/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Accession } from '../models/Accession';
import type { AccessionPATCH } from '../models/AccessionPATCH';
import type { AccessionPOST } from '../models/AccessionPOST';
import type { AccessionPrefix } from '../models/AccessionPrefix';
import type { AccessionWithCreatedCase } from '../models/AccessionWithCreatedCase';
import type { AdminCaseList } from '../models/AdminCaseList';
import type { AdminLabOrderList } from '../models/AdminLabOrderList';
import type { AdminLabOrderPrintLog } from '../models/AdminLabOrderPrintLog';
import type { AIRelease } from '../models/AIRelease';
import type { AntibodySpecies } from '../models/AntibodySpecies';
import type { AntigenRetrievalMethod } from '../models/AntigenRetrievalMethod';
import type { Block } from '../models/Block';
import type { BlockPOST } from '../models/BlockPOST';
import type { Case } from '../models/Case';
import type { CaseAdmin } from '../models/CaseAdmin';
import type { CaseBulkPOST } from '../models/CaseBulkPOST';
import type { CaseDiagnosis } from '../models/CaseDiagnosis';
import type { CaseDiagnosisAddonWritable } from '../models/CaseDiagnosisAddonWritable';
import type { CaseDisclaimerPreview } from '../models/CaseDisclaimerPreview';
import type { CaseDocumentAdmin } from '../models/CaseDocumentAdmin';
import type { CaseDocumentAdminDetail } from '../models/CaseDocumentAdminDetail';
import type { CaseDocumentAdminWritable } from '../models/CaseDocumentAdminWritable';
import type { CaseDocumentWithPresignedUrl } from '../models/CaseDocumentWithPresignedUrl';
import type { CaseEMRDetails } from '../models/CaseEMRDetails';
import type { CaseEventLog } from '../models/CaseEventLog';
import type { CaseMatches } from '../models/CaseMatches';
import type { CasePATCH } from '../models/CasePATCH';
import type { CaseQAReview } from '../models/CaseQAReview';
import type { CaseReport } from '../models/CaseReport';
import type { CaseReportDocumentWritable } from '../models/CaseReportDocumentWritable';
import type { CaseReportSignature } from '../models/CaseReportSignature';
import type { Cases } from '../models/Cases';
import type { CasesWithDocumentView } from '../models/CasesWithDocumentView';
import type { CassettePrinter } from '../models/CassettePrinter';
import type { CliaCertificate } from '../models/CliaCertificate';
import type { Clinic } from '../models/Clinic';
import type { ClinicGroup } from '../models/ClinicGroup';
import type { Clinics } from '../models/Clinics';
import type { CptCode } from '../models/CptCode';
import type { FrontLoaderAccessionPrefix } from '../models/FrontLoaderAccessionPrefix';
import type { FrontLoaderClinic } from '../models/FrontLoaderClinic';
import type { FrontLoaderLab } from '../models/FrontLoaderLab';
import type { FrontLoaderLabStation } from '../models/FrontLoaderLabStation';
import type { Icd10Code } from '../models/Icd10Code';
import type { Icd10CodeSite } from '../models/Icd10CodeSite';
import type { Icd10SiteSpecificCodeThrough } from '../models/Icd10SiteSpecificCodeThrough';
import type { InsurancePlan } from '../models/InsurancePlan';
import type { Lab } from '../models/Lab';
import type { LabOrder } from '../models/LabOrder';
import type { LabOrderPOST } from '../models/LabOrderPOST';
import type { LabPanel } from '../models/LabPanel';
import type { LabStainList } from '../models/LabStainList';
import type { LabStation } from '../models/LabStation';
import type { LISCase } from '../models/LISCase';
import type { LISCaseList } from '../models/LISCaseList';
import type { LISEvent } from '../models/LISEvent';
import type { LISPrintMultipleRequest } from '../models/LISPrintMultipleRequest';
import type { LISPrintRequest } from '../models/LISPrintRequest';
import type { LISScanRequest } from '../models/LISScanRequest';
import type { LISWork } from '../models/LISWork';
import type { Location } from '../models/Location';
import type { MacroCode } from '../models/MacroCode';
import type { MaintenanceMessage } from '../models/MaintenanceMessage';
import type { MFALoginSend } from '../models/MFALoginSend';
import type { MFASend } from '../models/MFASend';
import type { MFAVerify } from '../models/MFAVerify';
import type { MRMCAssessment } from '../models/MRMCAssessment';
import type { PasswordChange } from '../models/PasswordChange';
import type { PasswordReset } from '../models/PasswordReset';
import type { PasswordResetConfirm } from '../models/PasswordResetConfirm';
import type { Patient } from '../models/Patient';
import type { PatientFullInsurance } from '../models/PatientFullInsurance';
import type { PatientGuarantor } from '../models/PatientGuarantor';
import type { PatientGuarantorWritable } from '../models/PatientGuarantorWritable';
import type { PatientInsurance } from '../models/PatientInsurance';
import type { PWTokenObtainPair } from '../models/PWTokenObtainPair';
import type { PWTokenRefresh } from '../models/PWTokenRefresh';
import type { PWTokenRefreshPair } from '../models/PWTokenRefreshPair';
import type { QRAuthObtainPair } from '../models/QRAuthObtainPair';
import type { QRAuthToken } from '../models/QRAuthToken';
import type { QRAuthTokenPATCH } from '../models/QRAuthTokenPATCH';
import type { QRAuthTokenPOST } from '../models/QRAuthTokenPOST';
import type { RescanRequest } from '../models/RescanRequest';
import type { Rule } from '../models/Rule';
import type { S3Slide } from '../models/S3Slide';
import type { ScanningLog } from '../models/ScanningLog';
import type { Shipment } from '../models/Shipment';
import type { ShipmentWritable } from '../models/ShipmentWritable';
import type { Slide } from '../models/Slide';
import type { SlideAdmin } from '../models/SlideAdmin';
import type { SlideAdminList } from '../models/SlideAdminList';
import type { SlideAdminPATCH } from '../models/SlideAdminPATCH';
import type { SlideAnnotation } from '../models/SlideAnnotation';
import type { SlideClassification } from '../models/SlideClassification';
import type { SlideFlag } from '../models/SlideFlag';
import type { SlideFlagPOST } from '../models/SlideFlagPOST';
import type { SlidePOST } from '../models/SlidePOST';
import type { SonicPractice } from '../models/SonicPractice';
import type { Specimen } from '../models/Specimen';
import type { SpecimenAdmin } from '../models/SpecimenAdmin';
import type { SpecimenPATCH } from '../models/SpecimenPATCH';
import type { SpecimenPOST } from '../models/SpecimenPOST';
import type { Stain } from '../models/Stain';
import type { TokenVerify } from '../models/TokenVerify';
import type { UploaderClient } from '../models/UploaderClient';
import type { User } from '../models/User';
import type { UserList } from '../models/UserList';
import type { UserSupportDocumentList } from '../models/UserSupportDocumentList';
import type { UserSupportDocumentRetrieve } from '../models/UserSupportDocumentRetrieve';
import type { ZsdCode } from '../models/ZsdCode';
import { request as __request } from '../core/request';
import { CaseDataEntry } from 'models/CaseDataEntry';

export class ApiService {

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminBlocks({
        limit,
        offset,
        labStationType,
        labStationLabName,
        lisState,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unprocessed' | 'racked' | 'processed' | 'cooling' | 'embedded',
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Block>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/blocks/`,
            query: {
                'limit': limit,
                'offset': offset,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
            },
        });
        return result.body;
    }

    /**
     * @returns BlockPOST
     * @throws ApiError
     */
    public static async createAdminBlock({
        requestBody,
    }: {
        requestBody?: BlockPOST,
    }): Promise<BlockPOST> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/blocks/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Block
     * @throws ApiError
     */
    public static async retrieveAdminBlock({
        id,
        labStationType,
        labStationLabName,
        lisState,
    }: {
        /** A unique integer value identifying this block. **/
        id: number,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unprocessed' | 'racked' | 'processed' | 'cooling' | 'embedded',
    }): Promise<Block> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/blocks/${id}/`,
            query: {
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
            },
        });
        return result.body;
    }

    /**
     * @returns Block
     * @throws ApiError
     */
    public static async updateAdminBlock({
        id,
        labStationType,
        labStationLabName,
        lisState,
        requestBody,
    }: {
        /** A unique integer value identifying this block. **/
        id: number,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unprocessed' | 'racked' | 'processed' | 'cooling' | 'embedded',
        requestBody?: Block,
    }): Promise<Block> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/blocks/${id}/`,
            query: {
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Block
     * @throws ApiError
     */
    public static async partialUpdateAdminBlock({
        id,
        labStationType,
        labStationLabName,
        lisState,
        requestBody,
    }: {
        /** A unique integer value identifying this block. **/
        id: number,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unprocessed' | 'racked' | 'processed' | 'cooling' | 'embedded',
        requestBody?: Block,
    }): Promise<Block> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/blocks/${id}/`,
            query: {
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyAdminBlock({
        id,
        labStationType,
        labStationLabName,
        lisState,
    }: {
        /** A unique integer value identifying this block. **/
        id: number,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unprocessed' | 'racked' | 'processed' | 'cooling' | 'embedded',
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/admin/blocks/${id}/`,
            query: {
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminSlides({
        limit,
        offset,
        accessionNumber,
        labName,
        name,
        status,
        clinicName,
        casePriority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        uuid,
        qcStatus,
        hasQcNotes,
        expectedUploadByAfter,
        expectedUploadByBefore,
        caseOrderingDoctorName,
        isLoose,
        hasMismatchedAccession,
        qualityErrors,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** accession_number **/
        accessionNumber?: string,
        /** lab__name **/
        labName?: string,
        /** name **/
        name?: string,
        /** status **/
        status?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** clinic__name **/
        clinicName?: string,
        /** case__priority **/
        casePriority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** uuid **/
        uuid?: string,
        /** qc_status **/
        qcStatus?: 'checked' | 'blurry' | 'contact-lab' | 'missing-lab' | 'missing-viewer' | 'mislabeled' | 'unknown',
        /** has_qc_notes **/
        hasQcNotes?: string,
        /** expected_upload_by_after **/
        expectedUploadByAfter?: string,
        /** expected_upload_by_before **/
        expectedUploadByBefore?: string,
        /** case_ordering_doctor_name **/
        caseOrderingDoctorName?: string,
        /** is_loose **/
        isLoose?: string,
        /** has_mismatched_accession **/
        hasMismatchedAccession?: string,
        /** quality_errors **/
        qualityErrors?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<SlideAdminList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/slides/`,
            query: {
                'limit': limit,
                'offset': offset,
                'accession_number': accessionNumber,
                'lab__name': labName,
                'name': name,
                'status': status,
                'clinic__name': clinicName,
                'case__priority': casePriority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'uuid': uuid,
                'qc_status': qcStatus,
                'has_qc_notes': hasQcNotes,
                'expected_upload_by_after': expectedUploadByAfter,
                'expected_upload_by_before': expectedUploadByBefore,
                'case_ordering_doctor_name': caseOrderingDoctorName,
                'is_loose': isLoose,
                'has_mismatched_accession': hasMismatchedAccession,
                'quality_errors': qualityErrors,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns SlideAdmin
     * @throws ApiError
     */
    public static async createAdminSlide({
        requestBody,
    }: {
        requestBody?: SlideAdmin,
    }): Promise<SlideAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/slides/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Generic count endpoint, potentially open ended for additional future asks.
     * @returns SlideAdmin
     * @throws ApiError
     */
    public static async countAdminSlide(): Promise<SlideAdmin> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/slides/count/`,
        });
        return result.body;
    }

    /**
     * @returns SlideAdmin
     * @throws ApiError
     */
    public static async retrieveAdminSlide({
        id,
        accessionNumber,
        labName,
        name,
        status,
        clinicName,
        casePriority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        uuid,
        qcStatus,
        hasQcNotes,
        expectedUploadByAfter,
        expectedUploadByBefore,
        caseOrderingDoctorName,
        isLoose,
        hasMismatchedAccession,
        qualityErrors,
        ordering,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        /** accession_number **/
        accessionNumber?: string,
        /** lab__name **/
        labName?: string,
        /** name **/
        name?: string,
        /** status **/
        status?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** clinic__name **/
        clinicName?: string,
        /** case__priority **/
        casePriority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** uuid **/
        uuid?: string,
        /** qc_status **/
        qcStatus?: 'checked' | 'blurry' | 'contact-lab' | 'missing-lab' | 'missing-viewer' | 'mislabeled' | 'unknown',
        /** has_qc_notes **/
        hasQcNotes?: string,
        /** expected_upload_by_after **/
        expectedUploadByAfter?: string,
        /** expected_upload_by_before **/
        expectedUploadByBefore?: string,
        /** case_ordering_doctor_name **/
        caseOrderingDoctorName?: string,
        /** is_loose **/
        isLoose?: string,
        /** has_mismatched_accession **/
        hasMismatchedAccession?: string,
        /** quality_errors **/
        qualityErrors?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<SlideAdmin> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/slides/${id}/`,
            query: {
                'accession_number': accessionNumber,
                'lab__name': labName,
                'name': name,
                'status': status,
                'clinic__name': clinicName,
                'case__priority': casePriority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'uuid': uuid,
                'qc_status': qcStatus,
                'has_qc_notes': hasQcNotes,
                'expected_upload_by_after': expectedUploadByAfter,
                'expected_upload_by_before': expectedUploadByBefore,
                'case_ordering_doctor_name': caseOrderingDoctorName,
                'is_loose': isLoose,
                'has_mismatched_accession': hasMismatchedAccession,
                'quality_errors': qualityErrors,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns SlideAdmin
     * @throws ApiError
     */
    public static async updateAdminSlide({
        id,
        accessionNumber,
        labName,
        name,
        status,
        clinicName,
        casePriority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        uuid,
        qcStatus,
        hasQcNotes,
        expectedUploadByAfter,
        expectedUploadByBefore,
        caseOrderingDoctorName,
        isLoose,
        hasMismatchedAccession,
        qualityErrors,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        /** accession_number **/
        accessionNumber?: string,
        /** lab__name **/
        labName?: string,
        /** name **/
        name?: string,
        /** status **/
        status?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** clinic__name **/
        clinicName?: string,
        /** case__priority **/
        casePriority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** uuid **/
        uuid?: string,
        /** qc_status **/
        qcStatus?: 'checked' | 'blurry' | 'contact-lab' | 'missing-lab' | 'missing-viewer' | 'mislabeled' | 'unknown',
        /** has_qc_notes **/
        hasQcNotes?: string,
        /** expected_upload_by_after **/
        expectedUploadByAfter?: string,
        /** expected_upload_by_before **/
        expectedUploadByBefore?: string,
        /** case_ordering_doctor_name **/
        caseOrderingDoctorName?: string,
        /** is_loose **/
        isLoose?: string,
        /** has_mismatched_accession **/
        hasMismatchedAccession?: string,
        /** quality_errors **/
        qualityErrors?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: SlideAdmin,
    }): Promise<SlideAdmin> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/slides/${id}/`,
            query: {
                'accession_number': accessionNumber,
                'lab__name': labName,
                'name': name,
                'status': status,
                'clinic__name': clinicName,
                'case__priority': casePriority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'uuid': uuid,
                'qc_status': qcStatus,
                'has_qc_notes': hasQcNotes,
                'expected_upload_by_after': expectedUploadByAfter,
                'expected_upload_by_before': expectedUploadByBefore,
                'case_ordering_doctor_name': caseOrderingDoctorName,
                'is_loose': isLoose,
                'has_mismatched_accession': hasMismatchedAccession,
                'quality_errors': qualityErrors,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns SlideAdminPATCH
     * @throws ApiError
     */
    public static async partialUpdateAdminSlide({
        id,
        accessionNumber,
        labName,
        name,
        status,
        clinicName,
        casePriority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        uuid,
        qcStatus,
        hasQcNotes,
        expectedUploadByAfter,
        expectedUploadByBefore,
        caseOrderingDoctorName,
        isLoose,
        hasMismatchedAccession,
        qualityErrors,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        /** accession_number **/
        accessionNumber?: string,
        /** lab__name **/
        labName?: string,
        /** name **/
        name?: string,
        /** status **/
        status?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** clinic__name **/
        clinicName?: string,
        /** case__priority **/
        casePriority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** uuid **/
        uuid?: string,
        /** qc_status **/
        qcStatus?: 'checked' | 'blurry' | 'contact-lab' | 'missing-lab' | 'missing-viewer' | 'mislabeled' | 'unknown',
        /** has_qc_notes **/
        hasQcNotes?: string,
        /** expected_upload_by_after **/
        expectedUploadByAfter?: string,
        /** expected_upload_by_before **/
        expectedUploadByBefore?: string,
        /** case_ordering_doctor_name **/
        caseOrderingDoctorName?: string,
        /** is_loose **/
        isLoose?: string,
        /** has_mismatched_accession **/
        hasMismatchedAccession?: string,
        /** quality_errors **/
        qualityErrors?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: SlideAdminPATCH,
    }): Promise<SlideAdminPATCH> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/slides/${id}/`,
            query: {
                'accession_number': accessionNumber,
                'lab__name': labName,
                'name': name,
                'status': status,
                'clinic__name': clinicName,
                'case__priority': casePriority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'uuid': uuid,
                'qc_status': qcStatus,
                'has_qc_notes': hasQcNotes,
                'expected_upload_by_after': expectedUploadByAfter,
                'expected_upload_by_before': expectedUploadByBefore,
                'case_ordering_doctor_name': caseOrderingDoctorName,
                'is_loose': isLoose,
                'has_mismatched_accession': hasMismatchedAccession,
                'quality_errors': qualityErrors,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminCases({
        limit,
        offset,
        accession,
        accessionCompletedAfter,
        accessionCompletedBefore,
        accessioningLab,
        activeAssignmentEmail,
        activeAssignmentIsnull,
        activeAssignmentUsername,
        activeAssignmentName,
        billingType,
        collectedDateAfter,
        collectedDateBefore,
        createdAt,
        expectedNextStatusByRangeAfter,
        expectedNextStatusByRangeBefore,
        externalAccession,
        finalizedAtAfter,
        finalizedAtBefore,
        grossCompletedAfter,
        grossCompletedBefore,
        isDiagnostic,
        isManuallyAccessioned,
        lab,
        orderingDoctorName,
        priority,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        patientClinicId,
        patientClinicName,
        patientClinicClinicGroupName,
        patientClinicSonicPracticeName,
        patientDateOfBirth,
        patientName,
        receivedDateAfter,
        receivedDateBefore,
        reviewed,
        selfPay,
        signOutDateAfter,
        signOutDateBefore,
        slidesExpectedUploadByAfter,
        slidesExpectedUploadByBefore,
        slidesHasQcNotes,
        slidesLab,
        slidesQcStatus,
        slidesScannedDateAfter,
        slidesScannedDateBefore,
        slidesSlideReviewReason,
        slidesSpecimenBiopsyType,
        slidesSpecimenProcedure,
        slidesSpecimenSource,
        specimensBiopsyType,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        specimensClinicalHistory,
        slidesStainName,
        slidesStatus,
        source,
        status,
        updatedAt,
        unviewed,
        sonicPracticeId,
        sonicPracticeName,
        activeAssignmentId,
        billerName,
        finalizingSignatureId,
        grossedByCert,
        hasFinalizingSignature,
        hasOnlySpecialStains,
        isEmpty,
        patientClinicLocationState,
        patientClinicClinicGroupId,
        patientClinicSonicPracticeId,
        patientInsuranceInsuranceCompanyName,
        patientAddressState,
        qaReviewHold,
        dataEntry,
        billingEntry,
        type,
        clinicNumber,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** accession **/
        accession?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__isnull **/
        activeAssignmentIsnull?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** billing_type **/
        billingType?: 'global' | 'client' | 'none',
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** created_at **/
        createdAt?: string,
        /** expected_next_status_by_range_after **/
        expectedNextStatusByRangeAfter?: string,
        /** expected_next_status_by_range_before **/
        expectedNextStatusByRangeBefore?: string,
        /** external_accession **/
        externalAccession?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** is_diagnostic **/
        isDiagnostic?: string,
        /** is_manually_accessioned **/
        isManuallyAccessioned?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** patient__clinic__id **/
        patientClinicId?: number,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** patient__clinic__clinic_group__name **/
        patientClinicClinicGroupName?: string,
        /** patient__clinic__sonic_practice__name **/
        patientClinicSonicPracticeName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** patient_name **/
        patientName?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** reviewed **/
        reviewed?: string,
        /** self_pay **/
        selfPay?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** slides__expected_upload_by_after **/
        slidesExpectedUploadByAfter?: string,
        /** slides__expected_upload_by_before **/
        slidesExpectedUploadByBefore?: string,
        /** slides__has_qc_notes **/
        slidesHasQcNotes?: string,
        /** slides__lab **/
        slidesLab?: string,
        /** slides__qc_status **/
        slidesQcStatus?: 'checked' | 'blurry' | 'contact-lab' | 'missing-lab' | 'missing-viewer' | 'mislabeled' | 'unknown',
        /** slides__scanned_date_after **/
        slidesScannedDateAfter?: string,
        /** slides__scanned_date_before **/
        slidesScannedDateBefore?: string,
        /** slides__slide_review_reason **/
        slidesSlideReviewReason?: 'missing-case' | 'missing-ordering-doctor' | 'missing-active-assignment' | 'missing-accessioning-lab' | 'random-selection' | 'prefix-random-selection' | 'reimport-metadata-task' | 'missing-barcode' | 'slide-has-ihc-stain' | 'quality-issue-found' | 'auto-created-case' | 'missing-stain' | 'not-grossed',
        /** slides__specimen__biopsy_type **/
        slidesSpecimenBiopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** slides__specimen__procedure **/
        slidesSpecimenProcedure?: string,
        /** slides__specimen__source **/
        slidesSpecimenSource?: string,
        /** specimens__biopsy_type **/
        specimensBiopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** slides__stain__name **/
        slidesStainName?: string,
        /** slides__status **/
        slidesStatus?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** source **/
        source?: 'wpl' | 'pw' | 'apl',
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** updated_at **/
        updatedAt?: string,
        /** unviewed **/
        unviewed?: string,
        /** sonic_practice_id **/
        sonicPracticeId?: number,
        /** sonic_practice_name **/
        sonicPracticeName?: string,
        /** active_assignment__id **/
        activeAssignmentId?: number,
        /** biller_name **/
        billerName?: string,
        /** finalizing_signature__id **/
        finalizingSignatureId?: number,
        /** grossed_by_cert **/
        grossedByCert?: string,
        /** has_finalizing_signature **/
        hasFinalizingSignature?: string,
        /** has_only_special_stains **/
        hasOnlySpecialStains?: string,
        /** is_empty **/
        isEmpty?: string,
        /** patient__clinic__location__state **/
        patientClinicLocationState?: string,
        /** patient__clinic__clinic_group__id **/
        patientClinicClinicGroupId?: number,
        /** patient__clinic__sonic_practice__id **/
        patientClinicSonicPracticeId?: number,
        /** patient__insurance__insurance_company_name **/
        patientInsuranceInsuranceCompanyName?: string,
        /** patient__address__state **/
        patientAddressState?: string,
        /** qa_review_hold **/
        qaReviewHold?: 'reviewed' | 'unreviewed' | 'on-hold',
        /** data_entry **/
        dataEntry?: string,
        /** billing_entry **/
        billingEntry?: string,
        /** type **/
        type?: 'clinical' | 'test' | 'demo' | 'validation' | 'consult' | 'control' | 'tc-pc' | 'historical' | 'education' | 'non-diagnostic' | 'mohs-qc' | 'triage',
        /** clinic_number **/
        clinicNumber?: 'P-Number' | 'Other',
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<AdminCaseList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/cases/`,
            query: {
                'limit': limit,
                'offset': offset,
                'accession': accession,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'accessioning_lab': accessioningLab,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__isnull': activeAssignmentIsnull,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'billing_type': billingType,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'created_at': createdAt,
                'expected_next_status_by_range_after': expectedNextStatusByRangeAfter,
                'expected_next_status_by_range_before': expectedNextStatusByRangeBefore,
                'external_accession': externalAccession,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'is_diagnostic': isDiagnostic,
                'is_manually_accessioned': isManuallyAccessioned,
                'lab': lab,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'patient__clinic__id': patientClinicId,
                'patient__clinic__name': patientClinicName,
                'patient__clinic__clinic_group__name': patientClinicClinicGroupName,
                'patient__clinic__sonic_practice__name': patientClinicSonicPracticeName,
                'patient__date_of_birth': patientDateOfBirth,
                'patient_name': patientName,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'reviewed': reviewed,
                'self_pay': selfPay,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'slides__expected_upload_by_after': slidesExpectedUploadByAfter,
                'slides__expected_upload_by_before': slidesExpectedUploadByBefore,
                'slides__has_qc_notes': slidesHasQcNotes,
                'slides__lab': slidesLab,
                'slides__qc_status': slidesQcStatus,
                'slides__scanned_date_after': slidesScannedDateAfter,
                'slides__scanned_date_before': slidesScannedDateBefore,
                'slides__slide_review_reason': slidesSlideReviewReason,
                'slides__specimen__biopsy_type': slidesSpecimenBiopsyType,
                'slides__specimen__procedure': slidesSpecimenProcedure,
                'slides__specimen__source': slidesSpecimenSource,
                'specimens__biopsy_type': specimensBiopsyType,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'specimens__clinical_history': specimensClinicalHistory,
                'slides__stain__name': slidesStainName,
                'slides__status': slidesStatus,
                'source': source,
                'status': status,
                'updated_at': updatedAt,
                'unviewed': unviewed,
                'sonic_practice_id': sonicPracticeId,
                'sonic_practice_name': sonicPracticeName,
                'active_assignment__id': activeAssignmentId,
                'biller_name': billerName,
                'finalizing_signature__id': finalizingSignatureId,
                'grossed_by_cert': grossedByCert,
                'has_finalizing_signature': hasFinalizingSignature,
                'has_only_special_stains': hasOnlySpecialStains,
                'is_empty': isEmpty,
                'patient__clinic__location__state': patientClinicLocationState,
                'patient__clinic__clinic_group__id': patientClinicClinicGroupId,
                'patient__clinic__sonic_practice__id': patientClinicSonicPracticeId,
                'patient__insurance__insurance_company_name': patientInsuranceInsuranceCompanyName,
                'patient__address__state': patientAddressState,
                'qa_review_hold': qaReviewHold,
                'data_entry': dataEntry,
                'billing_entry': billingEntry,
                'type': type,
                'clinic_number': clinicNumber,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns CaseAdmin
     * @throws ApiError
     */
    public static async retrieveAdminCase({
        id,
        accession,
        accessionCompletedAfter,
        accessionCompletedBefore,
        accessioningLab,
        activeAssignmentEmail,
        activeAssignmentIsnull,
        activeAssignmentUsername,
        activeAssignmentName,
        billingType,
        collectedDateAfter,
        collectedDateBefore,
        createdAt,
        expectedNextStatusByRangeAfter,
        expectedNextStatusByRangeBefore,
        externalAccession,
        finalizedAtAfter,
        finalizedAtBefore,
        grossCompletedAfter,
        grossCompletedBefore,
        isDiagnostic,
        isManuallyAccessioned,
        lab,
        orderingDoctorName,
        priority,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        patientClinicId,
        patientClinicName,
        patientClinicClinicGroupName,
        patientClinicSonicPracticeName,
        patientDateOfBirth,
        patientName,
        receivedDateAfter,
        receivedDateBefore,
        reviewed,
        selfPay,
        signOutDateAfter,
        signOutDateBefore,
        slidesExpectedUploadByAfter,
        slidesExpectedUploadByBefore,
        slidesHasQcNotes,
        slidesLab,
        slidesQcStatus,
        slidesScannedDateAfter,
        slidesScannedDateBefore,
        slidesSlideReviewReason,
        slidesSpecimenBiopsyType,
        slidesSpecimenProcedure,
        slidesSpecimenSource,
        specimensBiopsyType,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        specimensClinicalHistory,
        slidesStainName,
        slidesStatus,
        source,
        status,
        updatedAt,
        unviewed,
        sonicPracticeId,
        sonicPracticeName,
        activeAssignmentId,
        billerName,
        finalizingSignatureId,
        grossedByCert,
        hasFinalizingSignature,
        hasOnlySpecialStains,
        isEmpty,
        patientClinicLocationState,
        patientClinicClinicGroupId,
        patientClinicSonicPracticeId,
        patientInsuranceInsuranceCompanyName,
        patientAddressState,
        qaReviewHold,
        dataEntry,
        billingEntry,
        type,
        clinicNumber,
        ordering,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        /** accession **/
        accession?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__isnull **/
        activeAssignmentIsnull?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** billing_type **/
        billingType?: 'global' | 'client' | 'none',
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** created_at **/
        createdAt?: string,
        /** expected_next_status_by_range_after **/
        expectedNextStatusByRangeAfter?: string,
        /** expected_next_status_by_range_before **/
        expectedNextStatusByRangeBefore?: string,
        /** external_accession **/
        externalAccession?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** is_diagnostic **/
        isDiagnostic?: string,
        /** is_manually_accessioned **/
        isManuallyAccessioned?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** patient__clinic__id **/
        patientClinicId?: number,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** patient__clinic__clinic_group__name **/
        patientClinicClinicGroupName?: string,
        /** patient__clinic__sonic_practice__name **/
        patientClinicSonicPracticeName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** patient_name **/
        patientName?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** reviewed **/
        reviewed?: string,
        /** self_pay **/
        selfPay?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** slides__expected_upload_by_after **/
        slidesExpectedUploadByAfter?: string,
        /** slides__expected_upload_by_before **/
        slidesExpectedUploadByBefore?: string,
        /** slides__has_qc_notes **/
        slidesHasQcNotes?: string,
        /** slides__lab **/
        slidesLab?: string,
        /** slides__qc_status **/
        slidesQcStatus?: 'checked' | 'blurry' | 'contact-lab' | 'missing-lab' | 'missing-viewer' | 'mislabeled' | 'unknown',
        /** slides__scanned_date_after **/
        slidesScannedDateAfter?: string,
        /** slides__scanned_date_before **/
        slidesScannedDateBefore?: string,
        /** slides__slide_review_reason **/
        slidesSlideReviewReason?: 'missing-case' | 'missing-ordering-doctor' | 'missing-active-assignment' | 'missing-accessioning-lab' | 'random-selection' | 'prefix-random-selection' | 'reimport-metadata-task' | 'missing-barcode' | 'slide-has-ihc-stain' | 'quality-issue-found' | 'auto-created-case' | 'missing-stain' | 'not-grossed',
        /** slides__specimen__biopsy_type **/
        slidesSpecimenBiopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** slides__specimen__procedure **/
        slidesSpecimenProcedure?: string,
        /** slides__specimen__source **/
        slidesSpecimenSource?: string,
        /** specimens__biopsy_type **/
        specimensBiopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** slides__stain__name **/
        slidesStainName?: string,
        /** slides__status **/
        slidesStatus?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** source **/
        source?: 'wpl' | 'pw' | 'apl',
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** updated_at **/
        updatedAt?: string,
        /** unviewed **/
        unviewed?: string,
        /** sonic_practice_id **/
        sonicPracticeId?: number,
        /** sonic_practice_name **/
        sonicPracticeName?: string,
        /** active_assignment__id **/
        activeAssignmentId?: number,
        /** biller_name **/
        billerName?: string,
        /** finalizing_signature__id **/
        finalizingSignatureId?: number,
        /** grossed_by_cert **/
        grossedByCert?: string,
        /** has_finalizing_signature **/
        hasFinalizingSignature?: string,
        /** has_only_special_stains **/
        hasOnlySpecialStains?: string,
        /** is_empty **/
        isEmpty?: string,
        /** patient__clinic__location__state **/
        patientClinicLocationState?: string,
        /** patient__clinic__clinic_group__id **/
        patientClinicClinicGroupId?: number,
        /** patient__clinic__sonic_practice__id **/
        patientClinicSonicPracticeId?: number,
        /** patient__insurance__insurance_company_name **/
        patientInsuranceInsuranceCompanyName?: string,
        /** patient__address__state **/
        patientAddressState?: string,
        /** qa_review_hold **/
        qaReviewHold?: 'reviewed' | 'unreviewed' | 'on-hold',
        /** data_entry **/
        dataEntry?: string,
        /** billing_entry **/
        billingEntry?: string,
        /** type **/
        type?: 'clinical' | 'test' | 'demo' | 'validation' | 'consult' | 'control' | 'tc-pc' | 'historical' | 'education' | 'non-diagnostic' | 'mohs-qc' | 'triage',
        /** clinic_number **/
        clinicNumber?: 'P-Number' | 'Other',
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<CaseAdmin> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/cases/${id}/`,
            query: {
                'accession': accession,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'accessioning_lab': accessioningLab,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__isnull': activeAssignmentIsnull,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'billing_type': billingType,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'created_at': createdAt,
                'expected_next_status_by_range_after': expectedNextStatusByRangeAfter,
                'expected_next_status_by_range_before': expectedNextStatusByRangeBefore,
                'external_accession': externalAccession,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'is_diagnostic': isDiagnostic,
                'is_manually_accessioned': isManuallyAccessioned,
                'lab': lab,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'patient__clinic__id': patientClinicId,
                'patient__clinic__name': patientClinicName,
                'patient__clinic__clinic_group__name': patientClinicClinicGroupName,
                'patient__clinic__sonic_practice__name': patientClinicSonicPracticeName,
                'patient__date_of_birth': patientDateOfBirth,
                'patient_name': patientName,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'reviewed': reviewed,
                'self_pay': selfPay,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'slides__expected_upload_by_after': slidesExpectedUploadByAfter,
                'slides__expected_upload_by_before': slidesExpectedUploadByBefore,
                'slides__has_qc_notes': slidesHasQcNotes,
                'slides__lab': slidesLab,
                'slides__qc_status': slidesQcStatus,
                'slides__scanned_date_after': slidesScannedDateAfter,
                'slides__scanned_date_before': slidesScannedDateBefore,
                'slides__slide_review_reason': slidesSlideReviewReason,
                'slides__specimen__biopsy_type': slidesSpecimenBiopsyType,
                'slides__specimen__procedure': slidesSpecimenProcedure,
                'slides__specimen__source': slidesSpecimenSource,
                'specimens__biopsy_type': specimensBiopsyType,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'specimens__clinical_history': specimensClinicalHistory,
                'slides__stain__name': slidesStainName,
                'slides__status': slidesStatus,
                'source': source,
                'status': status,
                'updated_at': updatedAt,
                'unviewed': unviewed,
                'sonic_practice_id': sonicPracticeId,
                'sonic_practice_name': sonicPracticeName,
                'active_assignment__id': activeAssignmentId,
                'biller_name': billerName,
                'finalizing_signature__id': finalizingSignatureId,
                'grossed_by_cert': grossedByCert,
                'has_finalizing_signature': hasFinalizingSignature,
                'has_only_special_stains': hasOnlySpecialStains,
                'is_empty': isEmpty,
                'patient__clinic__location__state': patientClinicLocationState,
                'patient__clinic__clinic_group__id': patientClinicClinicGroupId,
                'patient__clinic__sonic_practice__id': patientClinicSonicPracticeId,
                'patient__insurance__insurance_company_name': patientInsuranceInsuranceCompanyName,
                'patient__address__state': patientAddressState,
                'qa_review_hold': qaReviewHold,
                'data_entry': dataEntry,
                'billing_entry': billingEntry,
                'type': type,
                'clinic_number': clinicNumber,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns CaseAdmin
     * @throws ApiError
     */
    public static async updateAdminCase({
        id,
        accession,
        accessionCompletedAfter,
        accessionCompletedBefore,
        accessioningLab,
        activeAssignmentEmail,
        activeAssignmentIsnull,
        activeAssignmentUsername,
        activeAssignmentName,
        billingType,
        collectedDateAfter,
        collectedDateBefore,
        createdAt,
        expectedNextStatusByRangeAfter,
        expectedNextStatusByRangeBefore,
        externalAccession,
        finalizedAtAfter,
        finalizedAtBefore,
        grossCompletedAfter,
        grossCompletedBefore,
        isDiagnostic,
        isManuallyAccessioned,
        lab,
        orderingDoctorName,
        priority,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        patientClinicId,
        patientClinicName,
        patientClinicClinicGroupName,
        patientClinicSonicPracticeName,
        patientDateOfBirth,
        patientName,
        receivedDateAfter,
        receivedDateBefore,
        reviewed,
        selfPay,
        signOutDateAfter,
        signOutDateBefore,
        slidesExpectedUploadByAfter,
        slidesExpectedUploadByBefore,
        slidesHasQcNotes,
        slidesLab,
        slidesQcStatus,
        slidesScannedDateAfter,
        slidesScannedDateBefore,
        slidesSlideReviewReason,
        slidesSpecimenBiopsyType,
        slidesSpecimenProcedure,
        slidesSpecimenSource,
        specimensBiopsyType,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        specimensClinicalHistory,
        slidesStainName,
        slidesStatus,
        source,
        status,
        updatedAt,
        unviewed,
        sonicPracticeId,
        sonicPracticeName,
        activeAssignmentId,
        billerName,
        finalizingSignatureId,
        grossedByCert,
        hasFinalizingSignature,
        hasOnlySpecialStains,
        isEmpty,
        patientClinicLocationState,
        patientClinicClinicGroupId,
        patientClinicSonicPracticeId,
        patientInsuranceInsuranceCompanyName,
        patientAddressState,
        qaReviewHold,
        dataEntry,
        billingEntry,
        type,
        clinicNumber,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        /** accession **/
        accession?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__isnull **/
        activeAssignmentIsnull?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** billing_type **/
        billingType?: 'global' | 'client' | 'none',
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** created_at **/
        createdAt?: string,
        /** expected_next_status_by_range_after **/
        expectedNextStatusByRangeAfter?: string,
        /** expected_next_status_by_range_before **/
        expectedNextStatusByRangeBefore?: string,
        /** external_accession **/
        externalAccession?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** is_diagnostic **/
        isDiagnostic?: string,
        /** is_manually_accessioned **/
        isManuallyAccessioned?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** patient__clinic__id **/
        patientClinicId?: number,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** patient__clinic__clinic_group__name **/
        patientClinicClinicGroupName?: string,
        /** patient__clinic__sonic_practice__name **/
        patientClinicSonicPracticeName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** patient_name **/
        patientName?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** reviewed **/
        reviewed?: string,
        /** self_pay **/
        selfPay?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** slides__expected_upload_by_after **/
        slidesExpectedUploadByAfter?: string,
        /** slides__expected_upload_by_before **/
        slidesExpectedUploadByBefore?: string,
        /** slides__has_qc_notes **/
        slidesHasQcNotes?: string,
        /** slides__lab **/
        slidesLab?: string,
        /** slides__qc_status **/
        slidesQcStatus?: 'checked' | 'blurry' | 'contact-lab' | 'missing-lab' | 'missing-viewer' | 'mislabeled' | 'unknown',
        /** slides__scanned_date_after **/
        slidesScannedDateAfter?: string,
        /** slides__scanned_date_before **/
        slidesScannedDateBefore?: string,
        /** slides__slide_review_reason **/
        slidesSlideReviewReason?: 'missing-case' | 'missing-ordering-doctor' | 'missing-active-assignment' | 'missing-accessioning-lab' | 'random-selection' | 'prefix-random-selection' | 'reimport-metadata-task' | 'missing-barcode' | 'slide-has-ihc-stain' | 'quality-issue-found' | 'auto-created-case' | 'missing-stain' | 'not-grossed',
        /** slides__specimen__biopsy_type **/
        slidesSpecimenBiopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** slides__specimen__procedure **/
        slidesSpecimenProcedure?: string,
        /** slides__specimen__source **/
        slidesSpecimenSource?: string,
        /** specimens__biopsy_type **/
        specimensBiopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** slides__stain__name **/
        slidesStainName?: string,
        /** slides__status **/
        slidesStatus?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** source **/
        source?: 'wpl' | 'pw' | 'apl',
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** updated_at **/
        updatedAt?: string,
        /** unviewed **/
        unviewed?: string,
        /** sonic_practice_id **/
        sonicPracticeId?: number,
        /** sonic_practice_name **/
        sonicPracticeName?: string,
        /** active_assignment__id **/
        activeAssignmentId?: number,
        /** biller_name **/
        billerName?: string,
        /** finalizing_signature__id **/
        finalizingSignatureId?: number,
        /** grossed_by_cert **/
        grossedByCert?: string,
        /** has_finalizing_signature **/
        hasFinalizingSignature?: string,
        /** has_only_special_stains **/
        hasOnlySpecialStains?: string,
        /** is_empty **/
        isEmpty?: string,
        /** patient__clinic__location__state **/
        patientClinicLocationState?: string,
        /** patient__clinic__clinic_group__id **/
        patientClinicClinicGroupId?: number,
        /** patient__clinic__sonic_practice__id **/
        patientClinicSonicPracticeId?: number,
        /** patient__insurance__insurance_company_name **/
        patientInsuranceInsuranceCompanyName?: string,
        /** patient__address__state **/
        patientAddressState?: string,
        /** qa_review_hold **/
        qaReviewHold?: 'reviewed' | 'unreviewed' | 'on-hold',
        /** data_entry **/
        dataEntry?: string,
        /** billing_entry **/
        billingEntry?: string,
        /** type **/
        type?: 'clinical' | 'test' | 'demo' | 'validation' | 'consult' | 'control' | 'tc-pc' | 'historical' | 'education' | 'non-diagnostic' | 'mohs-qc' | 'triage',
        /** clinic_number **/
        clinicNumber?: 'P-Number' | 'Other',
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: CaseAdmin,
    }): Promise<CaseAdmin> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/cases/${id}/`,
            query: {
                'accession': accession,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'accessioning_lab': accessioningLab,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__isnull': activeAssignmentIsnull,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'billing_type': billingType,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'created_at': createdAt,
                'expected_next_status_by_range_after': expectedNextStatusByRangeAfter,
                'expected_next_status_by_range_before': expectedNextStatusByRangeBefore,
                'external_accession': externalAccession,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'is_diagnostic': isDiagnostic,
                'is_manually_accessioned': isManuallyAccessioned,
                'lab': lab,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'patient__clinic__id': patientClinicId,
                'patient__clinic__name': patientClinicName,
                'patient__clinic__clinic_group__name': patientClinicClinicGroupName,
                'patient__clinic__sonic_practice__name': patientClinicSonicPracticeName,
                'patient__date_of_birth': patientDateOfBirth,
                'patient_name': patientName,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'reviewed': reviewed,
                'self_pay': selfPay,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'slides__expected_upload_by_after': slidesExpectedUploadByAfter,
                'slides__expected_upload_by_before': slidesExpectedUploadByBefore,
                'slides__has_qc_notes': slidesHasQcNotes,
                'slides__lab': slidesLab,
                'slides__qc_status': slidesQcStatus,
                'slides__scanned_date_after': slidesScannedDateAfter,
                'slides__scanned_date_before': slidesScannedDateBefore,
                'slides__slide_review_reason': slidesSlideReviewReason,
                'slides__specimen__biopsy_type': slidesSpecimenBiopsyType,
                'slides__specimen__procedure': slidesSpecimenProcedure,
                'slides__specimen__source': slidesSpecimenSource,
                'specimens__biopsy_type': specimensBiopsyType,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'specimens__clinical_history': specimensClinicalHistory,
                'slides__stain__name': slidesStainName,
                'slides__status': slidesStatus,
                'source': source,
                'status': status,
                'updated_at': updatedAt,
                'unviewed': unviewed,
                'sonic_practice_id': sonicPracticeId,
                'sonic_practice_name': sonicPracticeName,
                'active_assignment__id': activeAssignmentId,
                'biller_name': billerName,
                'finalizing_signature__id': finalizingSignatureId,
                'grossed_by_cert': grossedByCert,
                'has_finalizing_signature': hasFinalizingSignature,
                'has_only_special_stains': hasOnlySpecialStains,
                'is_empty': isEmpty,
                'patient__clinic__location__state': patientClinicLocationState,
                'patient__clinic__clinic_group__id': patientClinicClinicGroupId,
                'patient__clinic__sonic_practice__id': patientClinicSonicPracticeId,
                'patient__insurance__insurance_company_name': patientInsuranceInsuranceCompanyName,
                'patient__address__state': patientAddressState,
                'qa_review_hold': qaReviewHold,
                'data_entry': dataEntry,
                'billing_entry': billingEntry,
                'type': type,
                'clinic_number': clinicNumber,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * cloned from PUT /api/cases/id/ for admin specific use
     * @returns CaseAdmin
     * @throws ApiError
     */
    public static async partialUpdateAdminCase({
        id,
        accession,
        accessionCompletedAfter,
        accessionCompletedBefore,
        accessioningLab,
        activeAssignmentEmail,
        activeAssignmentIsnull,
        activeAssignmentUsername,
        activeAssignmentName,
        billingType,
        collectedDateAfter,
        collectedDateBefore,
        createdAt,
        expectedNextStatusByRangeAfter,
        expectedNextStatusByRangeBefore,
        externalAccession,
        finalizedAtAfter,
        finalizedAtBefore,
        grossCompletedAfter,
        grossCompletedBefore,
        isDiagnostic,
        isManuallyAccessioned,
        lab,
        orderingDoctorName,
        priority,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        patientClinicId,
        patientClinicName,
        patientClinicClinicGroupName,
        patientClinicSonicPracticeName,
        patientDateOfBirth,
        patientName,
        receivedDateAfter,
        receivedDateBefore,
        reviewed,
        selfPay,
        signOutDateAfter,
        signOutDateBefore,
        slidesExpectedUploadByAfter,
        slidesExpectedUploadByBefore,
        slidesHasQcNotes,
        slidesLab,
        slidesQcStatus,
        slidesScannedDateAfter,
        slidesScannedDateBefore,
        slidesSlideReviewReason,
        slidesSpecimenBiopsyType,
        slidesSpecimenProcedure,
        slidesSpecimenSource,
        specimensBiopsyType,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        specimensClinicalHistory,
        slidesStainName,
        slidesStatus,
        source,
        status,
        updatedAt,
        unviewed,
        sonicPracticeId,
        sonicPracticeName,
        activeAssignmentId,
        billerName,
        finalizingSignatureId,
        grossedByCert,
        hasFinalizingSignature,
        hasOnlySpecialStains,
        isEmpty,
        patientClinicLocationState,
        patientClinicClinicGroupId,
        patientClinicSonicPracticeId,
        patientInsuranceInsuranceCompanyName,
        patientAddressState,
        qaReviewHold,
        dataEntry,
        billingEntry,
        type,
        clinicNumber,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        /** accession **/
        accession?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__isnull **/
        activeAssignmentIsnull?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** billing_type **/
        billingType?: 'global' | 'client' | 'none',
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** created_at **/
        createdAt?: string,
        /** expected_next_status_by_range_after **/
        expectedNextStatusByRangeAfter?: string,
        /** expected_next_status_by_range_before **/
        expectedNextStatusByRangeBefore?: string,
        /** external_accession **/
        externalAccession?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** is_diagnostic **/
        isDiagnostic?: string,
        /** is_manually_accessioned **/
        isManuallyAccessioned?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** patient__clinic__id **/
        patientClinicId?: number,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** patient__clinic__clinic_group__name **/
        patientClinicClinicGroupName?: string,
        /** patient__clinic__sonic_practice__name **/
        patientClinicSonicPracticeName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** patient_name **/
        patientName?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** reviewed **/
        reviewed?: string,
        /** self_pay **/
        selfPay?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** slides__expected_upload_by_after **/
        slidesExpectedUploadByAfter?: string,
        /** slides__expected_upload_by_before **/
        slidesExpectedUploadByBefore?: string,
        /** slides__has_qc_notes **/
        slidesHasQcNotes?: string,
        /** slides__lab **/
        slidesLab?: string,
        /** slides__qc_status **/
        slidesQcStatus?: 'checked' | 'blurry' | 'contact-lab' | 'missing-lab' | 'missing-viewer' | 'mislabeled' | 'unknown',
        /** slides__scanned_date_after **/
        slidesScannedDateAfter?: string,
        /** slides__scanned_date_before **/
        slidesScannedDateBefore?: string,
        /** slides__slide_review_reason **/
        slidesSlideReviewReason?: 'missing-case' | 'missing-ordering-doctor' | 'missing-active-assignment' | 'missing-accessioning-lab' | 'random-selection' | 'prefix-random-selection' | 'reimport-metadata-task' | 'missing-barcode' | 'slide-has-ihc-stain' | 'quality-issue-found' | 'auto-created-case' | 'missing-stain' | 'not-grossed',
        /** slides__specimen__biopsy_type **/
        slidesSpecimenBiopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** slides__specimen__procedure **/
        slidesSpecimenProcedure?: string,
        /** slides__specimen__source **/
        slidesSpecimenSource?: string,
        /** specimens__biopsy_type **/
        specimensBiopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** slides__stain__name **/
        slidesStainName?: string,
        /** slides__status **/
        slidesStatus?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** source **/
        source?: 'wpl' | 'pw' | 'apl',
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** updated_at **/
        updatedAt?: string,
        /** unviewed **/
        unviewed?: string,
        /** sonic_practice_id **/
        sonicPracticeId?: number,
        /** sonic_practice_name **/
        sonicPracticeName?: string,
        /** active_assignment__id **/
        activeAssignmentId?: number,
        /** biller_name **/
        billerName?: string,
        /** finalizing_signature__id **/
        finalizingSignatureId?: number,
        /** grossed_by_cert **/
        grossedByCert?: string,
        /** has_finalizing_signature **/
        hasFinalizingSignature?: string,
        /** has_only_special_stains **/
        hasOnlySpecialStains?: string,
        /** is_empty **/
        isEmpty?: string,
        /** patient__clinic__location__state **/
        patientClinicLocationState?: string,
        /** patient__clinic__clinic_group__id **/
        patientClinicClinicGroupId?: number,
        /** patient__clinic__sonic_practice__id **/
        patientClinicSonicPracticeId?: number,
        /** patient__insurance__insurance_company_name **/
        patientInsuranceInsuranceCompanyName?: string,
        /** patient__address__state **/
        patientAddressState?: string,
        /** qa_review_hold **/
        qaReviewHold?: 'reviewed' | 'unreviewed' | 'on-hold',
        /** data_entry **/
        dataEntry?: string,
        /** billing_entry **/
        billingEntry?: string,
        /** type **/
        type?: 'clinical' | 'test' | 'demo' | 'validation' | 'consult' | 'control' | 'tc-pc' | 'historical' | 'education' | 'non-diagnostic' | 'mohs-qc' | 'triage',
        /** clinic_number **/
        clinicNumber?: 'P-Number' | 'Other',
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: CaseAdmin,
    }): Promise<CaseAdmin> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/cases/${id}/`,
            query: {
                'accession': accession,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'accessioning_lab': accessioningLab,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__isnull': activeAssignmentIsnull,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'billing_type': billingType,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'created_at': createdAt,
                'expected_next_status_by_range_after': expectedNextStatusByRangeAfter,
                'expected_next_status_by_range_before': expectedNextStatusByRangeBefore,
                'external_accession': externalAccession,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'is_diagnostic': isDiagnostic,
                'is_manually_accessioned': isManuallyAccessioned,
                'lab': lab,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'patient__clinic__id': patientClinicId,
                'patient__clinic__name': patientClinicName,
                'patient__clinic__clinic_group__name': patientClinicClinicGroupName,
                'patient__clinic__sonic_practice__name': patientClinicSonicPracticeName,
                'patient__date_of_birth': patientDateOfBirth,
                'patient_name': patientName,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'reviewed': reviewed,
                'self_pay': selfPay,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'slides__expected_upload_by_after': slidesExpectedUploadByAfter,
                'slides__expected_upload_by_before': slidesExpectedUploadByBefore,
                'slides__has_qc_notes': slidesHasQcNotes,
                'slides__lab': slidesLab,
                'slides__qc_status': slidesQcStatus,
                'slides__scanned_date_after': slidesScannedDateAfter,
                'slides__scanned_date_before': slidesScannedDateBefore,
                'slides__slide_review_reason': slidesSlideReviewReason,
                'slides__specimen__biopsy_type': slidesSpecimenBiopsyType,
                'slides__specimen__procedure': slidesSpecimenProcedure,
                'slides__specimen__source': slidesSpecimenSource,
                'specimens__biopsy_type': specimensBiopsyType,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'specimens__clinical_history': specimensClinicalHistory,
                'slides__stain__name': slidesStainName,
                'slides__status': slidesStatus,
                'source': source,
                'status': status,
                'updated_at': updatedAt,
                'unviewed': unviewed,
                'sonic_practice_id': sonicPracticeId,
                'sonic_practice_name': sonicPracticeName,
                'active_assignment__id': activeAssignmentId,
                'biller_name': billerName,
                'finalizing_signature__id': finalizingSignatureId,
                'grossed_by_cert': grossedByCert,
                'has_finalizing_signature': hasFinalizingSignature,
                'has_only_special_stains': hasOnlySpecialStains,
                'is_empty': isEmpty,
                'patient__clinic__location__state': patientClinicLocationState,
                'patient__clinic__clinic_group__id': patientClinicClinicGroupId,
                'patient__clinic__sonic_practice__id': patientClinicSonicPracticeId,
                'patient__insurance__insurance_company_name': patientInsuranceInsuranceCompanyName,
                'patient__address__state': patientAddressState,
                'qa_review_hold': qaReviewHold,
                'data_entry': dataEntry,
                'billing_entry': billingEntry,
                'type': type,
                'clinic_number': clinicNumber,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseEMRDetails
     * @throws ApiError
     */
    public static async emrDetailsAdminCase({
        id,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<CaseEMRDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/cases/${id}/emr-details/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCliaCertificates({
        limit,
        offset,
        name,
        labName,
        labDirectorName,
        hasLab,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
        /** lab__name **/
        labName?: string,
        /** lab_director_name **/
        labDirectorName?: string,
        /** has_lab **/
        hasLab?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CliaCertificate>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/clia-certificates/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
                'lab__name': labName,
                'lab_director_name': labDirectorName,
                'has_lab': hasLab,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminCaseDocuments({
        limit,
        offset,
        caseAccession,
        category,
        status,
        createdAtAfter,
        createdAtBefore,
        updatedAtAfter,
        updatedAtBefore,
        isLoose,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** case__accession **/
        caseAccession?: string,
        /** category **/
        category?: 'Case-Report' | 'Unmerged-Case-Report' | 'Previous-Pathology-Report' | 'Preliminary-Report' | 'Unmerged-Preliminary-Report' | 'Clinic-Notes' | 'Consent-Form' | 'Consultation-Report' | 'Doc-Clinical' | 'Doc-Insurance' | 'DIF-Report' | 'Fish-Report' | 'Gross-Diagram' | 'Lab-Report' | 'Lab-Requisition' | 'Sendout-Requisition' | 'Molecular-Report' | 'Patient-Demographics' | 'Requisition-Form' | 'Loose-Document' | 'Material-Request' | 'Self-Pay-Attestation' | 'Indigent-Patient-Agreement-Notice' | 'IHC-Report' | 'Case-Correction-Request' | 'Consult-Letter' | 'Tick-Report' | 'Castle-Report' | 'ISH-Report' | 'Gross-Specimen-Photo' | 'Other',
        /** status **/
        status?: 'pending' | 'uploaded',
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** updated_at_after **/
        updatedAtAfter?: string,
        /** updated_at_before **/
        updatedAtBefore?: string,
        /** is_loose **/
        isLoose?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CaseDocumentAdmin>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/documents/`,
            query: {
                'limit': limit,
                'offset': offset,
                'case__accession': caseAccession,
                'category': category,
                'status': status,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'updated_at_after': updatedAtAfter,
                'updated_at_before': updatedAtBefore,
                'is_loose': isLoose,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns CaseDocumentAdminDetail
     * @throws ApiError
     */
    public static async retrieveAdminCaseDocument({
        id,
        caseAccession,
        category,
        status,
        createdAtAfter,
        createdAtBefore,
        updatedAtAfter,
        updatedAtBefore,
        isLoose,
        ordering,
    }: {
        /** A unique integer value identifying this case document. **/
        id: number,
        /** case__accession **/
        caseAccession?: string,
        /** category **/
        category?: 'Case-Report' | 'Unmerged-Case-Report' | 'Previous-Pathology-Report' | 'Preliminary-Report' | 'Unmerged-Preliminary-Report' | 'Clinic-Notes' | 'Consent-Form' | 'Consultation-Report' | 'Doc-Clinical' | 'Doc-Insurance' | 'DIF-Report' | 'Fish-Report' | 'Gross-Diagram' | 'Lab-Report' | 'Lab-Requisition' | 'Sendout-Requisition' | 'Molecular-Report' | 'Patient-Demographics' | 'Requisition-Form' | 'Loose-Document' | 'Material-Request' | 'Self-Pay-Attestation' | 'Indigent-Patient-Agreement-Notice' | 'IHC-Report' | 'Case-Correction-Request' | 'Consult-Letter' | 'Tick-Report' | 'Castle-Report' | 'ISH-Report' | 'Gross-Specimen-Photo' | 'Other',
        /** status **/
        status?: 'pending' | 'uploaded',
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** updated_at_after **/
        updatedAtAfter?: string,
        /** updated_at_before **/
        updatedAtBefore?: string,
        /** is_loose **/
        isLoose?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<CaseDocumentAdminDetail> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/documents/${id}/`,
            query: {
                'case__accession': caseAccession,
                'category': category,
                'status': status,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'updated_at_after': updatedAtAfter,
                'updated_at_before': updatedAtBefore,
                'is_loose': isLoose,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns CaseDocumentAdmin
     * @throws ApiError
     */
    public static async updateAdminCaseDocument({
        id,
        caseAccession,
        category,
        status,
        createdAtAfter,
        createdAtBefore,
        updatedAtAfter,
        updatedAtBefore,
        isLoose,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this case document. **/
        id: number,
        /** case__accession **/
        caseAccession?: string,
        /** category **/
        category?: 'Case-Report' | 'Unmerged-Case-Report' | 'Previous-Pathology-Report' | 'Preliminary-Report' | 'Unmerged-Preliminary-Report' | 'Clinic-Notes' | 'Consent-Form' | 'Consultation-Report' | 'Doc-Clinical' | 'Doc-Insurance' | 'DIF-Report' | 'Fish-Report' | 'Gross-Diagram' | 'Lab-Report' | 'Lab-Requisition' | 'Sendout-Requisition' | 'Molecular-Report' | 'Patient-Demographics' | 'Requisition-Form' | 'Loose-Document' | 'Material-Request' | 'Self-Pay-Attestation' | 'Indigent-Patient-Agreement-Notice' | 'IHC-Report' | 'Case-Correction-Request' | 'Consult-Letter' | 'Tick-Report' | 'Castle-Report' | 'ISH-Report' | 'Gross-Specimen-Photo' | 'Other',
        /** status **/
        status?: 'pending' | 'uploaded',
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** updated_at_after **/
        updatedAtAfter?: string,
        /** updated_at_before **/
        updatedAtBefore?: string,
        /** is_loose **/
        isLoose?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: CaseDocumentAdmin,
    }): Promise<CaseDocumentAdmin> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/documents/${id}/`,
            query: {
                'case__accession': caseAccession,
                'category': category,
                'status': status,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'updated_at_after': updatedAtAfter,
                'updated_at_before': updatedAtBefore,
                'is_loose': isLoose,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseDocumentAdminWritable
     * @throws ApiError
     */
    public static async partialUpdateAdminCaseDocument({
        id,
        caseAccession,
        category,
        status,
        createdAtAfter,
        createdAtBefore,
        updatedAtAfter,
        updatedAtBefore,
        isLoose,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this case document. **/
        id: number,
        /** case__accession **/
        caseAccession?: string,
        /** category **/
        category?: 'Case-Report' | 'Unmerged-Case-Report' | 'Previous-Pathology-Report' | 'Preliminary-Report' | 'Unmerged-Preliminary-Report' | 'Clinic-Notes' | 'Consent-Form' | 'Consultation-Report' | 'Doc-Clinical' | 'Doc-Insurance' | 'DIF-Report' | 'Fish-Report' | 'Gross-Diagram' | 'Lab-Report' | 'Lab-Requisition' | 'Sendout-Requisition' | 'Molecular-Report' | 'Patient-Demographics' | 'Requisition-Form' | 'Loose-Document' | 'Material-Request' | 'Self-Pay-Attestation' | 'Indigent-Patient-Agreement-Notice' | 'IHC-Report' | 'Case-Correction-Request' | 'Consult-Letter' | 'Tick-Report' | 'Castle-Report' | 'ISH-Report' | 'Gross-Specimen-Photo' | 'Other',
        /** status **/
        status?: 'pending' | 'uploaded',
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** updated_at_after **/
        updatedAtAfter?: string,
        /** updated_at_before **/
        updatedAtBefore?: string,
        /** is_loose **/
        isLoose?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: CaseDocumentAdminWritable,
    }): Promise<CaseDocumentAdminWritable> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/documents/${id}/`,
            query: {
                'case__accession': caseAccession,
                'category': category,
                'status': status,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'updated_at_after': updatedAtAfter,
                'updated_at_before': updatedAtBefore,
                'is_loose': isLoose,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyAdminCaseDocument({
        id,
        caseAccession,
        category,
        status,
        createdAtAfter,
        createdAtBefore,
        updatedAtAfter,
        updatedAtBefore,
        isLoose,
        ordering,
    }: {
        /** A unique integer value identifying this case document. **/
        id: number,
        /** case__accession **/
        caseAccession?: string,
        /** category **/
        category?: 'Case-Report' | 'Unmerged-Case-Report' | 'Previous-Pathology-Report' | 'Preliminary-Report' | 'Unmerged-Preliminary-Report' | 'Clinic-Notes' | 'Consent-Form' | 'Consultation-Report' | 'Doc-Clinical' | 'Doc-Insurance' | 'DIF-Report' | 'Fish-Report' | 'Gross-Diagram' | 'Lab-Report' | 'Lab-Requisition' | 'Sendout-Requisition' | 'Molecular-Report' | 'Patient-Demographics' | 'Requisition-Form' | 'Loose-Document' | 'Material-Request' | 'Self-Pay-Attestation' | 'Indigent-Patient-Agreement-Notice' | 'IHC-Report' | 'Case-Correction-Request' | 'Consult-Letter' | 'Tick-Report' | 'Castle-Report' | 'ISH-Report' | 'Gross-Specimen-Photo' | 'Other',
        /** status **/
        status?: 'pending' | 'uploaded',
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** updated_at_after **/
        updatedAtAfter?: string,
        /** updated_at_before **/
        updatedAtBefore?: string,
        /** is_loose **/
        isLoose?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/admin/documents/${id}/`,
            query: {
                'case__accession': caseAccession,
                'category': category,
                'status': status,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'updated_at_after': updatedAtAfter,
                'updated_at_before': updatedAtBefore,
                'is_loose': isLoose,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminSpecimen({
        limit,
        offset,
        caseId,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** case__id **/
        caseId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<SpecimenAdmin>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/specimen/`,
            query: {
                'limit': limit,
                'offset': offset,
                'case__id': caseId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns SpecimenAdmin
     * @throws ApiError
     */
    public static async createAdminSpecimen({
        requestBody,
    }: {
        requestBody?: SpecimenAdmin,
    }): Promise<SpecimenAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/specimen/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns SpecimenAdmin
     * @throws ApiError
     */
    public static async retrieveAdminSpecimen({
        id,
        caseId,
        ordering,
    }: {
        /** A unique integer value identifying this specimen. **/
        id: number,
        /** case__id **/
        caseId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<SpecimenAdmin> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/specimen/${id}/`,
            query: {
                'case__id': caseId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns SpecimenAdmin
     * @throws ApiError
     */
    public static async updateAdminSpecimen({
        id,
        caseId,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this specimen. **/
        id: number,
        /** case__id **/
        caseId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: SpecimenAdmin,
    }): Promise<SpecimenAdmin> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/specimen/${id}/`,
            query: {
                'case__id': caseId,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns SpecimenAdmin
     * @throws ApiError
     */
    public static async partialUpdateAdminSpecimen({
        id,
        caseId,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this specimen. **/
        id: number,
        /** case__id **/
        caseId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: SpecimenAdmin,
    }): Promise<SpecimenAdmin> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/specimen/${id}/`,
            query: {
                'case__id': caseId,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyAdminSpecimen({
        id,
        caseId,
        ordering,
    }: {
        /** A unique integer value identifying this specimen. **/
        id: number,
        /** case__id **/
        caseId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/admin/specimen/${id}/`,
            query: {
                'case__id': caseId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminPatients({
        limit,
        offset,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<PatientFullInsurance>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/patient/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns PatientFullInsurance
     * @throws ApiError
     */
    public static async createAdminPatient({
        requestBody,
    }: {
        requestBody?: PatientFullInsurance,
    }): Promise<PatientFullInsurance> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/patient/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns PatientFullInsurance
     * @throws ApiError
     */
    public static async retrieveAdminPatient({
        id,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
    }: {
        /** A unique integer value identifying this patient. **/
        id: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<PatientFullInsurance> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/patient/${id}/`,
            query: {
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns PatientFullInsurance
     * @throws ApiError
     */
    public static async updateAdminPatient({
        id,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this patient. **/
        id: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: PatientFullInsurance,
    }): Promise<PatientFullInsurance> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/patient/${id}/`,
            query: {
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * cloned from PUT /api/cases/id/ for admin specific use
     * @returns PatientFullInsurance
     * @throws ApiError
     */
    public static async partialUpdateAdminPatient({
        id,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this patient. **/
        id: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: PatientFullInsurance,
    }): Promise<PatientFullInsurance> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/patient/${id}/`,
            query: {
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listPatientGuarantors({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<PatientGuarantor>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/guarantor/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * Creates a new guarantor for a patient and if address is provided, creates a
     * new address for the guarantor
     * @returns PatientGuarantorWritable
     * @throws ApiError
     */
    public static async createPatientGuarantor({
        requestBody,
    }: {
        requestBody?: PatientGuarantorWritable,
    }): Promise<PatientGuarantorWritable> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/guarantor/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns PatientGuarantor
     * @throws ApiError
     */
    public static async retrievePatientGuarantor({
        id,
    }: {
        /** A unique integer value identifying this patient guarantor. **/
        id: number,
    }): Promise<PatientGuarantor> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/guarantor/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns PatientGuarantorWritable
     * @throws ApiError
     */
    public static async updatePatientGuarantor({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this patient guarantor. **/
        id: number,
        requestBody?: PatientGuarantorWritable,
    }): Promise<PatientGuarantorWritable> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/guarantor/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns PatientGuarantorWritable
     * @throws ApiError
     */
    public static async partialUpdatePatientGuarantor({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this patient guarantor. **/
        id: number,
        requestBody?: PatientGuarantorWritable,
    }): Promise<PatientGuarantorWritable> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/guarantor/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyPatientGuarantor({
        id,
    }: {
        /** A unique integer value identifying this patient guarantor. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/admin/guarantor/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminInsurances({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<PatientInsurance>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/insurance/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns PatientInsurance
     * @throws ApiError
     */
    public static async createAdminInsurance({
        requestBody,
    }: {
        requestBody?: PatientInsurance,
    }): Promise<PatientInsurance> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/insurance/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns PatientInsurance
     * @throws ApiError
     */
    public static async retrieveAdminInsurance({
        id,
    }: {
        /** A unique integer value identifying this patient insurance. **/
        id: number,
    }): Promise<PatientInsurance> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/insurance/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns PatientInsurance
     * @throws ApiError
     */
    public static async updateAdminInsurance({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this patient insurance. **/
        id: number,
        requestBody?: PatientInsurance,
    }): Promise<PatientInsurance> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/insurance/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns PatientInsurance
     * @throws ApiError
     */
    public static async partialUpdateAdminInsurance({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this patient insurance. **/
        id: number,
        requestBody?: PatientInsurance,
    }): Promise<PatientInsurance> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/insurance/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyAdminInsurance({
        id,
    }: {
        /** A unique integer value identifying this patient insurance. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/admin/insurance/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminInsurancePlans({
        limit,
        offset,
        payerName,
        payerLocationStreet,
        payerLocationZipcode,
        payerLocationStreet2,
        payerLocationCity,
        payerLocationState,
        searchTerm,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** payer_name **/
        payerName?: string,
        /** payer_location__street **/
        payerLocationStreet?: string,
        /** payer_location__zipcode **/
        payerLocationZipcode?: string,
        /** payer_location__street2 **/
        payerLocationStreet2?: string,
        /** payer_location__city **/
        payerLocationCity?: string,
        /** payer_location__state **/
        payerLocationState?: string,
        /** A generic search term to filter insurance plans by multiple fields. **/
        searchTerm?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<InsurancePlan>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/insurance-plans/`,
            query: {
                'limit': limit,
                'offset': offset,
                'payer_name': payerName,
                'payer_location__street': payerLocationStreet,
                'payer_location__zipcode': payerLocationZipcode,
                'payer_location__street2': payerLocationStreet2,
                'payer_location__city': payerLocationCity,
                'payer_location__state': payerLocationState,
                'search_term': searchTerm,
            },
        });
        return result.body;
    }

    /**
     * @returns InsurancePlan
     * @throws ApiError
     */
    public static async retrieveAdminInsurancePlan({
        id,
        payerName,
        payerLocationStreet,
        payerLocationZipcode,
        payerLocationStreet2,
        payerLocationCity,
        payerLocationState,
    }: {
        /** A unique integer value identifying this insurance plan. **/
        id: number,
        /** payer_name **/
        payerName?: string,
        /** payer_location__street **/
        payerLocationStreet?: string,
        /** payer_location__zipcode **/
        payerLocationZipcode?: string,
        /** payer_location__street2 **/
        payerLocationStreet2?: string,
        /** payer_location__city **/
        payerLocationCity?: string,
        /** payer_location__state **/
        payerLocationState?: string,
    }): Promise<InsurancePlan> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/insurance-plans/${id}/`,
            query: {
                'payer_name': payerName,
                'payer_location__street': payerLocationStreet,
                'payer_location__zipcode': payerLocationZipcode,
                'payer_location__street2': payerLocationStreet2,
                'payer_location__city': payerLocationCity,
                'payer_location__state': payerLocationState,
            },
        });
        return result.body;
    }

    /**
     * A temporary single-use ViewSet to provide a GET List Admin LabOrders endpoint for the QC Admin.
     * @returns any
     * @throws ApiError
     */
    public static async listAdminLabOrders({
        limit,
        offset,
        caseId,
        caseAccession,
        caseAccessioningLabName,
        casePriority,
        caseSource,
        createdAtAfter,
        createdAtBefore,
        completedAtAfter,
        completedAtBefore,
        sentAtAfter,
        sentAtBefore,
        cancelledAtAfter,
        cancelledAtBefore,
        user,
        type,
        labStainId,
        labStainStainId,
        labStainStainName,
        labStainStainCategory,
        isCompleted,
        isSent,
        isCancelled,
        isFlagged,
        includesNonRoutine,
        isPrinted,
        isSendout,
        incomingSendoutsLab,
        outgoingSendoutsLab,
        labStainExternalStainExternalLabName,
        isTatClinic,
        department,
        orderingDoctorName,
        includeRoutine,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** case__id **/
        caseId?: number,
        /** case__accession **/
        caseAccession?: string,
        /** case__accessioning_lab__name **/
        caseAccessioningLabName?: string,
        /** case__priority **/
        casePriority?: string,
        /** case__source **/
        caseSource?: string,
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** completed_at_after **/
        completedAtAfter?: string,
        /** completed_at_before **/
        completedAtBefore?: string,
        /** sent_at_after **/
        sentAtAfter?: string,
        /** sent_at_before **/
        sentAtBefore?: string,
        /** cancelled_at_after **/
        cancelledAtAfter?: string,
        /** cancelled_at_before **/
        cancelledAtBefore?: string,
        /** user **/
        user?: string,
        /** type **/
        type?: string,
        /** lab_stain__id **/
        labStainId?: number,
        /** lab_stain__stain__id **/
        labStainStainId?: number,
        /** lab_stain__stain__name **/
        labStainStainName?: string,
        /** Stain Category **/
        labStainStainCategory?: string,
        /** is_completed **/
        isCompleted?: string,
        /** is_sent **/
        isSent?: string,
        /** is_cancelled **/
        isCancelled?: string,
        /** is_flagged **/
        isFlagged?: string,
        /** includes_non_routine **/
        includesNonRoutine?: string,
        /** Printed **/
        isPrinted?: string,
        /** Sendout **/
        isSendout?: string,
        /** Incoming Sendouts Lab **/
        incomingSendoutsLab?: string,
        /** Outgoing Sendouts Lab **/
        outgoingSendoutsLab?: string,
        /** lab_stain__external_stain__external_lab__name **/
        labStainExternalStainExternalLabName?: string,
        /** TAT Clinic **/
        isTatClinic?: string,
        /** department **/
        department?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Include Routine **/
        includeRoutine?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<AdminLabOrderList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/lab-orders/`,
            query: {
                'limit': limit,
                'offset': offset,
                'case__id': caseId,
                'case__accession': caseAccession,
                'case__accessioning_lab__name': caseAccessioningLabName,
                'case__priority': casePriority,
                'case__source': caseSource,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'completed_at_after': completedAtAfter,
                'completed_at_before': completedAtBefore,
                'sent_at_after': sentAtAfter,
                'sent_at_before': sentAtBefore,
                'cancelled_at_after': cancelledAtAfter,
                'cancelled_at_before': cancelledAtBefore,
                'user': user,
                'type': type,
                'lab_stain__id': labStainId,
                'lab_stain__stain__id': labStainStainId,
                'lab_stain__stain__name': labStainStainName,
                'lab_stain__stain__category': labStainStainCategory,
                'is_completed': isCompleted,
                'is_sent': isSent,
                'is_cancelled': isCancelled,
                'is_flagged': isFlagged,
                'includes_non_routine': includesNonRoutine,
                'is_printed': isPrinted,
                'is_sendout': isSendout,
                'incoming_sendouts_lab': incomingSendoutsLab,
                'outgoing_sendouts_lab': outgoingSendoutsLab,
                'lab_stain__external_stain__external_lab__name': labStainExternalStainExternalLabName,
                'is_tat_clinic': isTatClinic,
                'department': department,
                'ordering_doctor_name': orderingDoctorName,
                'include_routine': includeRoutine,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * API endpoint that allows users to be viewed or edited.
     * @returns any
     * @throws ApiError
     */
    public static async listUsers({
        limit,
        offset,
        name,
        username,
        email,
        userprofileNpi,
        userprofileUserType,
        clinicId,
        labId,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
        /** username **/
        username?: string,
        /** email **/
        email?: string,
        /** userprofile__npi **/
        userprofileNpi?: string,
        /** userprofile__user_type **/
        userprofileUserType?: 'dermpath' | 'physician' | 'lab_admin' | 'clinic_admin' | 'demo' | 'admin' | 'unknown' | 'MRMC2021',
        /** clinic_id **/
        clinicId?: number,
        /** lab_id **/
        labId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<UserList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/users/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
                'username': username,
                'email': email,
                'userprofile__npi': userprofileNpi,
                'userprofile__user_type': userprofileUserType,
                'clinic_id': clinicId,
                'lab_id': labId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * API endpoint that allows users to be viewed or edited.
     * @returns User
     * @throws ApiError
     */
    public static async meUser(): Promise<User> {
        const result = await __request({
            method: 'GET',
            path: `/api/users/me/`,
        });
        return result.body;
    }

    /**
     * API endpoint that allows users to be viewed or edited.
     * @returns User
     * @throws ApiError
     */
    public static async retrieveUser({
        id,
        name,
        username,
        email,
        userprofileNpi,
        userprofileUserType,
        clinicId,
        labId,
        ordering,
    }: {
        /** A unique integer value identifying this user. **/
        id: number,
        /** name **/
        name?: string,
        /** username **/
        username?: string,
        /** email **/
        email?: string,
        /** userprofile__npi **/
        userprofileNpi?: string,
        /** userprofile__user_type **/
        userprofileUserType?: 'dermpath' | 'physician' | 'lab_admin' | 'clinic_admin' | 'demo' | 'admin' | 'unknown' | 'MRMC2021',
        /** clinic_id **/
        clinicId?: number,
        /** lab_id **/
        labId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<User> {
        const result = await __request({
            method: 'GET',
            path: `/api/users/${id}/`,
            query: {
                'name': name,
                'username': username,
                'email': email,
                'userprofile__npi': userprofileNpi,
                'userprofile__user_type': userprofileUserType,
                'clinic_id': clinicId,
                'lab_id': labId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * API endpoint that allows users to be viewed or edited.
     * @returns User
     * @throws ApiError
     */
    public static async updateUser({
        id,
        name,
        username,
        email,
        userprofileNpi,
        userprofileUserType,
        clinicId,
        labId,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this user. **/
        id: number,
        /** name **/
        name?: string,
        /** username **/
        username?: string,
        /** email **/
        email?: string,
        /** userprofile__npi **/
        userprofileNpi?: string,
        /** userprofile__user_type **/
        userprofileUserType?: 'dermpath' | 'physician' | 'lab_admin' | 'clinic_admin' | 'demo' | 'admin' | 'unknown' | 'MRMC2021',
        /** clinic_id **/
        clinicId?: number,
        /** lab_id **/
        labId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: User,
    }): Promise<User> {
        const result = await __request({
            method: 'PUT',
            path: `/api/users/${id}/`,
            query: {
                'name': name,
                'username': username,
                'email': email,
                'userprofile__npi': userprofileNpi,
                'userprofile__user_type': userprofileUserType,
                'clinic_id': clinicId,
                'lab_id': labId,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * API endpoint that allows users to be viewed or edited.
     * @returns User
     * @throws ApiError
     */
    public static async partialUpdateUser({
        id,
        name,
        username,
        email,
        userprofileNpi,
        userprofileUserType,
        clinicId,
        labId,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this user. **/
        id: number,
        /** name **/
        name?: string,
        /** username **/
        username?: string,
        /** email **/
        email?: string,
        /** userprofile__npi **/
        userprofileNpi?: string,
        /** userprofile__user_type **/
        userprofileUserType?: 'dermpath' | 'physician' | 'lab_admin' | 'clinic_admin' | 'demo' | 'admin' | 'unknown' | 'MRMC2021',
        /** clinic_id **/
        clinicId?: number,
        /** lab_id **/
        labId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: User,
    }): Promise<User> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/users/${id}/`,
            query: {
                'name': name,
                'username': username,
                'email': email,
                'userprofile__npi': userprofileNpi,
                'userprofile__user_type': userprofileUserType,
                'clinic_id': clinicId,
                'lab_id': labId,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * API endpoint that allows users to be viewed or edited.
     * @returns User
     * @throws ApiError
     */
    public static async signaturesUser({
        id,
    }: {
        /** A unique integer value identifying this user. **/
        id: number,
    }): Promise<User> {
        const result = await __request({
            method: 'GET',
            path: `/api/users/${id}/signatures/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAiReleases({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<AIRelease>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/ai-releases/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * Should be removed after AI v2023-05-11-0236 is deployed and story-8882 is implemented.
     * This class has been created to ensure backward compatibility with AI versions prior to v2023-05-11-0236.
     * @returns any
     * @throws ApiError
     */
    public static async listSlideClassifications({
        limit,
        offset,
        slide,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** slide **/
        slide?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<SlideClassification>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/slide-classifications/`,
            query: {
                'limit': limit,
                'offset': offset,
                'slide': slide,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * Should be removed after AI v2023-05-11-0236 is deployed and story-8882 is implemented.
     * This class has been created to ensure backward compatibility with AI versions prior to v2023-05-11-0236.
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async disclaimerSlideClassification(): Promise<SlideClassification> {
        const result = await __request({
            method: 'GET',
            path: `/api/slide-classifications/disclaimer/`,
        });
        return result.body;
    }

    /**
     * Should be removed after AI v2023-05-11-0236 is deployed and story-8882 is implemented.
     * This class has been created to ensure backward compatibility with AI versions prior to v2023-05-11-0236.
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async retrieveSlideClassification({
        id,
        slide,
        ordering,
    }: {
        /** A unique integer value identifying this slide classification. **/
        id: number,
        /** slide **/
        slide?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<SlideClassification> {
        const result = await __request({
            method: 'GET',
            path: `/api/slide-classifications/${id}/`,
            query: {
                'slide': slide,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listSlideClassifications1({
        limit,
        offset,
        slide,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** slide **/
        slide?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<SlideClassification>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/slide-classifications/`,
            query: {
                'limit': limit,
                'offset': offset,
                'slide': slide,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async disclaimerSlideClassification1(): Promise<SlideClassification> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/slide-classifications/disclaimer/`,
        });
        return result.body;
    }

    /**
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async retrieveSlideClassification1({
        id,
        slide,
        ordering,
    }: {
        /** A unique integer value identifying this slide classification. **/
        id: number,
        /** slide **/
        slide?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<SlideClassification> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/slide-classifications/${id}/`,
            query: {
                'slide': slide,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCptCodes({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CptCode>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/cpt-codes/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listZsdCodes({
        limit,
        offset,
        code,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** code **/
        code?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<ZsdCode>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/zsd-codes/`,
            query: {
                'limit': limit,
                'offset': offset,
                'code': code,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listIcd10Codes({
        limit,
        offset,
        description,
        code,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** description **/
        description?: string,
        /** code **/
        code?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Icd10Code>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/icd10-codes/`,
            query: {
                'limit': limit,
                'offset': offset,
                'description': description,
                'code': code,
            },
        });
        return result.body;
    }

    /**
     * Used for the frontend to obtain all site-specific codes,
     * against NOS codes.
     * Also returns `Icd10CodeSite` to avoid a separate resource call,
     * so the single payload package to avoid repetitive list behaviour
     * @returns any
     * @throws ApiError
     */
    public static async siteSpecificIcd10Code(): Promise<{
        codes?: Array<Icd10SiteSpecificCodeThrough>,
        sites?: Array<Icd10CodeSite>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/icd10-codes/site_specific/`,
        });
        return result.body;
    }

    /**
     * This is a dead-end endpoint to include the Icd10SiteSpecificCodeThrough model in schema
     * @returns Icd10SiteSpecificCodeThrough
     * @throws ApiError
     */
    public static async retrieveIcd10SiteSpecificCodeThrough({
        id,
    }: {
        /** A unique integer value identifying this icd10 site specific code through. **/
        id: number,
    }): Promise<Icd10SiteSpecificCodeThrough> {
        const result = await __request({
            method: 'GET',
            path: `/api/icd10-site-specific-code-through/${id}/`,
        });
        return result.body;
    }

    /**
     * This is a dead-end endpoint to include the Icd10CodeSite model in schema
     * @returns Icd10CodeSite
     * @throws ApiError
     */
    public static async retrieveIcd10CodeSite({
        id,
    }: {
        /** A unique integer value identifying this icd10 code site. **/
        id: number,
    }): Promise<Icd10CodeSite> {
        const result = await __request({
            method: 'GET',
            path: `/api/icd10-code-site/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listMacroCodes({
        limit,
        offset,
        search,
        dxcode,
        dxcodeIexact,
        dxcodeStarstwith,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** search **/
        search?: string,
        /** dxcode **/
        dxcode?: string,
        /** dxcode__iexact **/
        dxcodeIexact?: string,
        /** dxcode__starstwith **/
        dxcodeStarstwith?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<MacroCode>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/macro-codes/`,
            query: {
                'limit': limit,
                'offset': offset,
                'search': search,
                'dxcode': dxcode,
                'dxcode__iexact': dxcodeIexact,
                'dxcode__starstwith': dxcodeStarstwith,
            },
        });
        return result.body;
    }

    /**
     * @returns MacroCode
     * @throws ApiError
     */
    public static async helpersMacroCode(): Promise<MacroCode> {
        const result = await __request({
            method: 'GET',
            path: `/api/macro-codes/helpers/`,
        });
        return result.body;
    }

    /**
     * @returns MacroCode
     * @throws ApiError
     */
    public static async retrieveMacroCode({
        id,
        search,
        dxcode,
        dxcodeIexact,
        dxcodeStarstwith,
    }: {
        /** A unique integer value identifying this macro code. **/
        id: number,
        /** search **/
        search?: string,
        /** dxcode **/
        dxcode?: string,
        /** dxcode__iexact **/
        dxcodeIexact?: string,
        /** dxcode__starstwith **/
        dxcodeStarstwith?: string,
    }): Promise<MacroCode> {
        const result = await __request({
            method: 'GET',
            path: `/api/macro-codes/${id}/`,
            query: {
                'search': search,
                'dxcode': dxcode,
                'dxcode__iexact': dxcodeIexact,
                'dxcode__starstwith': dxcodeStarstwith,
            },
        });
        return result.body;
    }

    /**
     * /api/s3-slides/
     * @returns any
     * @throws ApiError
     */
    public static async listS3Slides({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<S3Slide>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/s3-slides/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * customized POST function that attempts to locate and merge WPL created slide
     * records with uploader client slide records.
     * @returns S3Slide
     * @throws ApiError
     */
    public static async createS3Slides({
        requestBody,
    }: {
        requestBody?: S3Slide,
    }): Promise<S3Slide> {
        const result = await __request({
            method: 'POST',
            path: `/api/s3-slides/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * /api/s3-slides/
     * @returns S3Slide
     * @throws ApiError
     */
    public static async retrieveS3Slides({
        uploaderHash,
    }: {
        /** an md5 hash of the uplaoded s3 filename **/
        uploaderHash: string,
    }): Promise<S3Slide> {
        const result = await __request({
            method: 'GET',
            path: `/api/s3-slides/${uploaderHash}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listClinics({
        limit,
        offset,
        name,
        orderingDoctor,
        externalClinicId,
        omni,
        caseSource,
        isArchived,
        status,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
        /** ordering_doctor **/
        orderingDoctor?: string,
        /** external_clinic_id **/
        externalClinicId?: number,
        /** omni **/
        omni?: string,
        /** case_source **/
        caseSource?: 'wpl' | 'pw' | 'apl',
        /** is_archived **/
        isArchived?: boolean,
        /** status **/
        status?: 'wpl' | 'pw' | 'apl',
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Clinics>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/clinics/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
                'ordering_doctor': orderingDoctor,
                'external_clinic_id': externalClinicId,
                'omni': omni,
                'case_source': caseSource,
                'is_archived': isArchived,
                'status': status,
            },
        });
        return result.body;
    }

    /**
     * @returns Clinic
     * @throws ApiError
     */
    public static async retrieveClinic({
        id,
        name,
        orderingDoctor,
        externalClinicId,
        omni,
        caseSource,
        isArchived,
        status,
    }: {
        /** A unique integer value identifying this clinic. **/
        id: number,
        /** name **/
        name?: string,
        /** ordering_doctor **/
        orderingDoctor?: string,
        /** external_clinic_id **/
        externalClinicId?: number,
        /** omni **/
        omni?: string,
        /** case_source **/
        caseSource?: 'wpl' | 'pw' | 'apl',
        /** is_archived **/
        isArchived?: boolean,
        /** status **/
        status?: 'wpl' | 'pw' | 'apl',
    }): Promise<Clinic> {
        const result = await __request({
            method: 'GET',
            path: `/api/clinics/${id}/`,
            query: {
                'name': name,
                'ordering_doctor': orderingDoctor,
                'external_clinic_id': externalClinicId,
                'omni': omni,
                'case_source': caseSource,
                'is_archived': isArchived,
                'status': status,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listClinicGroups({
        limit,
        offset,
        name,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<ClinicGroup>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/clinic-groups/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listSonicPractices({
        limit,
        offset,
        name,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<SonicPractice>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/sonic-practices/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCasesWithDocuments({
        limit,
        offset,
        accession,
        accessioningLab,
        externalAccession,
        patientFirstName,
        patientLastName,
        patientName,
        patientDateOfBirth,
        createdAt,
        updatedAt,
        patientClinicName,
        lab,
        orderingDoctorFirstName,
        orderingDoctorLastName,
        orderingDoctorName,
        priority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        signOutDateAfter,
        signOutDateBefore,
        finalizedAtAfter,
        finalizedAtBefore,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        diagnosesDiagnosis,
        diagnosesMicroscopic,
        diagnosesReportSignedAfter,
        diagnosesReportSignedBefore,
        status,
        activeAssignmentEmail,
        activeAssignmentUsername,
        activeAssignmentName,
        collectedDateAfter,
        collectedDateBefore,
        receivedDateAfter,
        receivedDateBefore,
        source,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        note,
        category,
        hasBeenViewed,
        isScreening,
        isRequestScreenComplete,
        biopsyType,
        specimensClinicalHistory,
        diagnosisCategory,
        anyDiagnosticText,
        allSlidesSuccess,
        allOrderedDocumentsUploaded,
        hasFlaggedSlides,
        hasActivePrelimReport,
        hasIncompleteOrders,
        hasActiveNoAdditionalOrders,
        hasActiveAdditionalOrders,
        hasUnviewedSlides,
        today,
        tomorrow,
        fields,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** accession **/
        accession?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** external_accession **/
        externalAccession?: string,
        /** patient__first_name **/
        patientFirstName?: string,
        /** patient__last_name **/
        patientLastName?: string,
        /** patient_name **/
        patientName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** created_at **/
        createdAt?: string,
        /** updated_at **/
        updatedAt?: string,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor__first_name **/
        orderingDoctorFirstName?: string,
        /** ordering_doctor__last_name **/
        orderingDoctorLastName?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** diagnoses__diagnosis **/
        diagnosesDiagnosis?: string,
        /** diagnoses__microscopic **/
        diagnosesMicroscopic?: string,
        /** diagnoses__report_signed_after **/
        diagnosesReportSignedAfter?: string,
        /** diagnoses__report_signed_before **/
        diagnosesReportSignedBefore?: string,
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** source **/
        source?: string,
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** note **/
        note?: string,
        /** category **/
        category?: 'Case-Report' | 'Unmerged-Case-Report' | 'Previous-Pathology-Report' | 'Preliminary-Report' | 'Unmerged-Preliminary-Report' | 'Clinic-Notes' | 'Consent-Form' | 'Consultation-Report' | 'Doc-Clinical' | 'Doc-Insurance' | 'DIF-Report' | 'Fish-Report' | 'Gross-Diagram' | 'Lab-Report' | 'Lab-Requisition' | 'Sendout-Requisition' | 'Molecular-Report' | 'Patient-Demographics' | 'Requisition-Form' | 'Loose-Document' | 'Material-Request' | 'Self-Pay-Attestation' | 'Indigent-Patient-Agreement-Notice' | 'IHC-Report' | 'Case-Correction-Request' | 'Consult-Letter' | 'Tick-Report' | 'Castle-Report' | 'ISH-Report' | 'Gross-Specimen-Photo' | 'Other',
        /** has_been_viewed **/
        hasBeenViewed?: string,
        /** is_screening **/
        isScreening?: string,
        /** is_request_screen_complete **/
        isRequestScreenComplete?: string,
        /** biopsy_type **/
        biopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** diagnosis_category **/
        diagnosisCategory?: 'ASL' | 'BCC' | 'MEL' | 'SK' | 'VV' | 'INCONCLUSIVE',
        /** any_diagnostic_text **/
        anyDiagnosticText?: string,
        /** all_slides_success **/
        allSlidesSuccess?: string,
        /** all_ordered_documents_uploaded **/
        allOrderedDocumentsUploaded?: string,
        /** has_flagged_slides **/
        hasFlaggedSlides?: string,
        /** has_active_prelim_report **/
        hasActivePrelimReport?: string,
        /** has_incomplete_orders **/
        hasIncompleteOrders?: string,
        /** has_active_no_additional_orders **/
        hasActiveNoAdditionalOrders?: string,
        /** has_active_additional_orders **/
        hasActiveAdditionalOrders?: string,
        /** has_unviewed_slides **/
        hasUnviewedSlides?: string,
        /** today **/
        today?: string,
        /** tomorrow **/
        tomorrow?: string,
        /** fields **/
        fields?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CasesWithDocumentView>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/documents-list/`,
            query: {
                'limit': limit,
                'offset': offset,
                'accession': accession,
                'accessioning_lab': accessioningLab,
                'external_accession': externalAccession,
                'patient__first_name': patientFirstName,
                'patient__last_name': patientLastName,
                'patient_name': patientName,
                'patient__date_of_birth': patientDateOfBirth,
                'created_at': createdAt,
                'updated_at': updatedAt,
                'patient__clinic__name': patientClinicName,
                'lab': lab,
                'ordering_doctor__first_name': orderingDoctorFirstName,
                'ordering_doctor__last_name': orderingDoctorLastName,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'diagnoses__diagnosis': diagnosesDiagnosis,
                'diagnoses__microscopic': diagnosesMicroscopic,
                'diagnoses__report_signed_after': diagnosesReportSignedAfter,
                'diagnoses__report_signed_before': diagnosesReportSignedBefore,
                'status': status,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'source': source,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'note': note,
                'category': category,
                'has_been_viewed': hasBeenViewed,
                'is_screening': isScreening,
                'is_request_screen_complete': isRequestScreenComplete,
                'biopsy_type': biopsyType,
                'specimens__clinical_history': specimensClinicalHistory,
                'diagnosis_category': diagnosisCategory,
                'any_diagnostic_text': anyDiagnosticText,
                'all_slides_success': allSlidesSuccess,
                'all_ordered_documents_uploaded': allOrderedDocumentsUploaded,
                'has_flagged_slides': hasFlaggedSlides,
                'has_active_prelim_report': hasActivePrelimReport,
                'has_incomplete_orders': hasIncompleteOrders,
                'has_active_no_additional_orders': hasActiveNoAdditionalOrders,
                'has_active_additional_orders': hasActiveAdditionalOrders,
                'has_unviewed_slides': hasUnviewedSlides,
                'today': today,
                'tomorrow': tomorrow,
                'fields': fields,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listUploaderClients({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<UploaderClient>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/uploader-clients/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns UploaderClient
     * @throws ApiError
     */
    public static async createUploaderClient({
        requestBody,
    }: {
        requestBody?: UploaderClient,
    }): Promise<UploaderClient> {
        const result = await __request({
            method: 'POST',
            path: `/api/uploader-clients/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns UploaderClient
     * @throws ApiError
     */
    public static async retrieveUploaderClient({
        uuid,
    }: {
        uuid: string,
    }): Promise<UploaderClient> {
        const result = await __request({
            method: 'GET',
            path: `/api/uploader-clients/${uuid}/`,
        });
        return result.body;
    }

    /**
     * @returns UploaderClient
     * @throws ApiError
     */
    public static async updateUploaderClient({
        uuid,
        requestBody,
    }: {
        uuid: string,
        requestBody?: UploaderClient,
    }): Promise<UploaderClient> {
        const result = await __request({
            method: 'PUT',
            path: `/api/uploader-clients/${uuid}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns UploaderClient
     * @throws ApiError
     */
    public static async partialUpdateUploaderClient({
        uuid,
        requestBody,
    }: {
        uuid: string,
        requestBody?: UploaderClient,
    }): Promise<UploaderClient> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/uploader-clients/${uuid}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyUploaderClient({
        uuid,
    }: {
        uuid: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/uploader-clients/${uuid}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listSpecimen({
        bypassRawText,
        limit,
        offset,
        labStationType,
        labStationLabName,
        lisState,
        ordering,
    }: {
        /** Do not force grossing_raw_text when updating gross_description **/
        bypassRawText?: boolean,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'bottled' | 'received' | 'grossed',
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Specimen>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/specimen/`,
            query: {
                'bypass_raw_text': bypassRawText,
                'limit': limit,
                'offset': offset,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns SpecimenPOST
     * @throws ApiError
     */
    public static async createSpecimen({
        bypassRawText,
        requestBody,
    }: {
        /** Do not force grossing_raw_text when updating gross_description **/
        bypassRawText?: boolean,
        requestBody?: SpecimenPOST,
    }): Promise<SpecimenPOST> {
        const result = await __request({
            method: 'POST',
            path: `/api/specimen/`,
            query: {
                'bypass_raw_text': bypassRawText,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Specimen
     * @throws ApiError
     */
    public static async retrieveSpecimen({
        id,
        bypassRawText,
        labStationType,
        labStationLabName,
        lisState,
        ordering,
    }: {
        /** A unique integer value identifying this specimen. **/
        id: number,
        /** Do not force grossing_raw_text when updating gross_description **/
        bypassRawText?: boolean,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'bottled' | 'received' | 'grossed',
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<Specimen> {
        const result = await __request({
            method: 'GET',
            path: `/api/specimen/${id}/`,
            query: {
                'bypass_raw_text': bypassRawText,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns SpecimenPATCH
     * @throws ApiError
     */
    public static async updateSpecimen({
        id,
        bypassRawText,
        labStationType,
        labStationLabName,
        lisState,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this specimen. **/
        id: number,
        /** Do not force grossing_raw_text when updating gross_description **/
        bypassRawText?: boolean,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'bottled' | 'received' | 'grossed',
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: SpecimenPATCH,
    }): Promise<SpecimenPATCH> {
        const result = await __request({
            method: 'PUT',
            path: `/api/specimen/${id}/`,
            query: {
                'bypass_raw_text': bypassRawText,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns SpecimenPATCH
     * @throws ApiError
     */
    public static async partialUpdateSpecimen({
        id,
        bypassRawText,
        labStationType,
        labStationLabName,
        lisState,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this specimen. **/
        id: number,
        /** Do not force grossing_raw_text when updating gross_description **/
        bypassRawText?: boolean,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'bottled' | 'received' | 'grossed',
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: SpecimenPATCH,
    }): Promise<SpecimenPATCH> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/specimen/${id}/`,
            query: {
                'bypass_raw_text': bypassRawText,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listStainLists({
        limit,
        offset,
        name,
        category,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
        /** category **/
        category?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Stain>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/stains/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
                'category': category,
            },
        });
        return result.body;
    }

    /**
     * @returns Stain
     * @throws ApiError
     */
    public static async retrieveStainList({
        id,
        name,
        category,
    }: {
        /** A unique integer value identifying this stain list. **/
        id: number,
        /** name **/
        name?: string,
        /** category **/
        category?: string,
    }): Promise<Stain> {
        const result = await __request({
            method: 'GET',
            path: `/api/stains/${id}/`,
            query: {
                'name': name,
                'category': category,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listScanningLogs({
        limit,
        offset,
        scannerId,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** scanner_id **/
        scannerId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<ScanningLog>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/scanning-logs/`,
            query: {
                'limit': limit,
                'offset': offset,
                'scanner_id': scannerId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns ScanningLog
     * @throws ApiError
     */
    public static async createScanningLog({
        requestBody,
    }: {
        requestBody?: ScanningLog,
    }): Promise<ScanningLog> {
        const result = await __request({
            method: 'POST',
            path: `/api/scanning-logs/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns ScanningLog
     * @throws ApiError
     */
    public static async retrieveScanningLog({
        id,
        scannerId,
        ordering,
    }: {
        /** A unique integer value identifying this scanning log. **/
        id: number,
        /** scanner_id **/
        scannerId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<ScanningLog> {
        const result = await __request({
            method: 'GET',
            path: `/api/scanning-logs/${id}/`,
            query: {
                'scanner_id': scannerId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns ScanningLog
     * @throws ApiError
     */
    public static async updateScanningLog({
        id,
        scannerId,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this scanning log. **/
        id: number,
        /** scanner_id **/
        scannerId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: ScanningLog,
    }): Promise<ScanningLog> {
        const result = await __request({
            method: 'PUT',
            path: `/api/scanning-logs/${id}/`,
            query: {
                'scanner_id': scannerId,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns ScanningLog
     * @throws ApiError
     */
    public static async partialUpdateScanningLog({
        id,
        scannerId,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this scanning log. **/
        id: number,
        /** scanner_id **/
        scannerId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: ScanningLog,
    }): Promise<ScanningLog> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/scanning-logs/${id}/`,
            query: {
                'scanner_id': scannerId,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyScanningLog({
        id,
        scannerId,
        ordering,
    }: {
        /** A unique integer value identifying this scanning log. **/
        id: number,
        /** scanner_id **/
        scannerId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/scanning-logs/${id}/`,
            query: {
                'scanner_id': scannerId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listViewerMaintenanceMessages({
        limit,
        offset,
        application,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** application **/
        application?: 'viewer' | 'pw-lis',
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<MaintenanceMessage>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/maintenance-message/`,
            query: {
                'limit': limit,
                'offset': offset,
                'application': application,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async apiExceptionErrorViewSet(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/api/errors/api_exception/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async exceptionErrorViewSet(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/api/errors/exception/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async permissionDeniedErrorViewSet(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/api/errors/permission_denied/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async timeoutErrorViewSet(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/api/errors/timeout/`,
        });
        return result.body;
    }

    /**
     * This class exists solely, more or less, to provide a type entry
     * in the OpenAPI schema for AccessionPrefix. The schema is generated
     * by enumerating the endpoints registered in the URL router.
     *
     * The endpoint actually in use for retrieving AccessionPrefixes is
     * `GET /api/cases/prefixes/`.
     *
     * The benefit to using the above endpoint is automatic filtering that
     * only returns the AccessionPrefixes for the Cases where user has permission.
     * @returns any
     * @throws ApiError
     */
    public static async listAccessionPrefixes({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<AccessionPrefix>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/prefixes/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabOrders({
        limit,
        offset,
        caseId,
        caseAccession,
        caseAccessioningLabName,
        casePriority,
        caseSource,
        createdAtAfter,
        createdAtBefore,
        completedAtAfter,
        completedAtBefore,
        sentAtAfter,
        sentAtBefore,
        cancelledAtAfter,
        cancelledAtBefore,
        user,
        type,
        labStainId,
        labStainStainId,
        labStainStainName,
        labStainStainCategory,
        isCompleted,
        isSent,
        isCancelled,
        isFlagged,
        includesNonRoutine,
        isPrinted,
        isSendout,
        incomingSendoutsLab,
        outgoingSendoutsLab,
        labStainExternalStainExternalLabName,
        isTatClinic,
        department,
        orderingDoctorName,
        includeRoutine,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** case__id **/
        caseId?: number,
        /** case__accession **/
        caseAccession?: string,
        /** case__accessioning_lab__name **/
        caseAccessioningLabName?: string,
        /** case__priority **/
        casePriority?: string,
        /** case__source **/
        caseSource?: string,
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** completed_at_after **/
        completedAtAfter?: string,
        /** completed_at_before **/
        completedAtBefore?: string,
        /** sent_at_after **/
        sentAtAfter?: string,
        /** sent_at_before **/
        sentAtBefore?: string,
        /** cancelled_at_after **/
        cancelledAtAfter?: string,
        /** cancelled_at_before **/
        cancelledAtBefore?: string,
        /** user **/
        user?: string,
        /** type **/
        type?: string,
        /** lab_stain__id **/
        labStainId?: number,
        /** lab_stain__stain__id **/
        labStainStainId?: number,
        /** lab_stain__stain__name **/
        labStainStainName?: string,
        /** Stain Category **/
        labStainStainCategory?: string,
        /** is_completed **/
        isCompleted?: string,
        /** is_sent **/
        isSent?: string,
        /** is_cancelled **/
        isCancelled?: string,
        /** is_flagged **/
        isFlagged?: string,
        /** includes_non_routine **/
        includesNonRoutine?: string,
        /** Printed **/
        isPrinted?: string,
        /** Sendout **/
        isSendout?: string,
        /** Incoming Sendouts Lab **/
        incomingSendoutsLab?: string,
        /** Outgoing Sendouts Lab **/
        outgoingSendoutsLab?: string,
        /** lab_stain__external_stain__external_lab__name **/
        labStainExternalStainExternalLabName?: string,
        /** TAT Clinic **/
        isTatClinic?: string,
        /** department **/
        department?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Include Routine **/
        includeRoutine?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<LabOrder>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/stain-order/`,
            query: {
                'limit': limit,
                'offset': offset,
                'case__id': caseId,
                'case__accession': caseAccession,
                'case__accessioning_lab__name': caseAccessioningLabName,
                'case__priority': casePriority,
                'case__source': caseSource,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'completed_at_after': completedAtAfter,
                'completed_at_before': completedAtBefore,
                'sent_at_after': sentAtAfter,
                'sent_at_before': sentAtBefore,
                'cancelled_at_after': cancelledAtAfter,
                'cancelled_at_before': cancelledAtBefore,
                'user': user,
                'type': type,
                'lab_stain__id': labStainId,
                'lab_stain__stain__id': labStainStainId,
                'lab_stain__stain__name': labStainStainName,
                'lab_stain__stain__category': labStainStainCategory,
                'is_completed': isCompleted,
                'is_sent': isSent,
                'is_cancelled': isCancelled,
                'is_flagged': isFlagged,
                'includes_non_routine': includesNonRoutine,
                'is_printed': isPrinted,
                'is_sendout': isSendout,
                'incoming_sendouts_lab': incomingSendoutsLab,
                'outgoing_sendouts_lab': outgoingSendoutsLab,
                'lab_stain__external_stain__external_lab__name': labStainExternalStainExternalLabName,
                'is_tat_clinic': isTatClinic,
                'department': department,
                'ordering_doctor_name': orderingDoctorName,
                'include_routine': includeRoutine,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns LabOrderPOST
     * @throws ApiError
     */
    public static async createLabOrder({
        requestBody,
    }: {
        requestBody?: LabOrderPOST,
    }): Promise<LabOrderPOST> {
        const result = await __request({
            method: 'POST',
            path: `/api/stain-order/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LabOrder
     * @throws ApiError
     */
    public static async retrieveLabOrder({
        id,
        caseId,
        caseAccession,
        caseAccessioningLabName,
        casePriority,
        caseSource,
        createdAtAfter,
        createdAtBefore,
        completedAtAfter,
        completedAtBefore,
        sentAtAfter,
        sentAtBefore,
        cancelledAtAfter,
        cancelledAtBefore,
        user,
        type,
        labStainId,
        labStainStainId,
        labStainStainName,
        labStainStainCategory,
        isCompleted,
        isSent,
        isCancelled,
        isFlagged,
        includesNonRoutine,
        isPrinted,
        isSendout,
        incomingSendoutsLab,
        outgoingSendoutsLab,
        labStainExternalStainExternalLabName,
        isTatClinic,
        department,
        orderingDoctorName,
        includeRoutine,
        ordering,
    }: {
        /** A unique integer value identifying this lab order. **/
        id: number,
        /** case__id **/
        caseId?: number,
        /** case__accession **/
        caseAccession?: string,
        /** case__accessioning_lab__name **/
        caseAccessioningLabName?: string,
        /** case__priority **/
        casePriority?: string,
        /** case__source **/
        caseSource?: string,
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** completed_at_after **/
        completedAtAfter?: string,
        /** completed_at_before **/
        completedAtBefore?: string,
        /** sent_at_after **/
        sentAtAfter?: string,
        /** sent_at_before **/
        sentAtBefore?: string,
        /** cancelled_at_after **/
        cancelledAtAfter?: string,
        /** cancelled_at_before **/
        cancelledAtBefore?: string,
        /** user **/
        user?: string,
        /** type **/
        type?: string,
        /** lab_stain__id **/
        labStainId?: number,
        /** lab_stain__stain__id **/
        labStainStainId?: number,
        /** lab_stain__stain__name **/
        labStainStainName?: string,
        /** Stain Category **/
        labStainStainCategory?: string,
        /** is_completed **/
        isCompleted?: string,
        /** is_sent **/
        isSent?: string,
        /** is_cancelled **/
        isCancelled?: string,
        /** is_flagged **/
        isFlagged?: string,
        /** includes_non_routine **/
        includesNonRoutine?: string,
        /** Printed **/
        isPrinted?: string,
        /** Sendout **/
        isSendout?: string,
        /** Incoming Sendouts Lab **/
        incomingSendoutsLab?: string,
        /** Outgoing Sendouts Lab **/
        outgoingSendoutsLab?: string,
        /** lab_stain__external_stain__external_lab__name **/
        labStainExternalStainExternalLabName?: string,
        /** TAT Clinic **/
        isTatClinic?: string,
        /** department **/
        department?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Include Routine **/
        includeRoutine?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<LabOrder> {
        const result = await __request({
            method: 'GET',
            path: `/api/stain-order/${id}/`,
            query: {
                'case__id': caseId,
                'case__accession': caseAccession,
                'case__accessioning_lab__name': caseAccessioningLabName,
                'case__priority': casePriority,
                'case__source': caseSource,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'completed_at_after': completedAtAfter,
                'completed_at_before': completedAtBefore,
                'sent_at_after': sentAtAfter,
                'sent_at_before': sentAtBefore,
                'cancelled_at_after': cancelledAtAfter,
                'cancelled_at_before': cancelledAtBefore,
                'user': user,
                'type': type,
                'lab_stain__id': labStainId,
                'lab_stain__stain__id': labStainStainId,
                'lab_stain__stain__name': labStainStainName,
                'lab_stain__stain__category': labStainStainCategory,
                'is_completed': isCompleted,
                'is_sent': isSent,
                'is_cancelled': isCancelled,
                'is_flagged': isFlagged,
                'includes_non_routine': includesNonRoutine,
                'is_printed': isPrinted,
                'is_sendout': isSendout,
                'incoming_sendouts_lab': incomingSendoutsLab,
                'outgoing_sendouts_lab': outgoingSendoutsLab,
                'lab_stain__external_stain__external_lab__name': labStainExternalStainExternalLabName,
                'is_tat_clinic': isTatClinic,
                'department': department,
                'ordering_doctor_name': orderingDoctorName,
                'include_routine': includeRoutine,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns LabOrder
     * @throws ApiError
     */
    public static async updateLabOrder({
        id,
        caseId,
        caseAccession,
        caseAccessioningLabName,
        casePriority,
        caseSource,
        createdAtAfter,
        createdAtBefore,
        completedAtAfter,
        completedAtBefore,
        sentAtAfter,
        sentAtBefore,
        cancelledAtAfter,
        cancelledAtBefore,
        user,
        type,
        labStainId,
        labStainStainId,
        labStainStainName,
        labStainStainCategory,
        isCompleted,
        isSent,
        isCancelled,
        isFlagged,
        includesNonRoutine,
        isPrinted,
        isSendout,
        incomingSendoutsLab,
        outgoingSendoutsLab,
        labStainExternalStainExternalLabName,
        isTatClinic,
        department,
        orderingDoctorName,
        includeRoutine,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this lab order. **/
        id: number,
        /** case__id **/
        caseId?: number,
        /** case__accession **/
        caseAccession?: string,
        /** case__accessioning_lab__name **/
        caseAccessioningLabName?: string,
        /** case__priority **/
        casePriority?: string,
        /** case__source **/
        caseSource?: string,
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** completed_at_after **/
        completedAtAfter?: string,
        /** completed_at_before **/
        completedAtBefore?: string,
        /** sent_at_after **/
        sentAtAfter?: string,
        /** sent_at_before **/
        sentAtBefore?: string,
        /** cancelled_at_after **/
        cancelledAtAfter?: string,
        /** cancelled_at_before **/
        cancelledAtBefore?: string,
        /** user **/
        user?: string,
        /** type **/
        type?: string,
        /** lab_stain__id **/
        labStainId?: number,
        /** lab_stain__stain__id **/
        labStainStainId?: number,
        /** lab_stain__stain__name **/
        labStainStainName?: string,
        /** Stain Category **/
        labStainStainCategory?: string,
        /** is_completed **/
        isCompleted?: string,
        /** is_sent **/
        isSent?: string,
        /** is_cancelled **/
        isCancelled?: string,
        /** is_flagged **/
        isFlagged?: string,
        /** includes_non_routine **/
        includesNonRoutine?: string,
        /** Printed **/
        isPrinted?: string,
        /** Sendout **/
        isSendout?: string,
        /** Incoming Sendouts Lab **/
        incomingSendoutsLab?: string,
        /** Outgoing Sendouts Lab **/
        outgoingSendoutsLab?: string,
        /** lab_stain__external_stain__external_lab__name **/
        labStainExternalStainExternalLabName?: string,
        /** TAT Clinic **/
        isTatClinic?: string,
        /** department **/
        department?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Include Routine **/
        includeRoutine?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: LabOrder,
    }): Promise<LabOrder> {
        const result = await __request({
            method: 'PUT',
            path: `/api/stain-order/${id}/`,
            query: {
                'case__id': caseId,
                'case__accession': caseAccession,
                'case__accessioning_lab__name': caseAccessioningLabName,
                'case__priority': casePriority,
                'case__source': caseSource,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'completed_at_after': completedAtAfter,
                'completed_at_before': completedAtBefore,
                'sent_at_after': sentAtAfter,
                'sent_at_before': sentAtBefore,
                'cancelled_at_after': cancelledAtAfter,
                'cancelled_at_before': cancelledAtBefore,
                'user': user,
                'type': type,
                'lab_stain__id': labStainId,
                'lab_stain__stain__id': labStainStainId,
                'lab_stain__stain__name': labStainStainName,
                'lab_stain__stain__category': labStainStainCategory,
                'is_completed': isCompleted,
                'is_sent': isSent,
                'is_cancelled': isCancelled,
                'is_flagged': isFlagged,
                'includes_non_routine': includesNonRoutine,
                'is_printed': isPrinted,
                'is_sendout': isSendout,
                'incoming_sendouts_lab': incomingSendoutsLab,
                'outgoing_sendouts_lab': outgoingSendoutsLab,
                'lab_stain__external_stain__external_lab__name': labStainExternalStainExternalLabName,
                'is_tat_clinic': isTatClinic,
                'department': department,
                'ordering_doctor_name': orderingDoctorName,
                'include_routine': includeRoutine,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LabOrder
     * @throws ApiError
     */
    public static async partialUpdateLabOrder({
        id,
        caseId,
        caseAccession,
        caseAccessioningLabName,
        casePriority,
        caseSource,
        createdAtAfter,
        createdAtBefore,
        completedAtAfter,
        completedAtBefore,
        sentAtAfter,
        sentAtBefore,
        cancelledAtAfter,
        cancelledAtBefore,
        user,
        type,
        labStainId,
        labStainStainId,
        labStainStainName,
        labStainStainCategory,
        isCompleted,
        isSent,
        isCancelled,
        isFlagged,
        includesNonRoutine,
        isPrinted,
        isSendout,
        incomingSendoutsLab,
        outgoingSendoutsLab,
        labStainExternalStainExternalLabName,
        isTatClinic,
        department,
        orderingDoctorName,
        includeRoutine,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this lab order. **/
        id: number,
        /** case__id **/
        caseId?: number,
        /** case__accession **/
        caseAccession?: string,
        /** case__accessioning_lab__name **/
        caseAccessioningLabName?: string,
        /** case__priority **/
        casePriority?: string,
        /** case__source **/
        caseSource?: string,
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** completed_at_after **/
        completedAtAfter?: string,
        /** completed_at_before **/
        completedAtBefore?: string,
        /** sent_at_after **/
        sentAtAfter?: string,
        /** sent_at_before **/
        sentAtBefore?: string,
        /** cancelled_at_after **/
        cancelledAtAfter?: string,
        /** cancelled_at_before **/
        cancelledAtBefore?: string,
        /** user **/
        user?: string,
        /** type **/
        type?: string,
        /** lab_stain__id **/
        labStainId?: number,
        /** lab_stain__stain__id **/
        labStainStainId?: number,
        /** lab_stain__stain__name **/
        labStainStainName?: string,
        /** Stain Category **/
        labStainStainCategory?: string,
        /** is_completed **/
        isCompleted?: string,
        /** is_sent **/
        isSent?: string,
        /** is_cancelled **/
        isCancelled?: string,
        /** is_flagged **/
        isFlagged?: string,
        /** includes_non_routine **/
        includesNonRoutine?: string,
        /** Printed **/
        isPrinted?: string,
        /** Sendout **/
        isSendout?: string,
        /** Incoming Sendouts Lab **/
        incomingSendoutsLab?: string,
        /** Outgoing Sendouts Lab **/
        outgoingSendoutsLab?: string,
        /** lab_stain__external_stain__external_lab__name **/
        labStainExternalStainExternalLabName?: string,
        /** TAT Clinic **/
        isTatClinic?: string,
        /** department **/
        department?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Include Routine **/
        includeRoutine?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: LabOrder,
    }): Promise<LabOrder> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/stain-order/${id}/`,
            query: {
                'case__id': caseId,
                'case__accession': caseAccession,
                'case__accessioning_lab__name': caseAccessioningLabName,
                'case__priority': casePriority,
                'case__source': caseSource,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'completed_at_after': completedAtAfter,
                'completed_at_before': completedAtBefore,
                'sent_at_after': sentAtAfter,
                'sent_at_before': sentAtBefore,
                'cancelled_at_after': cancelledAtAfter,
                'cancelled_at_before': cancelledAtBefore,
                'user': user,
                'type': type,
                'lab_stain__id': labStainId,
                'lab_stain__stain__id': labStainStainId,
                'lab_stain__stain__name': labStainStainName,
                'lab_stain__stain__category': labStainStainCategory,
                'is_completed': isCompleted,
                'is_sent': isSent,
                'is_cancelled': isCancelled,
                'is_flagged': isFlagged,
                'includes_non_routine': includesNonRoutine,
                'is_printed': isPrinted,
                'is_sendout': isSendout,
                'incoming_sendouts_lab': incomingSendoutsLab,
                'outgoing_sendouts_lab': outgoingSendoutsLab,
                'lab_stain__external_stain__external_lab__name': labStainExternalStainExternalLabName,
                'is_tat_clinic': isTatClinic,
                'department': department,
                'ordering_doctor_name': orderingDoctorName,
                'include_routine': includeRoutine,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyLabOrder({
        id,
        caseId,
        caseAccession,
        caseAccessioningLabName,
        casePriority,
        caseSource,
        createdAtAfter,
        createdAtBefore,
        completedAtAfter,
        completedAtBefore,
        sentAtAfter,
        sentAtBefore,
        cancelledAtAfter,
        cancelledAtBefore,
        user,
        type,
        labStainId,
        labStainStainId,
        labStainStainName,
        labStainStainCategory,
        isCompleted,
        isSent,
        isCancelled,
        isFlagged,
        includesNonRoutine,
        isPrinted,
        isSendout,
        incomingSendoutsLab,
        outgoingSendoutsLab,
        labStainExternalStainExternalLabName,
        isTatClinic,
        department,
        orderingDoctorName,
        includeRoutine,
        ordering,
    }: {
        /** A unique integer value identifying this lab order. **/
        id: number,
        /** case__id **/
        caseId?: number,
        /** case__accession **/
        caseAccession?: string,
        /** case__accessioning_lab__name **/
        caseAccessioningLabName?: string,
        /** case__priority **/
        casePriority?: string,
        /** case__source **/
        caseSource?: string,
        /** created_at_after **/
        createdAtAfter?: string,
        /** created_at_before **/
        createdAtBefore?: string,
        /** completed_at_after **/
        completedAtAfter?: string,
        /** completed_at_before **/
        completedAtBefore?: string,
        /** sent_at_after **/
        sentAtAfter?: string,
        /** sent_at_before **/
        sentAtBefore?: string,
        /** cancelled_at_after **/
        cancelledAtAfter?: string,
        /** cancelled_at_before **/
        cancelledAtBefore?: string,
        /** user **/
        user?: string,
        /** type **/
        type?: string,
        /** lab_stain__id **/
        labStainId?: number,
        /** lab_stain__stain__id **/
        labStainStainId?: number,
        /** lab_stain__stain__name **/
        labStainStainName?: string,
        /** Stain Category **/
        labStainStainCategory?: string,
        /** is_completed **/
        isCompleted?: string,
        /** is_sent **/
        isSent?: string,
        /** is_cancelled **/
        isCancelled?: string,
        /** is_flagged **/
        isFlagged?: string,
        /** includes_non_routine **/
        includesNonRoutine?: string,
        /** Printed **/
        isPrinted?: string,
        /** Sendout **/
        isSendout?: string,
        /** Incoming Sendouts Lab **/
        incomingSendoutsLab?: string,
        /** Outgoing Sendouts Lab **/
        outgoingSendoutsLab?: string,
        /** lab_stain__external_stain__external_lab__name **/
        labStainExternalStainExternalLabName?: string,
        /** TAT Clinic **/
        isTatClinic?: string,
        /** department **/
        department?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Include Routine **/
        includeRoutine?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/stain-order/${id}/`,
            query: {
                'case__id': caseId,
                'case__accession': caseAccession,
                'case__accessioning_lab__name': caseAccessioningLabName,
                'case__priority': casePriority,
                'case__source': caseSource,
                'created_at_after': createdAtAfter,
                'created_at_before': createdAtBefore,
                'completed_at_after': completedAtAfter,
                'completed_at_before': completedAtBefore,
                'sent_at_after': sentAtAfter,
                'sent_at_before': sentAtBefore,
                'cancelled_at_after': cancelledAtAfter,
                'cancelled_at_before': cancelledAtBefore,
                'user': user,
                'type': type,
                'lab_stain__id': labStainId,
                'lab_stain__stain__id': labStainStainId,
                'lab_stain__stain__name': labStainStainName,
                'lab_stain__stain__category': labStainStainCategory,
                'is_completed': isCompleted,
                'is_sent': isSent,
                'is_cancelled': isCancelled,
                'is_flagged': isFlagged,
                'includes_non_routine': includesNonRoutine,
                'is_printed': isPrinted,
                'is_sendout': isSendout,
                'incoming_sendouts_lab': incomingSendoutsLab,
                'outgoing_sendouts_lab': outgoingSendoutsLab,
                'lab_stain__external_stain__external_lab__name': labStainExternalStainExternalLabName,
                'is_tat_clinic': isTatClinic,
                'department': department,
                'ordering_doctor_name': orderingDoctorName,
                'include_routine': includeRoutine,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listQrAuthTokens({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<QRAuthToken>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/qr-auth/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns QRAuthTokenPOST
     * @throws ApiError
     */
    public static async createQrAuthToken({
        requestBody,
    }: {
        requestBody?: QRAuthTokenPOST,
    }): Promise<QRAuthTokenPOST> {
        const result = await __request({
            method: 'POST',
            path: `/api/qr-auth/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns QRAuthToken
     * @throws ApiError
     */
    public static async retrieveQrAuthToken({
        id,
    }: {
        /** A unique integer value identifying this qr auth token. **/
        id: number,
    }): Promise<QRAuthToken> {
        const result = await __request({
            method: 'GET',
            path: `/api/qr-auth/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns QRAuthToken
     * @throws ApiError
     */
    public static async updateQrAuthToken({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this qr auth token. **/
        id: number,
        requestBody?: QRAuthToken,
    }): Promise<QRAuthToken> {
        const result = await __request({
            method: 'PUT',
            path: `/api/qr-auth/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns QRAuthTokenPATCH
     * @throws ApiError
     */
    public static async partialUpdateQrAuthToken({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this qr auth token. **/
        id: number,
        requestBody?: QRAuthTokenPATCH,
    }): Promise<QRAuthTokenPATCH> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/qr-auth/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyQrAuthToken({
        id,
    }: {
        /** A unique integer value identifying this qr auth token. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/qr-auth/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns FrontLoaderLab
     * @throws ApiError
     */
    public static async listFrontLoaderLabs(): Promise<Array<FrontLoaderLab>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/labs/`,
        });
        return result.body;
    }

    /**
     * @returns FrontLoaderLabStation
     * @throws ApiError
     */
    public static async listFrontLoaderLabStations(): Promise<Array<FrontLoaderLabStation>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/lab-stations/`,
        });
        return result.body;
    }

    /**
     * @returns FrontLoaderClinic
     * @throws ApiError
     */
    public static async listFrontLoaderClinics(): Promise<Array<FrontLoaderClinic>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/clinics/`,
        });
        return result.body;
    }

    /**
     * @returns UserList
     * @throws ApiError
     */
    public static async listFrontLoaderUsers(): Promise<Array<UserList>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/users/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listFrontLoaderExternalLabs(): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/external-labs/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listFrontLoaderExternalLabStains(): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/external-lab-stains/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listFrontLoaderStains(): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/stains/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listFrontLoaderLabStains(): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/lab-stains/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listFrontLoaderLabPanels(): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/lab-panels/`,
        });
        return result.body;
    }

    /**
     * @returns AntigenRetrievalMethod
     * @throws ApiError
     */
    public static async listFrontLoaderAntigenRetrievalMethods(): Promise<Array<AntigenRetrievalMethod>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/antigen-retrieval-methods/`,
        });
        return result.body;
    }

    /**
     * @returns AntibodySpecies
     * @throws ApiError
     */
    public static async listFrontLoaderAntibodySpecies(): Promise<Array<AntibodySpecies>> {
        const result = await __request({
            method: 'GET',
            path: `/api/front-load/antibody-species/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCaseReportSignatures({
        caseId,
        limit,
        offset,
        nameOrDescription,
        user,
    }: {
        /** Get case id. **/
        caseId?: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name_or_description **/
        nameOrDescription?: string,
        /** user **/
        user?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CaseReportSignature>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/signatures/`,
            query: {
                'case_id': caseId,
                'limit': limit,
                'offset': offset,
                'name_or_description': nameOrDescription,
                'user': user,
            },
        });
        return result.body;
    }

    /**
     * /api/rules/<str:rule_engine_type>/
     * rule_engine_types must be from the PWRuleEngineType class
     *
     * The payload for the GET or POST request must include one or more
     * of the fields in the rule engine's field_map.
     * @returns any
     * @throws ApiError
     */
    public static async listRuleReadables({
        ruleEngineType,
        limit,
        offset,
    }: {
        ruleEngineType: string,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Rule>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/rules/${ruleEngineType}/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * The list endpoint runs the rules using the preview mode and return the
     * serialized rule that was matched.  The POST method runs the rules in
     * update mode and returns the serialized rule that was matched.
     * Running the rules engine in preview mode requires us to first validate
     * the attributes passed in by the frontend.  The attributes passed in by
     * the frontend must be keys in the `field_map` property on the rule engine
     * class.  We use the serializer to validate the attributes.  If the
     * attributes are in the rule engine `field_map` then the serializer will
     * return the attributes.  If not, it will raise a validation error.
     * @returns Rule
     * @throws ApiError
     */
    public static async createRuleReadable({
        ruleEngineType,
        requestBody,
    }: {
        ruleEngineType: string,
        requestBody?: Rule,
    }): Promise<Rule> {
        const result = await __request({
            method: 'POST',
            path: `/api/rules/${ruleEngineType}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listUserSupportDocuments({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<UserSupportDocumentList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/user-support-documents/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns UserSupportDocumentRetrieve
     * @throws ApiError
     */
    public static async retrieveUserSupportDocument({
        documentType,
    }: {
        /** The type of the support document. Please be extra careful when filling this field, as the same document type must match across all user types (see comment on user type below).  **/
        documentType: string,
    }): Promise<UserSupportDocumentRetrieve> {
        const result = await __request({
            method: 'GET',
            path: `/api/user-support-documents/${documentType}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabOrderPrintLogs({
        limit,
        offset,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<AdminLabOrderPrintLog>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/lab-order-print-log/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns AdminLabOrderPrintLog
     * @throws ApiError
     */
    public static async retrieveLabOrderPrintLog({
        id,
    }: {
        /** A unique integer value identifying this lab order print log. **/
        id: number,
    }): Promise<AdminLabOrderPrintLog> {
        const result = await __request({
            method: 'GET',
            path: `/api/lab-order-print-log/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns AdminLabOrderPrintLog
     * @throws ApiError
     */
    public static async updateLabOrderPrintLog({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this lab order print log. **/
        id: number,
        requestBody?: AdminLabOrderPrintLog,
    }): Promise<AdminLabOrderPrintLog> {
        const result = await __request({
            method: 'PUT',
            path: `/api/lab-order-print-log/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * A patch to the print log can only set the printed_at
     * date and is called when a non superuser prints lab orders.
     * @returns AdminLabOrderPrintLog
     * @throws ApiError
     */
    public static async partialUpdateLabOrderPrintLog({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this lab order print log. **/
        id: number,
        requestBody?: AdminLabOrderPrintLog,
    }): Promise<AdminLabOrderPrintLog> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/lab-order-print-log/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listPatients({
        limit,
        offset,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Patient>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/patients/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns Patient
     * @throws ApiError
     */
    public static async createPatient({
        requestBody,
    }: {
        requestBody?: Patient,
    }): Promise<Patient> {
        const result = await __request({
            method: 'POST',
            path: `/api/patients/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Patient
     * @throws ApiError
     */
    public static async retrievePatient({
        id,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
    }: {
        /** A unique integer value identifying this patient. **/
        id: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<Patient> {
        const result = await __request({
            method: 'GET',
            path: `/api/patients/${id}/`,
            query: {
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns Patient
     * @throws ApiError
     */
    public static async updatePatient({
        id,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this patient. **/
        id: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: Patient,
    }): Promise<Patient> {
        const result = await __request({
            method: 'PUT',
            path: `/api/patients/${id}/`,
            query: {
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Patient
     * @throws ApiError
     */
    public static async partialUpdatePatient({
        id,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this patient. **/
        id: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: Patient,
    }): Promise<Patient> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/patients/${id}/`,
            query: {
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyPatient({
        id,
        name,
        casesAccession,
        dateOfBirth,
        clinicId,
        orderingDoctorName,
        ordering,
    }: {
        /** A unique integer value identifying this patient. **/
        id: number,
        /** name **/
        name?: string,
        /** cases__accession **/
        casesAccession?: string,
        /** date_of_birth **/
        dateOfBirth?: string,
        /** clinic_id **/
        clinicId?: number,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/patients/${id}/`,
            query: {
                'name': name,
                'cases__accession': casesAccession,
                'date_of_birth': dateOfBirth,
                'clinic_id': clinicId,
                'ordering_doctor_name': orderingDoctorName,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * Overriding list to provide custom orderings.
     * @returns any
     * @throws ApiError
     */
    public static async listCases({
        limit,
        offset,
        accession,
        accessioningLab,
        externalAccession,
        patientFirstName,
        patientLastName,
        patientName,
        patientDateOfBirth,
        createdAt,
        updatedAt,
        unviewed,
        patientClinicName,
        lab,
        orderingDoctorFirstName,
        orderingDoctorLastName,
        orderingDoctorName,
        priority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        signOutDateAfter,
        signOutDateBefore,
        finalizedAtAfter,
        finalizedAtBefore,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        diagnosesDiagnosis,
        diagnosesMicroscopic,
        diagnosesReportSignedAfter,
        diagnosesReportSignedBefore,
        status,
        activeAssignmentEmail,
        activeAssignmentUsername,
        activeAssignmentName,
        collectedDateAfter,
        collectedDateBefore,
        receivedDateAfter,
        receivedDateBefore,
        source,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        note,
        isScreening,
        isRequestScreenComplete,
        biopsyType,
        specimensClinicalHistory,
        diagnosisCategory,
        anyDiagnosticText,
        allSlidesSuccess,
        allOrderedDocumentsUploaded,
        hasFlaggedSlides,
        hasActivePrelimReport,
        hasIncompleteOrders,
        hasActiveNoAdditionalOrders,
        hasActiveAdditionalOrders,
        hasUnviewedSlides,
        today,
        tomorrow,
        fields,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** accession **/
        accession?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** external_accession **/
        externalAccession?: string,
        /** patient__first_name **/
        patientFirstName?: string,
        /** patient__last_name **/
        patientLastName?: string,
        /** patient_name **/
        patientName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** created_at **/
        createdAt?: string,
        /** updated_at **/
        updatedAt?: string,
        /** unviewed **/
        unviewed?: string,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor__first_name **/
        orderingDoctorFirstName?: string,
        /** ordering_doctor__last_name **/
        orderingDoctorLastName?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** diagnoses__diagnosis **/
        diagnosesDiagnosis?: string,
        /** diagnoses__microscopic **/
        diagnosesMicroscopic?: string,
        /** diagnoses__report_signed_after **/
        diagnosesReportSignedAfter?: string,
        /** diagnoses__report_signed_before **/
        diagnosesReportSignedBefore?: string,
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** source **/
        source?: string,
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** note **/
        note?: string,
        /** is_screening **/
        isScreening?: string,
        /** is_request_screen_complete **/
        isRequestScreenComplete?: string,
        /** biopsy_type **/
        biopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** diagnosis_category **/
        diagnosisCategory?: 'ASL' | 'BCC' | 'MEL' | 'SK' | 'VV' | 'INCONCLUSIVE',
        /** any_diagnostic_text **/
        anyDiagnosticText?: string,
        /** all_slides_success **/
        allSlidesSuccess?: string,
        /** all_ordered_documents_uploaded **/
        allOrderedDocumentsUploaded?: string,
        /** has_flagged_slides **/
        hasFlaggedSlides?: string,
        /** has_active_prelim_report **/
        hasActivePrelimReport?: string,
        /** has_incomplete_orders **/
        hasIncompleteOrders?: string,
        /** has_active_no_additional_orders **/
        hasActiveNoAdditionalOrders?: string,
        /** has_active_additional_orders **/
        hasActiveAdditionalOrders?: string,
        /** has_unviewed_slides **/
        hasUnviewedSlides?: string,
        /** today **/
        today?: string,
        /** tomorrow **/
        tomorrow?: string,
        /** fields **/
        fields?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Cases>,
        count_specimen?: number,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/`,
            query: {
                'limit': limit,
                'offset': offset,
                'accession': accession,
                'accessioning_lab': accessioningLab,
                'external_accession': externalAccession,
                'patient__first_name': patientFirstName,
                'patient__last_name': patientLastName,
                'patient_name': patientName,
                'patient__date_of_birth': patientDateOfBirth,
                'created_at': createdAt,
                'updated_at': updatedAt,
                'unviewed': unviewed,
                'patient__clinic__name': patientClinicName,
                'lab': lab,
                'ordering_doctor__first_name': orderingDoctorFirstName,
                'ordering_doctor__last_name': orderingDoctorLastName,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'diagnoses__diagnosis': diagnosesDiagnosis,
                'diagnoses__microscopic': diagnosesMicroscopic,
                'diagnoses__report_signed_after': diagnosesReportSignedAfter,
                'diagnoses__report_signed_before': diagnosesReportSignedBefore,
                'status': status,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'source': source,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'note': note,
                'is_screening': isScreening,
                'is_request_screen_complete': isRequestScreenComplete,
                'biopsy_type': biopsyType,
                'specimens__clinical_history': specimensClinicalHistory,
                'diagnosis_category': diagnosisCategory,
                'any_diagnostic_text': anyDiagnosticText,
                'all_slides_success': allSlidesSuccess,
                'all_ordered_documents_uploaded': allOrderedDocumentsUploaded,
                'has_flagged_slides': hasFlaggedSlides,
                'has_active_prelim_report': hasActivePrelimReport,
                'has_incomplete_orders': hasIncompleteOrders,
                'has_active_no_additional_orders': hasActiveNoAdditionalOrders,
                'has_active_additional_orders': hasActiveAdditionalOrders,
                'has_unviewed_slides': hasUnviewedSlides,
                'today': today,
                'tomorrow': tomorrow,
                'fields': fields,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns AccessionPrefix
     * @throws ApiError
     */
    public static async prefixesCase(): Promise<Array<AccessionPrefix>> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/prefixes/`,
        });
        return result.body;
    }

    /**
     * @returns Case
     * @throws ApiError
     */
    public static async retrieveCase({
        id,
        accession,
        accessioningLab,
        externalAccession,
        patientFirstName,
        patientLastName,
        patientName,
        patientDateOfBirth,
        createdAt,
        updatedAt,
        patientClinicName,
        lab,
        orderingDoctorFirstName,
        orderingDoctorLastName,
        orderingDoctorName,
        priority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        signOutDateAfter,
        signOutDateBefore,
        finalizedAtAfter,
        finalizedAtBefore,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        diagnosesDiagnosis,
        diagnosesMicroscopic,
        diagnosesReportSignedAfter,
        diagnosesReportSignedBefore,
        status,
        activeAssignmentEmail,
        activeAssignmentUsername,
        activeAssignmentName,
        collectedDateAfter,
        collectedDateBefore,
        receivedDateAfter,
        receivedDateBefore,
        source,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        note,
        isScreening,
        isRequestScreenComplete,
        biopsyType,
        specimensClinicalHistory,
        diagnosisCategory,
        anyDiagnosticText,
        allSlidesSuccess,
        allOrderedDocumentsUploaded,
        hasFlaggedSlides,
        hasActivePrelimReport,
        hasIncompleteOrders,
        hasActiveNoAdditionalOrders,
        hasActiveAdditionalOrders,
        hasUnviewedSlides,
        today,
        tomorrow,
        fields,
        ordering,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        /** accession **/
        accession?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** external_accession **/
        externalAccession?: string,
        /** patient__first_name **/
        patientFirstName?: string,
        /** patient__last_name **/
        patientLastName?: string,
        /** patient_name **/
        patientName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** created_at **/
        createdAt?: string,
        /** updated_at **/
        updatedAt?: string,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor__first_name **/
        orderingDoctorFirstName?: string,
        /** ordering_doctor__last_name **/
        orderingDoctorLastName?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** diagnoses__diagnosis **/
        diagnosesDiagnosis?: string,
        /** diagnoses__microscopic **/
        diagnosesMicroscopic?: string,
        /** diagnoses__report_signed_after **/
        diagnosesReportSignedAfter?: string,
        /** diagnoses__report_signed_before **/
        diagnosesReportSignedBefore?: string,
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** source **/
        source?: string,
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** note **/
        note?: string,
        /** is_screening **/
        isScreening?: string,
        /** is_request_screen_complete **/
        isRequestScreenComplete?: string,
        /** biopsy_type **/
        biopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** diagnosis_category **/
        diagnosisCategory?: 'ASL' | 'BCC' | 'MEL' | 'SK' | 'VV' | 'INCONCLUSIVE',
        /** any_diagnostic_text **/
        anyDiagnosticText?: string,
        /** all_slides_success **/
        allSlidesSuccess?: string,
        /** all_ordered_documents_uploaded **/
        allOrderedDocumentsUploaded?: string,
        /** has_flagged_slides **/
        hasFlaggedSlides?: string,
        /** has_active_prelim_report **/
        hasActivePrelimReport?: string,
        /** has_incomplete_orders **/
        hasIncompleteOrders?: string,
        /** has_active_no_additional_orders **/
        hasActiveNoAdditionalOrders?: string,
        /** has_active_additional_orders **/
        hasActiveAdditionalOrders?: string,
        /** has_unviewed_slides **/
        hasUnviewedSlides?: string,
        /** today **/
        today?: string,
        /** tomorrow **/
        tomorrow?: string,
        /** fields **/
        fields?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<Case> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${id}/`,
            query: {
                'accession': accession,
                'accessioning_lab': accessioningLab,
                'external_accession': externalAccession,
                'patient__first_name': patientFirstName,
                'patient__last_name': patientLastName,
                'patient_name': patientName,
                'patient__date_of_birth': patientDateOfBirth,
                'created_at': createdAt,
                'updated_at': updatedAt,
                'patient__clinic__name': patientClinicName,
                'lab': lab,
                'ordering_doctor__first_name': orderingDoctorFirstName,
                'ordering_doctor__last_name': orderingDoctorLastName,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'diagnoses__diagnosis': diagnosesDiagnosis,
                'diagnoses__microscopic': diagnosesMicroscopic,
                'diagnoses__report_signed_after': diagnosesReportSignedAfter,
                'diagnoses__report_signed_before': diagnosesReportSignedBefore,
                'status': status,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'source': source,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'note': note,
                'is_screening': isScreening,
                'is_request_screen_complete': isRequestScreenComplete,
                'biopsy_type': biopsyType,
                'specimens__clinical_history': specimensClinicalHistory,
                'diagnosis_category': diagnosisCategory,
                'any_diagnostic_text': anyDiagnosticText,
                'all_slides_success': allSlidesSuccess,
                'all_ordered_documents_uploaded': allOrderedDocumentsUploaded,
                'has_flagged_slides': hasFlaggedSlides,
                'has_active_prelim_report': hasActivePrelimReport,
                'has_incomplete_orders': hasIncompleteOrders,
                'has_active_no_additional_orders': hasActiveNoAdditionalOrders,
                'has_active_additional_orders': hasActiveAdditionalOrders,
                'has_unviewed_slides': hasUnviewedSlides,
                'today': today,
                'tomorrow': tomorrow,
                'fields': fields,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async updateCase({
        id,
        accession,
        accessioningLab,
        externalAccession,
        patientFirstName,
        patientLastName,
        patientName,
        patientDateOfBirth,
        createdAt,
        updatedAt,
        patientClinicName,
        lab,
        orderingDoctorFirstName,
        orderingDoctorLastName,
        orderingDoctorName,
        priority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        signOutDateAfter,
        signOutDateBefore,
        finalizedAtAfter,
        finalizedAtBefore,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        diagnosesDiagnosis,
        diagnosesMicroscopic,
        diagnosesReportSignedAfter,
        diagnosesReportSignedBefore,
        status,
        activeAssignmentEmail,
        activeAssignmentUsername,
        activeAssignmentName,
        collectedDateAfter,
        collectedDateBefore,
        receivedDateAfter,
        receivedDateBefore,
        source,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        note,
        isScreening,
        isRequestScreenComplete,
        biopsyType,
        specimensClinicalHistory,
        diagnosisCategory,
        anyDiagnosticText,
        allSlidesSuccess,
        allOrderedDocumentsUploaded,
        hasFlaggedSlides,
        hasActivePrelimReport,
        hasIncompleteOrders,
        hasActiveNoAdditionalOrders,
        hasActiveAdditionalOrders,
        hasUnviewedSlides,
        today,
        tomorrow,
        fields,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        /** accession **/
        accession?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** external_accession **/
        externalAccession?: string,
        /** patient__first_name **/
        patientFirstName?: string,
        /** patient__last_name **/
        patientLastName?: string,
        /** patient_name **/
        patientName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** created_at **/
        createdAt?: string,
        /** updated_at **/
        updatedAt?: string,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor__first_name **/
        orderingDoctorFirstName?: string,
        /** ordering_doctor__last_name **/
        orderingDoctorLastName?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** diagnoses__diagnosis **/
        diagnosesDiagnosis?: string,
        /** diagnoses__microscopic **/
        diagnosesMicroscopic?: string,
        /** diagnoses__report_signed_after **/
        diagnosesReportSignedAfter?: string,
        /** diagnoses__report_signed_before **/
        diagnosesReportSignedBefore?: string,
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** source **/
        source?: string,
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** note **/
        note?: string,
        /** is_screening **/
        isScreening?: string,
        /** is_request_screen_complete **/
        isRequestScreenComplete?: string,
        /** biopsy_type **/
        biopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** diagnosis_category **/
        diagnosisCategory?: 'ASL' | 'BCC' | 'MEL' | 'SK' | 'VV' | 'INCONCLUSIVE',
        /** any_diagnostic_text **/
        anyDiagnosticText?: string,
        /** all_slides_success **/
        allSlidesSuccess?: string,
        /** all_ordered_documents_uploaded **/
        allOrderedDocumentsUploaded?: string,
        /** has_flagged_slides **/
        hasFlaggedSlides?: string,
        /** has_active_prelim_report **/
        hasActivePrelimReport?: string,
        /** has_incomplete_orders **/
        hasIncompleteOrders?: string,
        /** has_active_no_additional_orders **/
        hasActiveNoAdditionalOrders?: string,
        /** has_active_additional_orders **/
        hasActiveAdditionalOrders?: string,
        /** has_unviewed_slides **/
        hasUnviewedSlides?: string,
        /** today **/
        today?: string,
        /** tomorrow **/
        tomorrow?: string,
        /** fields **/
        fields?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'PUT',
            path: `/api/cases/${id}/`,
            query: {
                'accession': accession,
                'accessioning_lab': accessioningLab,
                'external_accession': externalAccession,
                'patient__first_name': patientFirstName,
                'patient__last_name': patientLastName,
                'patient_name': patientName,
                'patient__date_of_birth': patientDateOfBirth,
                'created_at': createdAt,
                'updated_at': updatedAt,
                'patient__clinic__name': patientClinicName,
                'lab': lab,
                'ordering_doctor__first_name': orderingDoctorFirstName,
                'ordering_doctor__last_name': orderingDoctorLastName,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'diagnoses__diagnosis': diagnosesDiagnosis,
                'diagnoses__microscopic': diagnosesMicroscopic,
                'diagnoses__report_signed_after': diagnosesReportSignedAfter,
                'diagnoses__report_signed_before': diagnosesReportSignedBefore,
                'status': status,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'source': source,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'note': note,
                'is_screening': isScreening,
                'is_request_screen_complete': isRequestScreenComplete,
                'biopsy_type': biopsyType,
                'specimens__clinical_history': specimensClinicalHistory,
                'diagnosis_category': diagnosisCategory,
                'any_diagnostic_text': anyDiagnosticText,
                'all_slides_success': allSlidesSuccess,
                'all_ordered_documents_uploaded': allOrderedDocumentsUploaded,
                'has_flagged_slides': hasFlaggedSlides,
                'has_active_prelim_report': hasActivePrelimReport,
                'has_incomplete_orders': hasIncompleteOrders,
                'has_active_no_additional_orders': hasActiveNoAdditionalOrders,
                'has_active_additional_orders': hasActiveAdditionalOrders,
                'has_unviewed_slides': hasUnviewedSlides,
                'today': today,
                'tomorrow': tomorrow,
                'fields': fields,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CasePATCH
     * @throws ApiError
     */
    public static async partialUpdateCase({
        id,
        accession,
        accessioningLab,
        externalAccession,
        patientFirstName,
        patientLastName,
        patientName,
        patientDateOfBirth,
        createdAt,
        updatedAt,
        patientClinicName,
        lab,
        orderingDoctorFirstName,
        orderingDoctorLastName,
        orderingDoctorName,
        priority,
        grossCompletedAfter,
        grossCompletedBefore,
        accessionCompletedAfter,
        accessionCompletedBefore,
        signOutDateAfter,
        signOutDateBefore,
        finalizedAtAfter,
        finalizedAtBefore,
        slideUploadedAtAfter,
        slideUploadedAtBefore,
        diagnosesDiagnosis,
        diagnosesMicroscopic,
        diagnosesReportSignedAfter,
        diagnosesReportSignedBefore,
        status,
        activeAssignmentEmail,
        activeAssignmentUsername,
        activeAssignmentName,
        collectedDateAfter,
        collectedDateBefore,
        receivedDateAfter,
        receivedDateBefore,
        source,
        specimensProcedure,
        specimensType,
        specimensSource,
        specimensSite,
        note,
        isScreening,
        isRequestScreenComplete,
        biopsyType,
        specimensClinicalHistory,
        diagnosisCategory,
        anyDiagnosticText,
        allSlidesSuccess,
        allOrderedDocumentsUploaded,
        hasFlaggedSlides,
        hasActivePrelimReport,
        hasIncompleteOrders,
        hasActiveNoAdditionalOrders,
        hasActiveAdditionalOrders,
        hasUnviewedSlides,
        today,
        tomorrow,
        fields,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        /** accession **/
        accession?: string,
        /** accessioning_lab **/
        accessioningLab?: string,
        /** external_accession **/
        externalAccession?: string,
        /** patient__first_name **/
        patientFirstName?: string,
        /** patient__last_name **/
        patientLastName?: string,
        /** patient_name **/
        patientName?: string,
        /** patient__date_of_birth **/
        patientDateOfBirth?: string,
        /** created_at **/
        createdAt?: string,
        /** updated_at **/
        updatedAt?: string,
        /** patient__clinic__name **/
        patientClinicName?: string,
        /** lab **/
        lab?: string,
        /** ordering_doctor__first_name **/
        orderingDoctorFirstName?: string,
        /** ordering_doctor__last_name **/
        orderingDoctorLastName?: string,
        /** ordering_doctor_name **/
        orderingDoctorName?: string,
        /** priority **/
        priority?: string,
        /** gross_completed_after **/
        grossCompletedAfter?: string,
        /** gross_completed_before **/
        grossCompletedBefore?: string,
        /** accession_completed_after **/
        accessionCompletedAfter?: string,
        /** accession_completed_before **/
        accessionCompletedBefore?: string,
        /** sign_out_date_after **/
        signOutDateAfter?: string,
        /** sign_out_date_before **/
        signOutDateBefore?: string,
        /** finalized_at_after **/
        finalizedAtAfter?: string,
        /** finalized_at_before **/
        finalizedAtBefore?: string,
        /** slide_uploaded_at_after **/
        slideUploadedAtAfter?: string,
        /** slide_uploaded_at_before **/
        slideUploadedAtBefore?: string,
        /** diagnoses__diagnosis **/
        diagnosesDiagnosis?: string,
        /** diagnoses__microscopic **/
        diagnosesMicroscopic?: string,
        /** diagnoses__report_signed_after **/
        diagnosesReportSignedAfter?: string,
        /** diagnoses__report_signed_before **/
        diagnosesReportSignedBefore?: string,
        /** status **/
        status?: 'ordered' | 'active' | 'working' | 'flagged' | 'finalized' | 'deleted' | 'archived' | 'lis-pending' | 'error',
        /** active_assignment__email **/
        activeAssignmentEmail?: string,
        /** active_assignment__username **/
        activeAssignmentUsername?: string,
        /** active_assignment_name **/
        activeAssignmentName?: string,
        /** collected_date_after **/
        collectedDateAfter?: string,
        /** collected_date_before **/
        collectedDateBefore?: string,
        /** received_date_after **/
        receivedDateAfter?: string,
        /** received_date_before **/
        receivedDateBefore?: string,
        /** source **/
        source?: string,
        /** specimens__procedure **/
        specimensProcedure?: 'c' | 'e' | 'pe' | 'ib' | 'nc' | 'na' | 'pb' | 'sb' | 'sbd' | 'sce' | 'sr' | 'srd' | 'snb' | 'gr' | 'se' | 'ebx' | 'fb' | 'mohs' | 'dblk' | 'u' | 'o',
        /** specimens__type **/
        specimensType?: 'MUCOSA' | 'SKIN' | 'NAIL' | 'SOFT TISSUE' | 'OTHER' | 'UNKNOWN',
        /** specimens__source **/
        specimensSource?: string,
        /** specimens__site **/
        specimensSite?: string,
        /** note **/
        note?: string,
        /** is_screening **/
        isScreening?: string,
        /** is_request_screen_complete **/
        isRequestScreenComplete?: string,
        /** biopsy_type **/
        biopsyType?: 'PUNCH' | 'SHAVE' | 'EXCISION' | 'UNKNOWN',
        /** specimens__clinical_history **/
        specimensClinicalHistory?: string,
        /** diagnosis_category **/
        diagnosisCategory?: 'ASL' | 'BCC' | 'MEL' | 'SK' | 'VV' | 'INCONCLUSIVE',
        /** any_diagnostic_text **/
        anyDiagnosticText?: string,
        /** all_slides_success **/
        allSlidesSuccess?: string,
        /** all_ordered_documents_uploaded **/
        allOrderedDocumentsUploaded?: string,
        /** has_flagged_slides **/
        hasFlaggedSlides?: string,
        /** has_active_prelim_report **/
        hasActivePrelimReport?: string,
        /** has_incomplete_orders **/
        hasIncompleteOrders?: string,
        /** has_active_no_additional_orders **/
        hasActiveNoAdditionalOrders?: string,
        /** has_active_additional_orders **/
        hasActiveAdditionalOrders?: string,
        /** has_unviewed_slides **/
        hasUnviewedSlides?: string,
        /** today **/
        today?: string,
        /** tomorrow **/
        tomorrow?: string,
        /** fields **/
        fields?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: CasePATCH,
    }): Promise<CasePATCH> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/cases/${id}/`,
            query: {
                'accession': accession,
                'accessioning_lab': accessioningLab,
                'external_accession': externalAccession,
                'patient__first_name': patientFirstName,
                'patient__last_name': patientLastName,
                'patient_name': patientName,
                'patient__date_of_birth': patientDateOfBirth,
                'created_at': createdAt,
                'updated_at': updatedAt,
                'patient__clinic__name': patientClinicName,
                'lab': lab,
                'ordering_doctor__first_name': orderingDoctorFirstName,
                'ordering_doctor__last_name': orderingDoctorLastName,
                'ordering_doctor_name': orderingDoctorName,
                'priority': priority,
                'gross_completed_after': grossCompletedAfter,
                'gross_completed_before': grossCompletedBefore,
                'accession_completed_after': accessionCompletedAfter,
                'accession_completed_before': accessionCompletedBefore,
                'sign_out_date_after': signOutDateAfter,
                'sign_out_date_before': signOutDateBefore,
                'finalized_at_after': finalizedAtAfter,
                'finalized_at_before': finalizedAtBefore,
                'slide_uploaded_at_after': slideUploadedAtAfter,
                'slide_uploaded_at_before': slideUploadedAtBefore,
                'diagnoses__diagnosis': diagnosesDiagnosis,
                'diagnoses__microscopic': diagnosesMicroscopic,
                'diagnoses__report_signed_after': diagnosesReportSignedAfter,
                'diagnoses__report_signed_before': diagnosesReportSignedBefore,
                'status': status,
                'active_assignment__email': activeAssignmentEmail,
                'active_assignment__username': activeAssignmentUsername,
                'active_assignment_name': activeAssignmentName,
                'collected_date_after': collectedDateAfter,
                'collected_date_before': collectedDateBefore,
                'received_date_after': receivedDateAfter,
                'received_date_before': receivedDateBefore,
                'source': source,
                'specimens__procedure': specimensProcedure,
                'specimens__type': specimensType,
                'specimens__source': specimensSource,
                'specimens__site': specimensSite,
                'note': note,
                'is_screening': isScreening,
                'is_request_screen_complete': isRequestScreenComplete,
                'biopsy_type': biopsyType,
                'specimens__clinical_history': specimensClinicalHistory,
                'diagnosis_category': diagnosisCategory,
                'any_diagnostic_text': anyDiagnosticText,
                'all_slides_success': allSlidesSuccess,
                'all_ordered_documents_uploaded': allOrderedDocumentsUploaded,
                'has_flagged_slides': hasFlaggedSlides,
                'has_active_prelim_report': hasActivePrelimReport,
                'has_incomplete_orders': hasIncompleteOrders,
                'has_active_no_additional_orders': hasActiveNoAdditionalOrders,
                'has_active_additional_orders': hasActiveAdditionalOrders,
                'has_unviewed_slides': hasUnviewedSlides,
                'today': today,
                'tomorrow': tomorrow,
                'fields': fields,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async copathMatchesCase({
        id,
        h,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        h?: string,
    }): Promise<Cases> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${id}/copath_matches/`,
            // TODO: Make this official OpenAPI. It is here for cache-busting, this parameter does nothing on the backend
            query: {
                'h': h
            },
        });
        return result.body;
    }

    /**
     * @returns CaseDiagnosis
     * @throws ApiError
     */
    public static async diagnosesCase({
        id,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<Array<CaseDiagnosis>> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${id}/diagnoses/`,
        });
        return result.body;
    }

    /**
     * @returns LISEvent
     * @throws ApiError
     */
    public static async lisHistoryCase({
        id,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<Array<LISEvent>> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${id}/lis-history/`,
        });
        return result.body;
    }

    /**
     * @returns LISWork
     * @throws ApiError
     */
    public static async lisStatusCase({
        id,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<Array<LISWork>> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${id}/lis-status/`,
        });
        return result.body;
    }

    /**
     * Searches for all cases from the same person.  Because the current model is a 1:1 relationship
     * between Patient and Case, we have to search all the patients who are actually the same person with
     * different cases.  This function will pull the Patient object from the Case requested in the GET request,
     * and will then search all patients with the same first name, last name, and date of birth.  We then
     * return all the cases for those patients.
     * @returns CaseMatches
     * @throws ApiError
     */
    public static async matchesCase({
        id,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<CaseMatches> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${id}/matches/`,
        });
        return result.body;
    }

    /**
     * Nested slide annotations viewsets: /api/cases/<case id>/documents/*
     * @returns CaseDocumentWithPresignedUrl
     * @throws ApiError
     */
    public static async retrieveCaseDocument({
        parentLookupCaseId,
        id,
        source,
    }: {
        parentLookupCaseId: number,
        /** A unique integer value identifying this case document. **/
        id: number,
        /** From what list the user is viewing the document **/
        source?: string,
    }): Promise<CaseDocumentWithPresignedUrl> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${parentLookupCaseId}/documents/${id}/`,
            query: {
                'source': source,
            },
        });
        return result.body;
    }

    /**
     * Nested slide annotations viewsets: /api/cases/<case id>/documents/*
     * @returns CaseDocumentWithPresignedUrl
     * @throws ApiError
     */
    public static async updateCaseDocument({
        parentLookupCaseId,
        id,
        source,
        requestBody,
    }: {
        parentLookupCaseId: number,
        /** A unique integer value identifying this case document. **/
        id: number,
        /** From what list the user is viewing the document **/
        source?: string,
        requestBody?: CaseDocumentWithPresignedUrl,
    }): Promise<CaseDocumentWithPresignedUrl> {
        const result = await __request({
            method: 'PUT',
            path: `/api/cases/${parentLookupCaseId}/documents/${id}/`,
            query: {
                'source': source,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Nested slide annotations viewsets: /api/cases/<case id>/documents/*
     * @returns CaseDocumentWithPresignedUrl
     * @throws ApiError
     */
    public static async partialUpdateCaseDocument({
        parentLookupCaseId,
        id,
        source,
        requestBody,
    }: {
        parentLookupCaseId: number,
        /** A unique integer value identifying this case document. **/
        id: number,
        /** From what list the user is viewing the document **/
        source?: string,
        requestBody?: CaseDocumentWithPresignedUrl,
    }): Promise<CaseDocumentWithPresignedUrl> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/cases/${parentLookupCaseId}/documents/${id}/`,
            query: {
                'source': source,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCaseEventLogs({
        parentLookupCaseId,
        limit,
        offset,
        event,
        authorId,
        associatedUserId,
    }: {
        parentLookupCaseId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** event **/
        event?: 'received-sign-out' | 'accession-done' | 'gross-done' | 'stain-order-wpl' | 'rescan-archival' | 'rescan-quality' | 'slide-added' | 'archived-by-clinic-rule' | 'screen-done' | 'signed-out' | 'amended' | 'addended' | 'corrected' | 'preliminary' | 'assign-screener' | 'assign-signer',
        /** author_id **/
        authorId?: number,
        /** associated_user_id **/
        associatedUserId?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CaseEventLog>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${parentLookupCaseId}/events/`,
            query: {
                'limit': limit,
                'offset': offset,
                'event': event,
                'author_id': authorId,
                'associated_user_id': associatedUserId,
            },
        });
        return result.body;
    }

    /**
     * Nested case report viewsets: /api/cases/<case_id>/report/<case_report_id>
     * @returns CaseReport
     * @throws ApiError
     */
    public static async retrieveCaseReport({
        parentLookupCaseId,
        id,
    }: {
        parentLookupCaseId: number,
        /** A unique integer value identifying this case report. **/
        id: number,
    }): Promise<CaseReport> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${parentLookupCaseId}/report/${id}/`,
        });
        return result.body;
    }

    /**
     * Alpha implementation of Case and Specimen level classification results. This has a few gotchas:
     * * It's named for Specimen but the list action (GET /api/cases/id/specimen-classifications/) returns results per case
     * * The retrieve action (GET /api/cases/id/specimen-classifications/id/) returns results per specimen
     * * Related tests aren't checking happy path, and default results are pretty flat (need lesion line, subtype results)
     * @returns any
     * @throws ApiError
     */
    public static async listSpecimenClassifications({
        parentLookupCaseId,
        limit,
        offset,
    }: {
        parentLookupCaseId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<SlideClassification>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${parentLookupCaseId}/specimen-classifications/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * Alpha implementation of Case and Specimen level classification results. This has a few gotchas:
     * * It's named for Specimen but the list action (GET /api/cases/id/specimen-classifications/) returns results per case
     * * The retrieve action (GET /api/cases/id/specimen-classifications/id/) returns results per specimen
     * * Related tests aren't checking happy path, and default results are pretty flat (need lesion line, subtype results)
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async retrieveSpecimenClassification({
        parentLookupCaseId,
        id,
    }: {
        parentLookupCaseId: number,
        /** A unique integer value identifying this slide classification. **/
        id: number,
    }): Promise<SlideClassification> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${parentLookupCaseId}/specimen-classifications/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCaseQaReviews({
        parentLookupCaseId,
        limit,
        offset,
    }: {
        parentLookupCaseId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CaseQAReview>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${parentLookupCaseId}/reviews/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCaseDisclaimersPreviews({
        parentLookupCaseId,
        limit,
        offset,
    }: {
        parentLookupCaseId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CaseDisclaimerPreview>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/cases/${parentLookupCaseId}/disclaimers/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listSlides({
        limit,
        offset,
        accessionNumber,
        labName,
        caseAccession,
        status,
        accessionPrefixPrefix,
        labStationType,
        labStationLabName,
        lisState,
        ordering,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** accession_number **/
        accessionNumber?: string,
        /** lab__name **/
        labName?: string,
        /** case__accession **/
        caseAccession?: string,
        /** status **/
        status?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** accession_prefix__prefix **/
        accessionPrefixPrefix?: string,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unstained' | 'racked' | 'stained' | 'scanning' | 'scanned',
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Slide>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/slides/`,
            query: {
                'limit': limit,
                'offset': offset,
                'accession_number': accessionNumber,
                'lab__name': labName,
                'case__accession': caseAccession,
                'status': status,
                'accession_prefix__prefix': accessionPrefixPrefix,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns Slide
     * @throws ApiError
     */
    public static async retrieveSlide({
        id,
        accessionNumber,
        labName,
        caseAccession,
        status,
        accessionPrefixPrefix,
        labStationType,
        labStationLabName,
        lisState,
        ordering,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        /** accession_number **/
        accessionNumber?: string,
        /** lab__name **/
        labName?: string,
        /** case__accession **/
        caseAccession?: string,
        /** status **/
        status?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** accession_prefix__prefix **/
        accessionPrefixPrefix?: string,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unstained' | 'racked' | 'stained' | 'scanning' | 'scanned',
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<Slide> {
        const result = await __request({
            method: 'GET',
            path: `/api/slides/${id}/`,
            query: {
                'accession_number': accessionNumber,
                'lab__name': labName,
                'case__accession': caseAccession,
                'status': status,
                'accession_prefix__prefix': accessionPrefixPrefix,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns Slide
     * @throws ApiError
     */
    public static async updateSlide({
        id,
        accessionNumber,
        labName,
        caseAccession,
        status,
        accessionPrefixPrefix,
        labStationType,
        labStationLabName,
        lisState,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        /** accession_number **/
        accessionNumber?: string,
        /** lab__name **/
        labName?: string,
        /** case__accession **/
        caseAccession?: string,
        /** status **/
        status?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** accession_prefix__prefix **/
        accessionPrefixPrefix?: string,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unstained' | 'racked' | 'stained' | 'scanning' | 'scanned',
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: Slide,
    }): Promise<Slide> {
        const result = await __request({
            method: 'PUT',
            path: `/api/slides/${id}/`,
            query: {
                'accession_number': accessionNumber,
                'lab__name': labName,
                'case__accession': caseAccession,
                'status': status,
                'accession_prefix__prefix': accessionPrefixPrefix,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Slide
     * @throws ApiError
     */
    public static async partialUpdateSlide({
        id,
        accessionNumber,
        labName,
        caseAccession,
        status,
        accessionPrefixPrefix,
        labStationType,
        labStationLabName,
        lisState,
        ordering,
        requestBody,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        /** accession_number **/
        accessionNumber?: string,
        /** lab__name **/
        labName?: string,
        /** case__accession **/
        caseAccession?: string,
        /** status **/
        status?: 'received-wpl' | 'received-lab' | 'pending' | 'precomputing' | 'uploaded' | 'error' | 'manual-merge' | 'manual-review' | 'success' | 'pending-ai' | 'deleted' | 'archived' | 'on-hold' | 'processing',
        /** accession_prefix__prefix **/
        accessionPrefixPrefix?: string,
        /** lab_station__type **/
        labStationType?: string,
        /** lab_station__lab__name **/
        labStationLabName?: string,
        /** lis_state **/
        lisState?: 'unstained' | 'racked' | 'stained' | 'scanning' | 'scanned',
        /** Which field to use when ordering the results. **/
        ordering?: string,
        requestBody?: Slide,
    }): Promise<Slide> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/slides/${id}/`,
            query: {
                'accession_number': accessionNumber,
                'lab__name': labName,
                'case__accession': caseAccession,
                'status': status,
                'accession_prefix__prefix': accessionPrefixPrefix,
                'lab_station__type': labStationType,
                'lab_station__lab__name': labStationLabName,
                'lis_state': lisState,
                'ordering': ordering,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns string
     * @throws ApiError
     */
    public static async barcodeUrlSlide({
        id,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
    }): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/api/slides/${id}/barcode_url/`,
        });
        return result.body;
    }

    /**
     * @returns string
     * @throws ApiError
     */
    public static async macroUrlSlide({
        id,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
    }): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/api/slides/${id}/macro_url/`,
        });
        return result.body;
    }

    /**
     * @returns number
     * @throws ApiError
     */
    public static async slideClassificationIdsSlide({
        id,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
    }): Promise<Array<number>> {
        const result = await __request({
            method: 'GET',
            path: `/api/slides/${id}/slide_classification_ids/`,
        });
        return result.body;
    }

    /**
     * Nested slide annotations viewsets: /api/slides/<slide id>/annotations/*
     * @returns any
     * @throws ApiError
     */
    public static async listSlideAnnotations({
        parentLookupSlideId,
        limit,
        offset,
    }: {
        parentLookupSlideId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<SlideAnnotation>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/slides/${parentLookupSlideId}/annotations/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * Nested slide annotations viewsets: /api/slides/<slide id>/annotations/*
     * @returns SlideAnnotation
     * @throws ApiError
     */
    public static async createSlideAnnotation({
        parentLookupSlideId,
        requestBody,
    }: {
        parentLookupSlideId: number,
        requestBody?: SlideAnnotation,
    }): Promise<SlideAnnotation> {
        const result = await __request({
            method: 'POST',
            path: `/api/slides/${parentLookupSlideId}/annotations/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Nested slide annotations viewsets: /api/slides/<slide id>/annotations/*
     * @returns SlideAnnotation
     * @throws ApiError
     */
    public static async retrieveSlideAnnotation({
        parentLookupSlideId,
        id,
    }: {
        parentLookupSlideId: number,
        /** A unique integer value identifying this slide annotation. **/
        id: number,
    }): Promise<SlideAnnotation> {
        const result = await __request({
            method: 'GET',
            path: `/api/slides/${parentLookupSlideId}/annotations/${id}/`,
        });
        return result.body;
    }

    /**
     * Nested slide annotations viewsets: /api/slides/<slide id>/annotations/*
     * @returns SlideAnnotation
     * @throws ApiError
     */
    public static async partialUpdateSlideAnnotation({
        parentLookupSlideId,
        id,
        requestBody,
    }: {
        parentLookupSlideId: number,
        /** A unique integer value identifying this slide annotation. **/
        id: number,
        requestBody?: SlideAnnotation,
    }): Promise<SlideAnnotation> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/slides/${parentLookupSlideId}/annotations/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Nested slide annotations viewsets: /api/slides/<slide id>/annotations/*
     * @returns void
     * @throws ApiError
     */
    public static async destroySlideAnnotation({
        parentLookupSlideId,
        id,
    }: {
        parentLookupSlideId: number,
        /** A unique integer value identifying this slide annotation. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/slides/${parentLookupSlideId}/annotations/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listSlideFlags({
        parentLookupSlideId,
        limit,
        offset,
        ordering,
    }: {
        parentLookupSlideId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<SlideFlag>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/slides/${parentLookupSlideId}/flags/`,
            query: {
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns SlideFlagPOST
     * @throws ApiError
     */
    public static async createSlideFlag({
        parentLookupSlideId,
        requestBody,
    }: {
        parentLookupSlideId: number,
        requestBody?: SlideFlagPOST,
    }): Promise<SlideFlagPOST> {
        const result = await __request({
            method: 'POST',
            path: `/api/slides/${parentLookupSlideId}/flags/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabs({
        limit,
        offset,
        name,
    }: {
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Lab>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
            },
        });
        return result.body;
    }

    /**
     * @returns Lab
     * @throws ApiError
     */
    public static async configLab(): Promise<Lab> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/config/`,
        });
        return result.body;
    }

    /**
     * @returns Lab
     * @throws ApiError
     */
    public static async retrieveLab({
        id,
        name,
    }: {
        /** A unique integer value identifying this lab. **/
        id: number,
        /** name **/
        name?: string,
    }): Promise<Lab> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${id}/`,
            query: {
                'name': name,
            },
        });
        return result.body;
    }

    /**
     * @returns Lab
     * @throws ApiError
     */
    public static async updateLab({
        id,
        name,
        requestBody,
    }: {
        /** A unique integer value identifying this lab. **/
        id: number,
        /** name **/
        name?: string,
        requestBody?: Lab,
    }): Promise<Lab> {
        const result = await __request({
            method: 'PUT',
            path: `/api/labs/${id}/`,
            query: {
                'name': name,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Lab
     * @throws ApiError
     */
    public static async partialUpdateLab({
        id,
        name,
        requestBody,
    }: {
        /** A unique integer value identifying this lab. **/
        id: number,
        /** name **/
        name?: string,
        requestBody?: Lab,
    }): Promise<Lab> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/labs/${id}/`,
            query: {
                'name': name,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabStations({
        parentLookupLabId,
        limit,
        offset,
    }: {
        parentLookupLabId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<LabStation>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/station/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns LabStation
     * @throws ApiError
     */
    public static async createLabStation({
        parentLookupLabId,
        requestBody,
    }: {
        parentLookupLabId: number,
        requestBody?: LabStation,
    }): Promise<LabStation> {
        const result = await __request({
            method: 'POST',
            path: `/api/labs/${parentLookupLabId}/station/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LabStation
     * @throws ApiError
     */
    public static async retrieveLabStation({
        parentLookupLabId,
        id,
    }: {
        parentLookupLabId: number,
        /** A unique integer value identifying this lab station. **/
        id: number,
    }): Promise<LabStation> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/station/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns LabStation
     * @throws ApiError
     */
    public static async updateLabStation({
        parentLookupLabId,
        id,
        requestBody,
    }: {
        parentLookupLabId: number,
        /** A unique integer value identifying this lab station. **/
        id: number,
        requestBody?: LabStation,
    }): Promise<LabStation> {
        const result = await __request({
            method: 'PUT',
            path: `/api/labs/${parentLookupLabId}/station/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LabStation
     * @throws ApiError
     */
    public static async partialUpdateLabStation({
        parentLookupLabId,
        id,
        requestBody,
    }: {
        parentLookupLabId: number,
        /** A unique integer value identifying this lab station. **/
        id: number,
        requestBody?: LabStation,
    }): Promise<LabStation> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/labs/${parentLookupLabId}/station/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyLabStation({
        parentLookupLabId,
        id,
    }: {
        parentLookupLabId: number,
        /** A unique integer value identifying this lab station. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/labs/${parentLookupLabId}/station/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabStainLists({
        parentLookupLabId,
        limit,
        offset,
        stainName,
        stainCategory,
        externalStainExternalLabName,
    }: {
        parentLookupLabId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** stain__name **/
        stainName?: string,
        /** stain__category **/
        stainCategory?: string,
        /** external_stain__external_lab__name **/
        externalStainExternalLabName?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<LabStainList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/stains/`,
            query: {
                'limit': limit,
                'offset': offset,
                'stain__name': stainName,
                'stain__category': stainCategory,
                'external_stain__external_lab__name': externalStainExternalLabName,
            },
        });
        return result.body;
    }

    /**
     * @returns LabStainList
     * @throws ApiError
     */
    public static async retrieveLabStainList({
        parentLookupLabId,
        id,
        stainName,
        stainCategory,
        externalStainExternalLabName,
    }: {
        parentLookupLabId: number,
        /** A unique integer value identifying this lab stain list. **/
        id: number,
        /** stain__name **/
        stainName?: string,
        /** stain__category **/
        stainCategory?: string,
        /** external_stain__external_lab__name **/
        externalStainExternalLabName?: string,
    }): Promise<LabStainList> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/stains/${id}/`,
            query: {
                'stain__name': stainName,
                'stain__category': stainCategory,
                'external_stain__external_lab__name': externalStainExternalLabName,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCassettePrinters({
        parentLookupLabId,
        limit,
        offset,
        ordering,
    }: {
        parentLookupLabId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CassettePrinter>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/cassette-printer/`,
            query: {
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabPanels({
        parentLookupLabId,
        limit,
        offset,
    }: {
        parentLookupLabId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<LabPanel>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/panels/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns FrontLoaderAccessionPrefix
     * @throws ApiError
     */
    public static async listLabFrontLoaderAccessionPrefixes({
        parentLookupLabId,
    }: {
        parentLookupLabId: number,
    }): Promise<Array<FrontLoaderAccessionPrefix>> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/front-load/accession-prefixes/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabFrontLoaderPatients({
        parentLookupLabId,
    }: {
        parentLookupLabId: number,
    }): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/front-load/patients/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabFrontLoaderAccessions({
        parentLookupLabId,
    }: {
        parentLookupLabId: number,
    }): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/front-load/accessions/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabFrontLoaderCases({
        parentLookupLabId,
    }: {
        parentLookupLabId: number,
    }): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/front-load/cases/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabFrontLoaderWorkProcesses({
        parentLookupLabId,
    }: {
        parentLookupLabId: number,
    }): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/front-load/work-processes/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabFrontLoaderWorkProcessTasks({
        parentLookupLabId,
    }: {
        parentLookupLabId: number,
    }): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/front-load/work-process-tasks/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLabFrontLoaderLabStains({
        parentLookupLabId,
    }: {
        parentLookupLabId: number,
    }): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/labs/${parentLookupLabId}/front-load/lab-stains/`,
        });
        return result.body;
    }

    /**
     * @returns Accession
     * @throws ApiError
     */
    public static async retrieveLisAccession({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this accession. **/
        id: number,
    }): Promise<Accession> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/accessions/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns AccessionPATCH
     * @throws ApiError
     */
    public static async updateLisAccession({
        parentLookupLabStationId,
        id,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this accession. **/
        id: number,
        requestBody?: AccessionPATCH,
    }): Promise<AccessionPATCH> {
        const result = await __request({
            method: 'PUT',
            path: `/api/lis/${parentLookupLabStationId}/accessions/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns AccessionPATCH
     * @throws ApiError
     */
    public static async partialUpdateLisAccession({
        parentLookupLabStationId,
        id,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this accession. **/
        id: number,
        requestBody?: AccessionPATCH,
    }): Promise<AccessionPATCH> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/lis/${parentLookupLabStationId}/accessions/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyLisAccession({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this accession. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/lis/${parentLookupLabStationId}/accessions/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCaseWithWorks({
        parentLookupLabStationId,
        limit,
        offset,
        ordering,
        search,
        status,
        clinicId,
        collectedAtStart,
        collectedAtEnd,
        id__in
    }: {
        parentLookupLabStationId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        /** A search term. **/
        search?: string,
        status?: string,
        clinicId?: number,
        collectedAtStart?: string,
        collectedAtEnd?: string,
        id__in?: string
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<LISCaseList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/cases/`,
            query: {
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
                'status': status,
                'patient__clinic_id': clinicId,
                'specimens__collected_date__gte': collectedAtStart,
                'specimens__collected_date__lte': collectedAtEnd,
                'id__in': id__in
            },
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async modmedCaseWithWork({
        parentLookupLabStationId,
        externalOrderId,
        medicalRecordNumber,
        externalPatientId,
        firstName,
        lastName,
    }: {
        parentLookupLabStationId: number,
        /** Order id get from order message from third party, e.g. ModMed **/
        externalOrderId: string,
        medicalRecordNumber?: string,
        externalPatientId?: string,
        firstName?: string,
        lastName?: string,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/cases/modmed/${externalOrderId}/`,
            query: {
                'medical_record_number': medicalRecordNumber,
                'external_patient_id': externalPatientId,
                'first_name': firstName,
                'last_name': lastName,
            },
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async retrieveCaseWithWork({
        parentLookupLabStationId,
        id,
        ordering,
        search,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this Case. **/
        id: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        /** A search term. **/
        search?: string,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/cases/${id}/`,
            query: {
                'ordering': ordering,
                'search': search,
            },
        });
        return result.body;
    }

    /**
     * @returns LISEvent
     * @throws ApiError
     */
    public static async historyCaseWithWork({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<Array<LISEvent>> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/cases/${id}/history/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listCaseWithWorkCursors({
        parentLookupLabStationId,
        cursor,
        ordering,
        search,
    }: {
        parentLookupLabStationId: number,
        /** The pagination cursor value. **/
        cursor?: string,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        /** A search term. **/
        search?: string,
    }): Promise<{
        next?: string | null,
        previous?: string | null,
        results: Array<LISCaseList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/cases-cursor/`,
            query: {
                'cursor': cursor,
                'ordering': ordering,
                'search': search,
            },
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async modmedCaseWithWorkCursor({
        parentLookupLabStationId,
        externalOrderId,
    }: {
        parentLookupLabStationId: number,
        /** Order id get from order message from third party, e.g. ModMed **/
        externalOrderId: string,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/cases-cursor/modmed/${externalOrderId}/`,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async retrieveCaseWithWorkCursor({
        parentLookupLabStationId,
        id,
        ordering,
        search,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this Case. **/
        id: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
        /** A search term. **/
        search?: string,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/cases-cursor/${id}/`,
            query: {
                'ordering': ordering,
                'search': search,
            },
        });
        return result.body;
    }

    /**
     * @returns LISEvent
     * @throws ApiError
     */
    public static async historyCaseWithWorkCursor({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<LISEvent> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/cases-cursor/${id}/history/`,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async caseWithWorkSpecimen({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this specimen. **/
        id: number,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/specimens/${id}/case-with-work/`,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async caseWithWorkBlock({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this block. **/
        id: number,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/blocks/${id}/case-with-work/`,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async caseWithWorkSlide({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this slide. **/
        id: number,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/slides/${id}/case-with-work/`,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async caseWithWorkWorkProcess({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this work process. **/
        id: number,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/works/${id}/case-with-work/`,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async caseWithWorkCaseDocument({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this case document. **/
        id: number,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/documents/${id}/case-with-work/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listShipments({
        parentLookupLabStationId,
        limit,
        offset,
    }: {
        parentLookupLabStationId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Shipment>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/shipments/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns Shipment
     * @throws ApiError
     */
    public static async retrieveShipment({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this shipment. **/
        id: number,
    }): Promise<Shipment> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/shipments/${id}/`,
        });
        return result.body;
    }

    /**
     * simple, temporary LIS based viewset until we figure out how to update the frontloader pattern
     * to handle a scenario where it doesn't get all data back.
     *
     * This returns the explicit list of clinics that the lab_station's lab is allowed to see.
     * @returns any
     * @throws ApiError
     */
    public static async listLisClinics({
        parentLookupLabStationId,
        limit,
        offset,
        name,
        orderingDoctor,
        externalClinicId,
        omni,
        caseSource,
        isArchived,
        status,
    }: {
        parentLookupLabStationId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
        /** ordering_doctor **/
        orderingDoctor?: string,
        /** external_clinic_id **/
        externalClinicId?: number,
        /** omni **/
        omni?: string,
        /** case_source **/
        caseSource?: 'wpl' | 'pw' | 'apl',
        /** is_archived **/
        isArchived?: boolean,
        /** status **/
        status?: 'wpl' | 'pw' | 'apl',
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<Clinic>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/clinics/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
                'ordering_doctor': orderingDoctor,
                'external_clinic_id': externalClinicId,
                'omni': omni,
                'case_source': caseSource,
                'is_archived': isArchived,
                'status': status,
            },
        });
        return result.body;
    }

    /**
     * simple, temporary LIS based viewset until we figure out how to update the frontloader pattern
     * to handle a scenario where it doesn't get all data back.
     *
     * This returns the explicit list of users (dermpath, ordering phyisician) that the lab_station's lab is allowed to see,
     * with the intent to scope down from seeing all users and only providing third party labs access to see what they need to.
     * @returns any
     * @throws ApiError
     */
    public static async listLisUsers({
        parentLookupLabStationId,
        limit,
        offset,
        name,
        username,
        email,
        userprofileNpi,
        userprofileUserType,
        clinicId,
        labId,
        ordering,
    }: {
        parentLookupLabStationId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** name **/
        name?: string,
        /** username **/
        username?: string,
        /** email **/
        email?: string,
        /** userprofile__npi **/
        userprofileNpi?: string,
        /** userprofile__user_type **/
        userprofileUserType?: 'dermpath' | 'physician' | 'lab_admin' | 'clinic_admin' | 'demo' | 'admin' | 'unknown' | 'MRMC2021',
        /** clinic_id **/
        clinicId?: number,
        /** lab_id **/
        labId?: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<UserList>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/users/`,
            query: {
                'limit': limit,
                'offset': offset,
                'name': name,
                'username': username,
                'email': email,
                'userprofile__npi': userprofileNpi,
                'userprofile__user_type': userprofileUserType,
                'clinic_id': clinicId,
                'lab_id': labId,
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listLisInsurancePlans({
        parentLookupLabStationId,
        limit,
        offset,
        payerName,
        payerLocationStreet,
        payerLocationZipcode,
        payerLocationStreet2,
        payerLocationCity,
        payerLocationState,
        searchTerm,
    }: {
        parentLookupLabStationId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
        /** payer_name **/
        payerName?: string,
        /** payer_location__street **/
        payerLocationStreet?: string,
        /** payer_location__zipcode **/
        payerLocationZipcode?: string,
        /** payer_location__street2 **/
        payerLocationStreet2?: string,
        /** payer_location__city **/
        payerLocationCity?: string,
        /** payer_location__state **/
        payerLocationState?: string,
        /** A generic search term to filter insurance plans by multiple fields. **/
        searchTerm?: string,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<InsurancePlan>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/insurance-plans/`,
            query: {
                'limit': limit,
                'offset': offset,
                'payer_name': payerName,
                'payer_location__street': payerLocationStreet,
                'payer_location__zipcode': payerLocationZipcode,
                'payer_location__street2': payerLocationStreet2,
                'payer_location__city': payerLocationCity,
                'payer_location__state': payerLocationState,
                'search_term': searchTerm,
            },
        });
        return result.body;
    }

    /**
     * @returns InsurancePlan
     * @throws ApiError
     */
    public static async retrieveLisInsurancePlan({
        parentLookupLabStationId,
        id,
        payerName,
        payerLocationStreet,
        payerLocationZipcode,
        payerLocationStreet2,
        payerLocationCity,
        payerLocationState,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this insurance plan. **/
        id: number,
        /** payer_name **/
        payerName?: string,
        /** payer_location__street **/
        payerLocationStreet?: string,
        /** payer_location__zipcode **/
        payerLocationZipcode?: string,
        /** payer_location__street2 **/
        payerLocationStreet2?: string,
        /** payer_location__city **/
        payerLocationCity?: string,
        /** payer_location__state **/
        payerLocationState?: string,
    }): Promise<InsurancePlan> {
        const result = await __request({
            method: 'GET',
            path: `/api/lis/${parentLookupLabStationId}/insurance-plans/${id}/`,
            query: {
                'payer_name': payerName,
                'payer_location__street': payerLocationStreet,
                'payer_location__zipcode': payerLocationZipcode,
                'payer_location__street2': payerLocationStreet2,
                'payer_location__city': payerLocationCity,
                'payer_location__state': payerLocationState,
            },
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAdminCaseQaReviews({
        parentLookupCaseId,
        limit,
        offset,
    }: {
        parentLookupCaseId: number,
        /** Number of results to return per page. **/
        limit?: number,
        /** The initial index from which to return the results. **/
        offset?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<CaseQAReview>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/cases/${parentLookupCaseId}/review/`,
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
        return result.body;
    }

    /**
     * @returns CaseQAReview
     * @throws ApiError
     */
    public static async createAdminCaseQaReview({
        parentLookupCaseId,
        requestBody,
    }: {
        parentLookupCaseId: number,
        requestBody?: CaseQAReview,
    }): Promise<CaseQAReview> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/cases/${parentLookupCaseId}/review/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseQAReview
     * @throws ApiError
     */
    public static async retrieveAdminCaseQaReview({
        parentLookupCaseId,
        id,
    }: {
        parentLookupCaseId: number,
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<CaseQAReview> {
        const result = await __request({
            method: 'GET',
            path: `/api/admin/cases/${parentLookupCaseId}/review/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns CaseQAReview
     * @throws ApiError
     */
    public static async updateAdminCaseQaReview({
        parentLookupCaseId,
        id,
        requestBody,
    }: {
        parentLookupCaseId: number,
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: CaseQAReview,
    }): Promise<CaseQAReview> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/cases/${parentLookupCaseId}/review/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseQAReview
     * @throws ApiError
     */
    public static async partialUpdateAdminCaseQaReview({
        parentLookupCaseId,
        id,
        requestBody,
    }: {
        parentLookupCaseId: number,
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: CaseQAReview,
    }): Promise<CaseQAReview> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/cases/${parentLookupCaseId}/review/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAllFeatureFlags(): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/feature-flags/`,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async listAllDisclaimers(): Promise<Array<any>> {
        const result = await __request({
            method: 'GET',
            path: `/api/disclaimers/`,
        });
        return result.body;
    }

    /**
     * @returns SlideAdmin
     * @throws ApiError
     */
    public static async actionsAdminSlide({
        requestBody,
    }: {
        requestBody?: SlideAdmin,
    }): Promise<SlideAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/slides/actions/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * /api/admin/slide/id/delete implemented as a POST action in order to pass
     * a deletion reason in the body of a "delete" request.
     * @returns SlideAdmin
     * @throws ApiError
     */
    public static async destroySlide({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        requestBody?: SlideAdmin,
    }): Promise<SlideAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/slides/${id}/delete/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseAdmin
     * @throws ApiError
     */
    public static async completeDataEntryAdminCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: {
            type: CaseDataEntry.type
        }, // TODO: get this "officially" from OpenAPI,
    }): Promise<CaseAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/cases/${id}/complete_data_entry/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseAdmin
     * @throws ApiError
     */
    public static async destroyCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: CaseAdmin,
    }): Promise<CaseAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/cases/${id}/delete/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseAdmin
     * @throws ApiError
     */
    public static async holdDataEntryAdminCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: {
            type: CaseDataEntry.type
        }, // TODO: get this "officially" from OpenAPI,
    }): Promise<CaseAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/cases/${id}/hold_data_entry/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseAdmin
     * @throws ApiError
     */
    public static async printLabOrdersSlidesAdminCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: CaseAdmin,
    }): Promise<Array<SlideAdmin>> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/cases/${id}/print_lab_orders_slides/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseAdmin
     * @throws ApiError
     */
    public static async reassignAccessionNumberAdminCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: CaseAdmin,
    }): Promise<CaseAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/cases/${id}/reassign_accession_number/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseDocumentAdmin
     * @throws ApiError
     */
    public static async uploadAdminCaseDocument({
        requestBody,
    }: {
        requestBody?: CaseDocumentAdmin,
    }): Promise<CaseDocumentAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/documents/upload/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseDocumentAdmin
     * @throws ApiError
     */
    public static async uploadDocumentAdminCaseDocument({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this case document. **/
        id: number,
        requestBody?: CaseDocumentAdmin,
    }): Promise<CaseDocumentAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/documents/${id}/upload/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Prints lab orders for the given lab
     * @returns AdminLabOrderList
     * @throws ApiError
     */
    public static async printAdminLabOrder({
        requestBody,
    }: {
        requestBody?: AdminLabOrderList,
    }): Promise<AdminLabOrderList> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/lab-orders/print/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * A temporary single-use ViewSet to provide a GET List Admin LabOrders endpoint for the QC Admin.
     * @returns AdminLabOrderList
     * @throws ApiError
     */
    public static async printSlideAdminLabOrder({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this lab order. **/
        id: number,
        requestBody?: AdminLabOrderList,
    }): Promise<SlideAdmin> {
        const result = await __request({
            method: 'POST',
            path: `/api/admin/lab-orders/${id}/print_slide/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Launch a classification task for a single WSI, use {"force": "True"} in the
     * request to force relaunch the classification.
     * Returns 200 if successful or 400 if not.
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async classifySlideClassification({
        requestBody,
    }: {
        requestBody?: SlideClassification,
    }): Promise<SlideClassification> {
        const result = await __request({
            method: 'POST',
            path: `/api/slide-classifications/classify/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Launch a classification task for a group of WSI, use {"force": "True"} in the
     * request to force relaunch the classification.
     * This is useful to avoid multiple API calls when a list of Slides need to be classified
     * all at once.
     * Returns a 200 status with per slide results.
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async classifybatchSlideClassification({
        requestBody,
    }: {
        requestBody?: SlideClassification,
    }): Promise<SlideClassification> {
        const result = await __request({
            method: 'POST',
            path: `/api/slide-classifications/classifybatch/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Launch a classification task for a single WSI, use {"force": "True"} in the
     * request to force relaunch the classification.
     * Returns 200 if successful or 400 if not.
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async classifySlideClassification1({
        requestBody,
    }: {
        requestBody?: SlideClassification,
    }): Promise<SlideClassification> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/slide-classifications/classify/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Launch a classification task for a group of WSI, use {"force": "True"} in the
     * request to force relaunch the classification.
     * This is useful to avoid multiple API calls when a list of Slides need to be classified
     * all at once.
     * Returns a 200 status with per slide results.
     * @returns SlideClassification
     * @throws ApiError
     */
    public static async classifybatchSlideClassification1({
        requestBody,
    }: {
        requestBody?: SlideClassification,
    }): Promise<SlideClassification> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/slide-classifications/classifybatch/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns MRMCAssessment
     * @throws ApiError
     */
    public static async createMrmcAssessment({
        requestBody,
    }: {
        requestBody?: MRMCAssessment,
    }): Promise<MRMCAssessment> {
        const result = await __request({
            method: 'POST',
            path: `/api/mrmc-assessment/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * /api/s3-slides/
     * @returns S3Slide
     * @throws ApiError
     */
    public static async finishUploadS3Slides({
        uploaderHash,
        requestBody,
    }: {
        /** an md5 hash of the uplaoded s3 filename **/
        uploaderHash: string,
        requestBody?: S3Slide,
    }): Promise<S3Slide> {
        const result = await __request({
            method: 'POST',
            path: `/api/s3-slides/${uploaderHash}/finish_upload/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseReportDocumentWritable
     * @throws ApiError
     */
    public static async uploadCaseDocument({
        requestBody,
    }: {
        requestBody?: CaseReportDocumentWritable,
    }): Promise<CaseReportDocumentWritable> {
        const result = await __request({
            method: 'POST',
            path: `/api/documents/upload/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseDiagnosis
     * @throws ApiError
     */
    public static async createCaseDiagnosis({
        requestBody,
    }: {
        requestBody?: CaseDiagnosis,
    }): Promise<CaseDiagnosis> {
        const result = await __request({
            method: 'POST',
            path: `/api/diagnosis/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns SlidePOST
     * @throws ApiError
     */
    public static async createSlideLis({
        requestBody,
    }: {
        requestBody?: SlidePOST,
    }): Promise<SlidePOST> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/slide/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseReportDocumentWritable
     * @throws ApiError
     */
    public static async uploadCaseDocument1({
        requestBody,
    }: {
        requestBody?: CaseReportDocumentWritable,
    }): Promise<CaseReportDocumentWritable> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/documents/upload/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Bulk updates are determined by the bulk_action field.
     * @returns CaseBulkPOST
     * @throws ApiError
     */
    public static async createCaseBulk({
        requestBody,
    }: {
        requestBody?: CaseBulkPOST,
    }): Promise<CaseBulkPOST> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/bulk/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns AdminLabOrderPrintLog
     * @throws ApiError
     */
    public static async printSlidesLabOrderPrintLog({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this lab order print log. **/
        id: number,
        requestBody?: AdminLabOrderPrintLog,
    }): Promise<AdminLabOrderPrintLog> {
        const result = await __request({
            method: 'POST',
            path: `/api/lab-order-print-log/${id}/print_slides/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Nested patient insurance viewset: /api/patients/<patient_id>/insurance/*
     * @returns PatientInsurance
     * @throws ApiError
     */
    public static async createPatientInsurance({
        parentLookupPatientId,
        requestBody,
    }: {
        parentLookupPatientId: number,
        requestBody?: PatientInsurance,
    }): Promise<PatientInsurance> {
        const result = await __request({
            method: 'POST',
            path: `/api/patients/${parentLookupPatientId}/insurance/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async amendOrAddendCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/amend_or_addend/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async amendOrAddendCase1({
        id,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/cases/${id}/amend_or_addend/`,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async cancelScreenCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/cancel_screen/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async completeCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/complete/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async completeTechnicalCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/complete_technical/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async editScreenCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/edit_screen/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async editScreenCase1({
        id,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/cases/${id}/edit_screen/`,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async modifyReportCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/modify_report/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async modifyReportCase1({
        id,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/cases/${id}/modify_report/`,
        });
        return result.body;
    }

    /**
     * used to create a draft report
     * @returns Cases
     * @throws ApiError
     */
    public static async reportCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/report/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async requestScreenCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/request_screen/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Cases
     * @throws ApiError
     */
    public static async undoCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'POST',
            path: `/api/cases/${id}/undo/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Slide
     * @throws ApiError
     */
    public static async barcodeScanSlide({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        requestBody?: Slide,
    }): Promise<Slide> {
        const result = await __request({
            method: 'POST',
            path: `/api/slides/${id}/barcode_scan/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Slide
     * @throws ApiError
     */
    public static async metadataSlide({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this slide. **/
        id: number,
        requestBody?: Slide,
    }): Promise<Slide> {
        const result = await __request({
            method: 'POST',
            path: `/api/slides/${id}/metadata/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns RescanRequest
     * @throws ApiError
     */
    public static async createRescanRequestLog({
        parentLookupSlideId,
        requestBody,
    }: {
        parentLookupSlideId: number,
        requestBody?: RescanRequest,
    }): Promise<RescanRequest> {
        const result = await __request({
            method: 'POST',
            path: `/api/slides/${parentLookupSlideId}/rescans/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * A non-restful-ish POST request to check the status of the provided filenames against the lab.
     * The purpose of the endpoint is to allow the uploader to retrieve which WSIs (parent files for mrxs)
     * are uploaded (completed), which are missing files or not started.
     * @returns Lab
     * @throws ApiError
     */
    public static async slideStatusLab({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this lab. **/
        id: number,
        requestBody?: Lab,
    }): Promise<Lab> {
        const result = await __request({
            method: 'POST',
            path: `/api/labs/${id}/slide_status/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CassettePrinter
     * @throws ApiError
     */
    public static async printCassettePrinter({
        parentLookupLabId,
        id,
        requestBody,
    }: {
        parentLookupLabId: number,
        /** A unique integer value identifying this cassette printer. **/
        id: number,
        requestBody?: CassettePrinter,
    }): Promise<CassettePrinter> {
        const result = await __request({
            method: 'POST',
            path: `/api/labs/${parentLookupLabId}/cassette-printer/${id}/print/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns AccessionPOST
     * @throws ApiError
     */
    public static async createLisAccession({
        parentLookupLabStationId,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        requestBody?: AccessionPOST,
    }): Promise<AccessionPOST> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/accessions/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns AccessionWithCreatedCase
     * @throws ApiError
     */
    public static async printLisAccession({
        parentLookupLabStationId,
        id,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this accession. **/
        id: number,
        requestBody?: AccessionWithCreatedCase,
    }): Promise<AccessionWithCreatedCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/accessions/${id}/print/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async printSpecimen({
        parentLookupLabStationId,
        id,
        blockCount,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this specimen. **/
        id: number,
        blockCount: number,
        requestBody?: LISPrintRequest,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/specimens/${id}/print/${blockCount}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async printPieceCountSpecimen({
        parentLookupLabStationId,
        id,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this specimen. **/
        id: number,
        requestBody?: LISPrintRequest,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/specimens/${id}/print/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async scanSpecimen({
        parentLookupLabStationId,
        id,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this specimen. **/
        id: number,
        requestBody?: LISScanRequest,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/specimens/${id}/scan/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async createBlock({
        parentLookupLabStationId,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        requestBody?: BlockPOST,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/blocks/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async printCassettesBlock({
        parentLookupLabStationId,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        requestBody?: any,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/blocks/print_cassettes/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async printBlock({
        parentLookupLabStationId,
        id,
        slideCount,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this block. **/
        id: number,
        slideCount: number,
        requestBody?: LISPrintRequest,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/blocks/${id}/print/${slideCount}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async printUncutSlidesBlock({
        parentLookupLabStationId,
        id,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this block. **/
        id: number,
        requestBody?: LISPrintMultipleRequest,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/blocks/${id}/print_uncut_slides/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async scanBlock({
        parentLookupLabStationId,
        id,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this block. **/
        id: number,
        requestBody?: LISScanRequest,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/blocks/${id}/scan/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async printAdditionalSlide({
        parentLookupLabStationId,
        id,
        slideCount,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this slide. **/
        id: number,
        slideCount: number,
        requestBody?: LISPrintRequest,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/slides/${id}/print_additional/${slideCount}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LISCase
     * @throws ApiError
     */
    public static async scanSlide({
        parentLookupLabStationId,
        id,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this slide. **/
        id: number,
        requestBody?: LISScanRequest,
    }): Promise<LISCase> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/slides/${id}/scan/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns ShipmentWritable
     * @throws ApiError
     */
    public static async printShipment({
        parentLookupLabStationId,
        requestBody,
    }: {
        parentLookupLabStationId: number,
        requestBody?: ShipmentWritable,
    }): Promise<ShipmentWritable> {
        const result = await __request({
            method: 'POST',
            path: `/api/lis/${parentLookupLabStationId}/shipments/print/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Calls Django Auth PasswordResetForm save method.
     * Accepts the following POST parameters: email
     * Returns the success/fail message.
     * @returns PasswordReset
     * @throws ApiError
     */
    public static async destroyPasswordReset({
        requestBody,
    }: {
        requestBody?: PasswordReset,
    }): Promise<PasswordReset> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/password/reset/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Password reset e-mail link is confirmed, therefore
     * this resets the user's password.
     * Accepts the following POST parameters: token, uid,
     * new_password1, new_password2
     * Returns the success/fail message.
     * @returns PasswordResetConfirm
     * @throws ApiError
     */
    public static async destroyPasswordResetConfirm({
        requestBody,
    }: {
        requestBody?: PasswordResetConfirm,
    }): Promise<PasswordResetConfirm> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/password/reset/confirm/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Calls Django Auth SetPasswordForm save method.
     * Accepts the following POST parameters: new_password1, new_password2
     * Returns the success/fail message.
     * @returns PasswordChange
     * @throws ApiError
     */
    public static async destroyPasswordChange({
        requestBody,
    }: {
        requestBody?: PasswordChange,
    }): Promise<PasswordChange> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/password/change/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns PWTokenObtainPair
     * @throws ApiError
     */
    public static async destroyPwTokenObtainPair({
        requestBody,
    }: {
        requestBody?: PWTokenObtainPair,
    }): Promise<PWTokenObtainPair> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/token/obtain/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns QRAuthObtainPair
     * @throws ApiError
     */
    public static async destroyQrAuthObtainPair({
        requestBody,
    }: {
        requestBody?: QRAuthObtainPair,
    }): Promise<QRAuthObtainPair> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/token/qr-obtain/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns PWTokenRefresh
     * @throws ApiError
     */
    public static async destroyPwTokenRefresh({
        requestBody,
    }: {
        requestBody?: PWTokenRefresh,
    }): Promise<PWTokenRefresh> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/token/refresh/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns PWTokenRefreshPair
     * @throws ApiError
     */
    public static async destroyPwTokenRefreshPair({
        requestBody,
    }: {
        requestBody?: PWTokenRefreshPair,
    }): Promise<PWTokenRefreshPair> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/token/refresh-pair/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Takes a token and indicates if it is valid.  This view provides no
     * information about a token's fitness for a particular use.
     * @returns TokenVerify
     * @throws ApiError
     */
    public static async destroyTokenVerify({
        requestBody,
    }: {
        requestBody?: TokenVerify,
    }): Promise<TokenVerify> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/token/verify/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns MFASend
     * @throws ApiError
     */
    public static async destroyMfaSend({
        requestBody,
    }: {
        requestBody?: MFASend,
    }): Promise<MFASend> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/mfa/send/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns MFALoginSend
     * @throws ApiError
     */
    public static async destroyMfaLoginSend({
        requestBody,
    }: {
        requestBody?: MFALoginSend,
    }): Promise<MFALoginSend> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/mfa/login/send/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns MFAVerify
     * @throws ApiError
     */
    public static async destroyMfaVerify({
        requestBody,
    }: {
        requestBody?: MFAVerify,
    }): Promise<MFAVerify> {
        const result = await __request({
            method: 'POST',
            path: `/api/auth/mfa/verify/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Receives the outbound fax event from MFax.
     *
     * See apps/integration/mfax/sample/webhook_payload.py for full contents.
     *
     * We save the full webhook payload as a part of the `detail` JSONField.
     * @returns any
     * @throws ApiError
     */
    public static async destroyoutboundFaxWebhook({
        requestBody,
    }: {
        requestBody?: any,
    }): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/api/autofax/outbound/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Location
     * @throws ApiError
     */
    public static async updateLocation({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this location. **/
        id: number,
        requestBody?: Location,
    }): Promise<Location> {
        const result = await __request({
            method: 'PUT',
            path: `/api/admin/location/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns Location
     * @throws ApiError
     */
    public static async partialUpdateLocation({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this location. **/
        id: number,
        requestBody?: Location,
    }): Promise<Location> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/location/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseDiagnosis
     * @throws ApiError
     */
    public static async updateCaseDiagnosis({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this case diagnosis. **/
        id: number,
        requestBody?: CaseDiagnosis,
    }): Promise<CaseDiagnosis> {
        const result = await __request({
            method: 'PUT',
            path: `/api/diagnosis/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyCaseDiagnosis({
        id,
    }: {
        /** A unique integer value identifying this case diagnosis. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/diagnosis/${id}/`,
        });
        return result.body;
    }

    /**
     * @returns CaseDiagnosisAddonWritable
     * @throws ApiError
     */
    public static async updateCaseDiagnosisAddon({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this case diagnosis addon. **/
        id: number,
        requestBody?: CaseDiagnosisAddonWritable,
    }): Promise<CaseDiagnosisAddonWritable> {
        const result = await __request({
            method: 'PUT',
            path: `/api/addon/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns CaseDiagnosisAddonWritable
     * @throws ApiError
     */
    public static async partialUpdateCaseDiagnosisAddon({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this case diagnosis addon. **/
        id: number,
        requestBody?: CaseDiagnosisAddonWritable,
    }): Promise<CaseDiagnosisAddonWritable> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/addon/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Nested patient insurance viewset: /api/patients/<patient_id>/insurance/*
     * @returns PatientInsurance
     * @throws ApiError
     */
    public static async updatePatientInsurance({
        parentLookupPatientId,
        id,
        requestBody,
    }: {
        parentLookupPatientId: number,
        /** A unique integer value identifying this patient insurance. **/
        id: number,
        requestBody?: PatientInsurance,
    }): Promise<PatientInsurance> {
        const result = await __request({
            method: 'PUT',
            path: `/api/patients/${parentLookupPatientId}/insurance/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Nested patient insurance viewset: /api/patients/<patient_id>/insurance/*
     * @returns PatientInsurance
     * @throws ApiError
     */
    public static async partialUpdatePatientInsurance({
        parentLookupPatientId,
        id,
        requestBody,
    }: {
        parentLookupPatientId: number,
        /** A unique integer value identifying this patient insurance. **/
        id: number,
        requestBody?: PatientInsurance,
    }): Promise<PatientInsurance> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/patients/${parentLookupPatientId}/insurance/${id}/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * API endpoint that allows users to be viewed or edited.
     * @returns User
     * @throws ApiError
     */
    public static async unsetMfaMethodUser({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this user. **/
        id: number,
        requestBody?: User,
    }): Promise<User> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/users/${id}/unset_mfa_method/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns LabOrder
     * @throws ApiError
     */
    public static async completeLabOrder({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this lab order. **/
        id: number,
        requestBody?: LabOrder,
    }): Promise<LabOrder> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/stain-order/${id}/complete/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Cases in the ORDERED status will move to the WORKING status when the specimen is received by a lab and the
     * accession begins.  Here we need to complete the accession, create a workprocess with tasks,
     * and change the case status to WORKING.
     * @returns Cases
     * @throws ApiError
     */
    public static async accessionCase({
        id,
        requestBody,
    }: {
        /** A unique integer value identifying this Case. **/
        id: number,
        requestBody?: Cases,
    }): Promise<Cases> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/cases/${id}/accession/`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * This custom admin viewset should only be used to change the clinic and/or
     * the external_order_id and/or the external_ederm_order_id from the QC admin.
     * Endpoint expects the following JSON object:
     * @returns any
     * @throws ApiError
     */
    public static async partialUpdateIntegrationAdminViewSet({
        requestBody,
    }: {
        requestBody?: any,
    }): Promise<any> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/admin/clinic-integration`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Delete the flag and cancel associated order if cancellation window remains open.
     * @returns void
     * @throws ApiError
     */
    public static async destroySlideFlag({
        parentLookupSlideId,
        id,
        ordering,
    }: {
        parentLookupSlideId: number,
        /** A unique integer value identifying this slide flag. **/
        id: number,
        /** Which field to use when ordering the results. **/
        ordering?: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/slides/${parentLookupSlideId}/flags/${id}/`,
            query: {
                'ordering': ordering,
            },
        });
        return result.body;
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static async destroyBlock({
        parentLookupLabStationId,
        id,
    }: {
        parentLookupLabStationId: number,
        /** A unique integer value identifying this block. **/
        id: number,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/lis/${parentLookupLabStationId}/blocks/${id}/`,
        });
        return result.body;
    }

}